import { jsx as h, jsxs as O, Fragment as x1 } from "react/jsx-runtime";
import { FontAwesomeIcon as ge } from "@fortawesome/react-fontawesome";
import * as Kt from "@radix-ui/react-accordion";
import { ThemeColors as d, WebColors as t1, WebGradients as ia, LightThemeColors as h0, ThemeColorTokenNames as Vi, LightThemeGradients as f0, ThemeGradientsTokenNames as ji, DarkThemeColors as m0, DarkThemeGradients as T0 } from "@sparelabs/colors";
import m, { keyframes as zt, css as pe, createGlobalStyle as p0 } from "styled-components";
import { useToggle as E0, useAsync as wn, useList as Xi, useCounter as Qi, useInterval as g0, useMount as A0 } from "react-use";
import { Translator as _0, BrowserLanguageHelper as Ft } from "@sparelabs/translate";
import C0 from "@tippyjs/react";
import Yt, { forwardRef as Wt, useState as V, useMemo as y1, useEffect as Ne, Component as oa, useRef as at, Children as N0, createElement as Wr } from "react";
import { followCursor as sa } from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "tippy.js/themes/translucent.css";
import "tippy.js/animations/shift-away.css";
import { library as G1 } from "@fortawesome/fontawesome-svg-core";
import { faFileExclamation as S0, faCloudUploadAlt as I0, faFilePdf as y0, faFileImage as O0, faFileCsv as v0, faFileExcel as x0, faFileAlt as R0, faExternalLink as b0, faUpload as aa, faExclamationCircle as L0, faTrashAlt as la } from "@fortawesome/pro-solid-svg-icons";
import * as P0 from "@radix-ui/react-visually-hidden";
import { Root as Bt, VisuallyHidden as Pr } from "@radix-ui/react-visually-hidden";
import { round as M0, uniqueId as ut, isEqual as ca, debounce as ua, padStart as D0, range as k0, isString as lt, uniq as qi, toString as Zi } from "lodash";
import { Button as w0, Input as H0, InputGroup as da, DropdownToggle as $0, DropdownMenu as F0, DropdownItem as B0, InputGroupButtonDropdown as U0, ModalBody as G0, ModalFooter as K0 } from "reactstrap";
import { Link as ha, NavLink as fa } from "react-router-dom";
import { Root as z0, Indicator as Y0 } from "@radix-ui/react-progress";
import { AddressFormatter as W0, AddressFieldName as se } from "@sparelabs/address";
import { buildPoint as V0 } from "@sparelabs/geography";
import { dateFormat as Ye, HOUR as Ut, TimezoneHelper as Nn, DAY as Vt, DateUtils as j0, Time as Lt } from "@sparelabs/time";
import O1 from "moment-timezone";
import { SingleDatePicker as ma, DateRangePicker as X0 } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { isNumber as n1, isObject as vn } from "@sparelabs/core";
import Q0 from "react-canvas-draw";
import * as q0 from "@radix-ui/react-announce";
import { Announce as Z0 } from "@radix-ui/react-announce";
import { ACCEPTED_FILE_EXTENSION_TYPES as J0 } from "@sparelabs/http-client-utils";
import { useDropzone as Ta } from "react-dropzone";
import e9 from "easymde";
import "easymde/dist/easymde.min.css";
import t9 from "react-simplemde-editor";
import { MarkdownVariableDefinitionType as Ji, MarkdownConverter as n9 } from "@sparelabs/markdown-utils";
import { Root as r9 } from "@radix-ui/react-portal";
import { Content as i9, Root as o9, Trigger as pa } from "@radix-ui/react-popover";
import { LocalizationPhoneHelper as s9 } from "@sparelabs/localization";
import a9 from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { CurrencyHelper as eo } from "@sparelabs/currency";
import l9 from "lodash/debounce";
import Ea from "react-markdown";
import { Content as Vr, Overlay as c9, Title as u9, Close as d9, Root as jr, Portal as ga, DialogTitle as Aa } from "@radix-ui/react-dialog";
import { ToggleGroup as h9, ToggleGroupItem as f9 } from "@radix-ui/react-toggle-group";
import { createPortal as m9 } from "react-dom";
import * as _a from "@radix-ui/react-switch";
import { Separator as T9 } from "@radix-ui/react-separator";
const Ca = m.span`
  font-size: 15px;
  padding-right: 10px;
  display: inline-flex;
  align-items: center;
`, f7 = Kt.Root, p9 = zt`
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
`, E9 = zt`
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
`, m7 = m(Kt.Content)`
  overflow: hidden;

  &[data-state='open'] {
    animation-name: ${p9};
    animation-duration: 300ms;
    animation-timing-function: ease-out;
  }
  &[data-state='closed'] {
    animation-name: ${E9};
    animation-duration: 300ms;
    animation-timing-function: ease-out;
  }
`, T7 = Kt.Item, g9 = Kt.Header, A9 = m(Kt.Trigger)`
  width: 100%;
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  text-align: left;
  background-color: ${d.backgroundPrimary};
  font-family: inherit;

  &:hover,
  &:active,
  &:focus {
    outline: none;
  }
`, p7 = ({
  title: t,
  className: e
}) => /* @__PURE__ */ h(g9, { className: e, children: /* @__PURE__ */ O(_9, { children: [
  typeof t == "string" ? /* @__PURE__ */ h(Ca, { children: t }) : t,
  /* @__PURE__ */ h(C9, { icon: "chevron-down", "aria-hidden": !0, className: "accordion-chevron" })
] }) }), _9 = m(A9)`
  border-bottom: 1px solid ${d.borderPrimary};
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  background-color: ${d.backgroundPrimary};

  &[data-state='open'] > .accordion-chevron {
    transform: rotate(180deg);
  }
`, C9 = m(ge)`
  width: 15px;
  height: 15px;
  align-self: center;
  transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
`, N9 = m.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  margin-right: 20px;
`, E7 = ({ title: t, buttons: e }) => /* @__PURE__ */ O(N9, { children: [
  /* @__PURE__ */ h(Ca, { children: t }),
  e
] }), S9 = zt`
  to {
    transform: rotate(360deg);
  }
`, K1 = m.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-radius: 50%;
  border-color: ${d.contentSecondary} ${d.contentSecondary} ${d.contentSecondary}
    transparent;
  animation: ${S9} 0.8s linear infinite;
`;
K1.displayName = "LoaderSpinner";
const I9 = m(K1)`
  height: 14px;
  width: 14px;
`, g7 = m.div`
  > * {
    animation: fly ${({ speed: t = 100 }) => t}s linear infinite;
    top: 0;
    left: 0;
    transform: translateX(-120%) translateY(-120%) rotateZ(0);
    position: fixed;
    animation-delay: 1s;
    z-index: 999999;
  }

  @keyframes fly {
    98.001%,
    0% {
      display: block;
      transform: translateX(-200%) translateY(100vh) rotateZ(0deg);
    }

    15% {
      transform: translateX(100vw) translateY(-100%) rotateZ(180deg);
    }

    15.001%,
    18% {
      transform: translateX(100vw) translateY(-30%) rotateZ(0deg);
    }

    40% {
      transform: translateX(-200%) translateY(3vh) rotateZ(-180deg);
    }

    40.001%,
    43% {
      transform: translateX(-200%) translateY(-100%) rotateZ(-180deg);
    }

    65% {
      transform: translateX(100vw) translateY(50vh) rotateZ(0deg);
    }

    65.001%,
    68% {
      transform: translateX(20vw) translateY(-200%) rotateZ(180deg);
    }

    95% {
      transform: translateX(10vw) translateY(100vh) rotateZ(0deg);
    }
  }
`, j = "8px", We = d.boxShadow, ct = d.boxShadowStrong, y9 = d.boxShadowStronger, dt = "36px", O9 = 150, Na = 500, Sa = 350, v9 = `${O9}px`, ce = `${Na}px`, Ia = "rgba(0, 0, 0, 0.5)", v1 = 230, ht = 12, x9 = Na + v1 + ht, R9 = 1050, b9 = 1051, A7 = 2e3, L9 = 1052, xn = "1.5px", Hn = pe`
  outline-width: ${xn} !important;
  outline-style: solid !important;
  outline-color: ${d.interactivePrimary} !important;
`, jt = pe`
  &:focus-visible {
    outline-color: ${d.focusOutline} !important;
    outline-style: solid !important;
    outline-width: ${xn} !important;
  }
`, $n = {
  xs: "320px",
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1200px"
}, Xr = (t) => t != null && t !== "" ? { "data-choice-item": t.toString() } : {}, P9 = pe`
  box-shadow: ${We};
  border-radius: ${j};
  background-color: ${d.backgroundPrimary};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`, M9 = m.div`
  ${P9};
`, _7 = m.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`, D9 = M9, ya = "18px", k9 = m.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`, w9 = m.div`
  width: ${ya};
`, H9 = m.div`
  padding-left: ${ya};
  overflow: hidden;
  ${({ isExpanded: t }) => t ? "" : "height: 0px;"}
`, $9 = ({ isExpanded: t }) => /* @__PURE__ */ h(ge, { icon: "caret-right", rotation: t ? 90 : void 0 }), C7 = ({ parent: t, children: e, renderExpanded: n, onExpanded: r }) => {
  const [i, s] = E0(n ?? !1);
  return /* @__PURE__ */ O(x1, { children: [
    /* @__PURE__ */ O(k9, { onClick: () => {
      r == null || r(), s();
    }, children: [
      /* @__PURE__ */ h(w9, { children: /* @__PURE__ */ h($9, { isExpanded: i }) }),
      t
    ] }),
    /* @__PURE__ */ h(H9, { isExpanded: i, children: e })
  ] });
}, F9 = {
  inputs: {
    choice: {
      selectOptionPrompt: "Please select an option",
      yes: "Yes",
      no: "No"
    },
    file: {
      sizeMb: "{{size}} MB"
    },
    multipleFile: {
      inProgress: "Uploading: {{count}}",
      completed: "Completed: {{count}}",
      failed: "Failed: {{count}}"
    },
    dropzone: {
      selectFile: "Select file",
      dragDropFile: "or drag and drop file here",
      viewButton: "View Uploaded File",
      chooseFileButton: "Choose File",
      chooseFilesButton: "Choose Files",
      deleteButton: "Remove Uploaded File",
      fileNameLabel: "Uploaded File:",
      fileSizeLabel: "Uploaded File Size:",
      noFileSelected: "No file selected:",
      invalidFileTypeMultipleFormats: "File must be either {{fileTypes}}, please try again.",
      invalidFileTypeSingle: "File must be a {{fileTypes}}, please try again.",
      invalidFileSize: "File size is too large, must be under {{fileSize}} MB",
      tooManyFiles: "Only one file may be uploaded at a time",
      genericError: "Something went wrong please try again or contact support",
      error: "Error:",
      description: "File must be smaller than {{maxFileSizeMB}}MB and one of the following: {{fileTypes}}."
    },
    photo: {
      prompt: "Upload an image"
    },
    shared: {
      uploading: "Uploading...",
      uploadFailed: "Upload failed"
    },
    drawing: {
      clear: "Clear"
    },
    dateTime: {
      dst: {
        springForward: {
          hint: "This time is unavailable due to the Daylight Saving Time change. Please select another time."
        },
        fallBack: {
          hint: "Due to the Daylight Saving Time change, this time occurs twice. Please specify which one should be used.",
          beforeTimeSetBack: "Before clocks are set back",
          afterTimeSetBack: "After clocks are set back"
        }
      },
      accessibleTimeHint: "{{time}} in 24 hour format",
      selectDateLabel: "Select Date",
      selectTimeLabel: "Select Time"
    },
    markdown: {
      variables: "Variables",
      variablesHint: "Insert custom variables"
    }
  },
  foundations: {
    restrictedToRootAdmins: "This functionality is currently restricted to Spare Super Admins."
  },
  date: {
    dateInputMessage: "Enter a date or use the arrow keys to change the date",
    dateRangePicker: {
      startDateMessage: "Enter a start date or use the arrow keys to change the start date",
      endDateMessage: "Enter an end date or use the arrow keys to change the end date"
    }
  },
  modal: {
    close: "Close",
    confirm: "Confirm",
    cancel: "Cancel"
  },
  common: {
    none: "None",
    required: "(Required)"
  },
  errors: {
    loadingData: "Error loading data from server. Please refresh the page."
  },
  showMoreContainer: {
    showMore: "Show more",
    showLess: "Show less"
  }
}, B9 = {}, U9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B9
}, Symbol.toStringTag, { value: "Module" })), Oa = {
  choice: {
    selectOptionPrompt: "Bitte wähle Wert aus",
    yes: "Ja",
    no: "Nein"
  }
}, G9 = {
  inputs: Oa
}, K9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G9,
  inputs: Oa
}, Symbol.toStringTag, { value: "Module" })), z9 = {}, Y9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z9
}, Symbol.toStringTag, { value: "Module" })), va = {
  choice: {
    selectOptionPrompt: "veuillez sélectionner une option",
    yes: "Oui",
    no: "Non"
  },
  file: {
    sizeMb: "{{taille}} Mo"
  },
  multipleFile: {
    inProgress: "Téléchargement : {{count}}",
    completed: "Terminé : {{count}}",
    failed: "Échec : {{count}}"
  },
  dropzone: {
    selectFile: "Choisir le dossier",
    dragDropFile: "ou faites glisser et déposez le fichier ici",
    viewButton: "Afficher le fichier téléchargé",
    chooseFileButton: "Choisir le fichier",
    chooseFilesButton: "Choisir des fichiers",
    deleteButton: "Supprimer le fichier téléchargé",
    fileNameLabel: "Fichier téléchargé :",
    fileSizeLabel: "Taille du fichier téléchargé :",
    noFileSelected: "Aucun fichier sélectionné:",
    invalidFileTypeMultipleFormats: "Le fichier doit être soit {{fileTypes}}, veuillez réessayer.",
    invalidFileTypeSingle: "Le fichier doit être un {{fileTypes}}, veuillez réessayer.",
    invalidFileSize: "La taille du fichier est trop volumineuse et doit être inférieure à {{fileSize}} Mo.",
    tooManyFiles: "Un seul fichier peut être téléchargé à la fois",
    genericError: "Quelque chose s'est mal passé, veuillez réessayer ou contacter l'assistance",
    error: "Erreur:",
    description: "Le fichier doit être inférieur à {{maxFileSizeMB}} Mo et être l'un des éléments suivants : {{fileTypes}}."
  },
  photo: {
    prompt: "Télécharger une image"
  },
  shared: {
    uploading: "Téléchargement...",
    uploadFailed: "Échec du téléchargement"
  },
  drawing: {
    clear: "Clair"
  },
  dateTime: {
    dst: {
      springForward: {
        hint: "Cette heure n'est pas disponible en raison du changement d'heure d'été. Veuillez sélectionner une autre heure."
      },
      fallBack: {
        hint: "En raison du changement d’heure d’été, cette heure apparaît deux fois. Veuillez préciser lequel doit être utilisé.",
        beforeTimeSetBack: "Avant que les horloges ne reculent",
        afterTimeSetBack: "Après le recul des horloges"
      }
    },
    accessibleTimeHint: "{{time}} au format 24 heures",
    selectDateLabel: "Sélectionner une date",
    selectTimeLabel: "Sélectionnez l'heure"
  },
  markdown: {
    variables: "Variables",
    variablesHint: "Insérer des variables personnalisées"
  }
}, xa = {
  restrictedToRootAdmins: "Cette fonctionnalité est actuellement limitée aux Super Administrateurs Spare."
}, Ra = {
  dateInputMessage: "Entrez une date ou utilisez les touches fléchées pour modifier la date",
  dateRangePicker: {
    startDateMessage: "Entrez une date de début ou utilisez les touches fléchées pour modifier la date de début",
    endDateMessage: "Saisissez une date de fin ou utilisez les touches fléchées pour modifier la date de fin"
  }
}, ba = {
  close: "Fermer"
}, La = {
  none: "Aucun",
  required: "(requis)"
}, Pa = {
  loadingData: "Erreur lors du chargement des données depuis le serveur. Veuillez actualiser la page."
}, W9 = {
  inputs: va,
  foundations: xa,
  date: Ra,
  modal: ba,
  common: La,
  errors: Pa
}, V9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  common: La,
  date: Ra,
  default: W9,
  errors: Pa,
  foundations: xa,
  inputs: va,
  modal: ba
}, Symbol.toStringTag, { value: "Module" })), j9 = {}, X9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j9
}, Symbol.toStringTag, { value: "Module" })), Ma = {
  choice: {
    selectOptionPrompt: "項目の選択",
    yes: "はい",
    no: "いいえ"
  },
  file: {
    sizeMb: "{{size}} MB"
  },
  multipleFile: {
    inProgress: "Uploading: {{count}}",
    completed: "Completed: {{count}}",
    failed: "Failed: {{count}}"
  },
  dropzone: {
    selectFile: "ファイルを選択",
    dragDropFile: "又はドラックアンドドロップでファイルをこちらにアップロード",
    viewButton: "アップロードするファイルを閲覧する",
    chooseFileButton: "ファイルを選択",
    chooseFilesButton: "ファイルを選択",
    deleteButton: "アップロードするファイルを取り除く",
    fileNameLabel: "Uploaded File:",
    fileSizeLabel: "Uploaded File Size:",
    noFileSelected: "No file selected:",
    invalidFileTypeMultipleFormats: "File must be either {{fileTypes}}, please try again.",
    invalidFileTypeSingle: "File must be a {{fileTypes}}, please try again.",
    invalidFileSize: "File size is too large, must be under {{fileSize}} MB",
    tooManyFiles: "一度に一つまでのファイルしかアップロードできません",
    genericError: "エラーが発生しました、1~2分ほど時間を置いて再度お試しください",
    error: "Error:",
    description: "ファイルサイズは {{maxFileSizeMB}}MB 以内且つ、  {{fileTypes}}の形式でアップロードしてください。"
  },
  photo: {
    prompt: "イメージをアップロードする"
  },
  shared: {
    uploading: "アップロード中",
    uploadFailed: "アップロードに失敗しました"
  },
  drawing: {
    clear: "Clear"
  },
  dateTime: {
    dst: {
      springForward: {
        hint: "This time is unavailable due to the Daylight Saving Time change. Please select another time."
      },
      fallBack: {
        hint: "Due to the Daylight Saving Time change, this time occurs twice. Please specify which one should be used.",
        beforeTimeSetBack: "Before clocks are set back",
        afterTimeSetBack: "After clocks are set back"
      }
    },
    accessibleTimeHint: "{{time}} in 24 hour format",
    selectDateLabel: "Select Date",
    selectTimeLabel: "Select Time"
  },
  markdown: {
    variables: "Variables",
    variablesHint: "Insert custom variables"
  }
}, Da = {
  restrictedToRootAdmins: "This functionality is currently restricted to Spare Super Admins."
}, ka = {
  dateInputMessage: "Enter a date or use the arrow keys to change the date",
  dateRangePicker: {
    startDateMessage: "Enter a start date or use the arrow keys to change the start date",
    endDateMessage: "Enter an end date or use the arrow keys to change the end date"
  }
}, wa = {
  close: "閉じる"
}, Ha = {
  none: "なし",
  required: "(必須)"
}, $a = {
  loadingData: "Error loading data from server. Please refresh the page."
}, Fa = {
  showMore: "Show more",
  showLess: "Show less"
}, Ba = {
  showMore: "Show more",
  showLess: "Show less"
}, Q9 = {
  inputs: Ma,
  foundations: Da,
  date: ka,
  modal: wa,
  common: Ha,
  errors: $a,
  cutoffContainer: Fa,
  showMoreContainer: Ba
}, q9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  common: Ha,
  cutoffContainer: Fa,
  date: ka,
  default: Q9,
  errors: $a,
  foundations: Da,
  inputs: Ma,
  modal: wa,
  showMoreContainer: Ba
}, Symbol.toStringTag, { value: "Module" })), Z9 = {}, J9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z9
}, Symbol.toStringTag, { value: "Module" })), e5 = {}, t5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e5
}, Symbol.toStringTag, { value: "Module" })), n5 = {}, r5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n5
}, Symbol.toStringTag, { value: "Module" })), i5 = {}, o5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: i5
}, Symbol.toStringTag, { value: "Module" })), s5 = {}, a5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s5
}, Symbol.toStringTag, { value: "Module" })), l5 = U9, c5 = K9, u5 = Y9, d5 = V9, h5 = X9, f5 = q9, m5 = J9, T5 = t5, p5 = r5, E5 = o5, g5 = a5, A5 = {
  ja: f5,
  nb: m5,
  de: c5,
  es: u5,
  ca: l5,
  is: h5,
  sv: E5,
  fr: d5,
  nn: T5,
  pt: p5,
  zh: g5
}, _5 = new _0(
  F9,
  A5,
  Ft.getCurrentLanguageCode(),
  (t) => {
    t && console.log(t);
  }
), H = _5.st, Ua = Wt(({ children: t, tooltipTheme: e, ...n }, r) => /* @__PURE__ */ h(C0, { ref: r, theme: e, ...n, plugins: [sa], children: t })), C5 = m(Ua)`
  border-radius: ${({ $borderRadius: t }) => t};
  overflow: hidden;

  .tippy-content {
    display: grid;
    place-content: center;
    padding: ${({ $noPadding: t }) => t ? "0px" : "6.4px 12.8px"};
    line-height: 22.8px;
    font-weight: 400px;
    font-size: 0.95rem;
  }
`, Ga = Wt((t, e) => /* @__PURE__ */ h(C5, { ref: e, $borderRadius: t.$borderRadius ?? "8px", ...t, plugins: [sa] }));
Ga.displayName = "Tooltip";
Ua.displayName = "Tooltip";
const ft = ({
  icon: t = "info-circle",
  color: e,
  className: n,
  placement: r = "top",
  tooltipTheme: i = "light",
  iconSize: s,
  ...a
}) => /* @__PURE__ */ h(
  Ga,
  {
    className: n,
    placement: r,
    animation: "shift-away",
    arrow: !0,
    tooltipTheme: i,
    ...a,
    children: /* @__PURE__ */ h("span", { children: /* @__PURE__ */ h(
      ge,
      {
        icon: t,
        size: s ?? "xs",
        color: e ?? d.contentSecondary,
        className: "info-tooltip-icon"
      }
    ) })
  }
), to = `${v1}px`, N5 = "270px", Ka = "20px", S5 = m.div`
  display: flex;
  flex-direction: ${({ stacked: t }) => t ? "column" : "row"};
  flex-wrap: wrap;
  font-size: 15px;
  gap: ${({ stacked: t }) => t ? "4px" : "0px "};
`, I5 = m.label`
  margin-bottom: 0px;
  font-weight: 400;
  line-height: ${Ka};
  color: ${d.contentSecondary};
  min-width: ${to};
  max-width: ${({ stacked: t }) => t ? ce : to};
  margin-right: ${ht}px;
  display: flex;
  height: fit-content;
`, za = m.div`
  flex-grow: 1;
  overflow-wrap: break-word;
  min-width: ${N5};
  flex-basis: ${({ stacked: t }) => `${t ? "0px" : `${Sa}px`}`};
`, Ya = m.div`
  line-height: ${Ka};
  max-width: ${ce};
`, Qr = m.div`
  color: ${d.contentTertiary};
  font-size: 13px;
  font-weight: 400;
  white-space: pre-wrap;
  margin-top: 5px;
  max-width: ${ce};
`, Fn = m.div`
  color: ${d.negativePrimary};
  font-size: 14px;
  margin-top: 5px;
  max-width: ${ce};
`, y5 = m.div`
  background-color: ${d.borderPrimary};
  height: 1px;
  flex: 1;
  margin-left: 12px;
  margin-top: 8px;
`, Mr = m.span`
  color: ${d.contentTertiary};
`, O5 = m.span`
  margin-left: 8px;
`, N7 = ({
  label: t,
  children: e,
  hint: n,
  tooltip: r,
  error: i,
  className: s,
  horizontalBar: a,
  labelStyle: c,
  valueStyle: l,
  stacked: u
}) => /* @__PURE__ */ O(S5, { className: s, stacked: u, children: [
  /* @__PURE__ */ O(I5, { style: c, stacked: u, children: [
    /* @__PURE__ */ h("div", { children: t }),
    r && /* @__PURE__ */ h(O5, { children: /* @__PURE__ */ h(ft, { content: r }) }),
    a && /* @__PURE__ */ h(y5, {})
  ] }),
  /* @__PURE__ */ O(za, { style: l, stacked: u, children: [
    /* @__PURE__ */ h(Ya, { style: l, children: e }),
    n && /* @__PURE__ */ h(Qr, { children: n }),
    i && /* @__PURE__ */ h(Fn, { role: "alert", children: i })
  ] })
] }), v5 = m.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 15px;
  flex-direction: column;
`, x5 = m.label`
  max-width: initial;
  margin-bottom: 4px;
  gap: 3px;
  margin-bottom: 0px;
  font-weight: 400;
  line-height: 20px;
  color: ${d.contentSecondary};
  min-width: ${v1}px;
  margin-right: ${ht}px;
  display: flex;
  height: fit-content;
`, R5 = m(Qr)`
  max-width: initial;
`, b5 = m(Fn)`
  max-width: initial;
`, L5 = m.span`
  margin-left: 6px;
`, P5 = m(za)`
  flex-basis: unset;
`, S7 = ({
  label: t,
  children: e,
  hint: n,
  error: r,
  tooltip: i,
  className: s,
  isRequired: a,
  id: c
}) => /* @__PURE__ */ O(v5, { className: s, children: [
  /* @__PURE__ */ O(x5, { htmlFor: c, children: [
    t,
    " ",
    a && /* @__PURE__ */ h("span", { children: H.common.required() }),
    i && /* @__PURE__ */ h(L5, { children: /* @__PURE__ */ h(ft, { content: i }) })
  ] }),
  e && /* @__PURE__ */ O(P5, { children: [
    /* @__PURE__ */ h(Ya, { children: e }),
    n && /* @__PURE__ */ h(R5, { children: n }),
    r && /* @__PURE__ */ h(b5, { children: r })
  ] })
] }), M5 = m.div`
  background-color: ${d.backgroundPrimary};
  border-radius: ${j};
  border: solid 1px ${d.borderPrimary};
  display: flex;
  justify-content: center;
`, I7 = ({ value: t, tempUrl: e, onError: n }) => {
  const [r, i] = V(null), [s, a] = V(!0), [c, l] = V(!1);
  return wn(async () => {
    if (a(!1), D5(t))
      i(t.url);
    else if (k5(t))
      try {
        const u = await e(t.id);
        i(u.tempUrl);
      } catch (u) {
        l(!0), n(u);
      }
    else
      a(!0);
  }, [t]), s ? /* @__PURE__ */ h(Mr, { children: H.common.none() }) : c ? /* @__PURE__ */ h(Mr, { children: H.errors.loadingData() }) : /* @__PURE__ */ h(M5, { children: r ? /* @__PURE__ */ h("img", { src: r }) : /* @__PURE__ */ h(K1, {}) });
}, D5 = (t) => t ? "url" in t : !1, k5 = (t) => t ? "id" in t : !1, w5 = m(ge)`
  width: 24px !important;
  height: 24px;
`, H5 = m.div`
  display: grid;
  place-content: center;
  width: 24px;
  height: 24px;
`, qr = ({ icon: t, className: e }) => /* @__PURE__ */ h(H5, { className: e, children: /* @__PURE__ */ h(w5, { icon: t }) }), Zr = m.div`
  border-radius: ${j};
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  max-width: ${ce};
`, Jr = m.div`
  flex: 1;
  min-width: 0;
  padding-right: 8px;
`, Wa = m.div`
  color: ${d.contentPrimary};
  font-size: 15px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`, $5 = m(qr)`
  color: ${d.contentSecondary};
`, F5 = m.div`
  color: ${d.warningPrimary};
  font-size: 15px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`, B5 = m.div`
  color: ${d.contentSecondary};
  font-size: 13px;
  line-height: 16px;
`;
G1.add(S0);
const U5 = m(Zr)`
  display: flex;
  gap: 8px;
  color: ${d.warningPrimary};
`, G5 = m.div`
  font-size: 13px;
  line-height: 16px;
`, K5 = ({ name: t }) => /* @__PURE__ */ O(U5, { children: [
  /* @__PURE__ */ h(qr, { icon: "file-exclamation" }),
  /* @__PURE__ */ O(Jr, { children: [
    /* @__PURE__ */ h(F5, { children: t }),
    /* @__PURE__ */ h(G5, { children: H.inputs.shared.uploadFailed() })
  ] })
] });
G1.add(I0);
const z5 = m(qr)`
  color: ${d.contentSecondary};
`, Va = () => /* @__PURE__ */ O(Zr, { children: [
  /* @__PURE__ */ h(z5, { icon: "cloud-upload-alt" }),
  /* @__PURE__ */ h(Jr, { children: /* @__PURE__ */ h(Wa, { children: H.inputs.shared.uploading() }) })
] }), U1 = m(({ marginRight: t, marginTop: e, ...n }) => /* @__PURE__ */ h(ge, { ...n }))`
  width: 15px;
  height: 15px;
  margin-right: ${({ marginRight: t }) => t};
  margin-top: ${({ marginTop: t }) => t};
`, ze = {
  backgroundColor: d.backgroundPrimary,
  textColor: d.contentPrimary
}, ja = {
  textColor: d.contentInvertedPrimary,
  backgroundColor: d.interactivePrimary
}, y7 = {
  textColor: d.contentInvertedPrimary,
  backgroundColor: d.brandPrimary
}, Y5 = {
  backgroundColor: d.backgroundSecondary,
  textColor: d.contentSecondary
}, O7 = {
  textColor: d.contentInvertedPrimary,
  backgroundColor: d.interactivePrimary
}, v7 = {
  textColor: d.contentInvertedPrimary,
  backgroundColor: d.negativePrimary
}, x7 = {
  backgroundColor: d.interactivePrimaryDisabled,
  textColor: d.contentInvertedPrimary
}, Xa = pe`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  width: ${({ width: t }) => t || "auto"};
  padding: 8px 12px;
  border: 0px;

  background-color: ${({ $buttonTheme: t }) => (t ?? ze).backgroundColor};
  color: ${({ $buttonTheme: t }) => (t ?? ze).textColor};
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: box-shadow 150ms ease;
  ${jt}
  &:hover,
  &:active,
  &:focus {
    cursor: pointer;
    color: ${({ $buttonTheme: t }) => (t ?? ze).textColor} !important;
    background-color: ${({ $buttonTheme: t }) => (t ?? ze).backgroundColor} !important;
    border: 0px !important;
  }

  /* Duplication of styles is needed here to override Reactstrap styling to get our desired disabled state
    there is a spike ticket for removing Reactstrap which would prevent us needing to do this
    https://sparelabs.atlassian.net/browse/FIN-1093
  */
  &:disabled {
    box-shadow: none !important;
    color: ${({ $buttonTheme: t }) => (t ?? ze).textColor} !important;
    background-color: ${({ $buttonTheme: t }) => (t ?? ze).backgroundColor} !important;
    border: 0px !important;
  }
  // removing ReactStrap's default styling
  &:active:focus {
    box-shadow: none !important;
  }
`, W5 = m(w0)`
  ${Xa}
`, Xt = ({
  onClick: t,
  validateActionText: e,
  icon: n,
  iconColor: r,
  children: i,
  buttonTheme: s = ze,
  disabled: a,
  loading: c,
  ...l
}) => /* @__PURE__ */ O(
  W5,
  {
    ...l,
    $buttonTheme: s,
    disabled: a || c,
    onClick: () => {
      (!e || confirm(e)) && t();
    },
    children: [
      n && /* @__PURE__ */ h(U1, { icon: n, color: r ?? s.textColor }),
      i
    ]
  }
), ei = ({
  children: t,
  icon: e,
  validateActionText: n,
  disabled: r,
  onClick: i,
  ...s
}) => {
  const [a, c] = V(!1);
  return /* @__PURE__ */ O(
    Xt,
    {
      ...s,
      ...a ? { buttonTheme: Y5 } : { icon: e, validateActionText: n },
      disabled: r || a,
      onClick: () => {
        a || (c(!0), (async () => {
          try {
            await i();
          } catch {
          }
          c(!1);
        })());
      },
      children: [
        a && /* @__PURE__ */ h(I9, {}),
        t
      ]
    }
  );
}, Qa = pe`
  text-align: left;

  &:hover {
    background-color: ${d.backgroundPrimaryHover};
  }
`, R7 = m(Xt)`
  ${Qa}
`, b7 = m(ei)`
  ${Qa}
`, ti = pe`
  border-radius: ${j};
  box-shadow: ${We};
  &:hover,
  &:active,
  &:focus {
    box-shadow: ${ct};
  }
`, Bn = m(Xt)`
  ${ti}
`, Rn = m(ei)`
  ${ti}
`, L7 = m.div`
  width: 10px;
`, qa = pe`
  ${Xa}
  ${ti}
  display: inline-flex;
  text-align: center;
  text-decoration: none !important;
`, V5 = m(ha)`
  ${qa}
`, j5 = m.a`
  ${qa}
`, X5 = ({
  isExternal: t,
  to: e,
  icon: n,
  iconColor: r,
  children: i,
  buttonTheme: s = ze,
  ...a
}) => t ? /* @__PURE__ */ O(j5, { ...a, href: e, $buttonTheme: s, children: [
  n && /* @__PURE__ */ h(U1, { icon: n, color: r ?? s.textColor }),
  i
] }) : /* @__PURE__ */ O(V5, { ...a, to: e, $buttonTheme: s, children: [
  n && /* @__PURE__ */ h(U1, { icon: n, color: r ?? s.textColor }),
  i
] }), Q5 = m.a`
  color: ${t1.interactivePrimary} !important;
  cursor: pointer;
  &:hover {
    color: ${t1.interactivePrimaryHover} !important;
    text-decoration: underline !important;
  }
  &:active {
    color: ${t1.interactivePrimaryActive} !important;
  }
`, P7 = (t) => /* @__PURE__ */ h(Q5, { tabIndex: 0, onKeyDown: (n) => {
  (n.key === "Enter" || n.key === "Space") && (n.preventDefault(), n.currentTarget.click());
}, ...t }), q5 = (t) => t === "application/pdf" ? "file-pdf" : t.startsWith("image") ? "file-image" : t === "text/csv" ? "file-csv" : (
  // cspell: disable
  t === "application/vnd.ms-excel" || t === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? "file-excel" : "file-alt"
), Z5 = (t) => (t == null ? void 0 : t.url) !== void 0, Za = (t) => (t == null ? void 0 : t.id) !== void 0, ni = (t) => t instanceof File, J5 = async (t, e) => {
  if (!t || !Za(t) || !e)
    return;
  const n = await e(t.id);
  if (n.tempUrl)
    window.open(n.tempUrl, "_blank");
  else
    throw new Error("Server returned a blank url");
};
G1.add(y0, O0, v0, x0, R0, b0, aa);
const eu = 1e6, tu = ({ value: t, tempUrl: e, onError: n }) => {
  const [r, i] = V(!1), s = !!t && !ni(t) && !Z5(t) && Za(t), a = async () => {
    i(!0), await J5(t, e).catch(n), i(!1);
  };
  return s ? /* @__PURE__ */ O(Rn, { onClick: a, loading: r, tabIndex: 0, children: [
    !r && /* @__PURE__ */ h(ge, { icon: "external-link" }),
    /* @__PURE__ */ h(Bt, { children: H.inputs.dropzone.viewButton() })
  ] }) : /* @__PURE__ */ h(
    X5,
    {
      isExternal: !0,
      to: t.url,
      icon: "external-link",
      target: "_blank",
      tabIndex: 0,
      children: /* @__PURE__ */ h(Bt, { children: H.inputs.dropzone.viewButton() })
    }
  );
}, Ja = ({
  id: t,
  value: e,
  onRemove: n,
  disableRemove: r,
  tempUrl: i,
  onError: s,
  hideButtons: a
}) => {
  if (!e)
    return /* @__PURE__ */ h(Mr, { children: H.common.none() });
  const c = ni(e) ? e.type : e.format;
  return /* @__PURE__ */ O(Zr, { id: t, children: [
    /* @__PURE__ */ h($5, { icon: q5(c) }),
    /* @__PURE__ */ O(Jr, { children: [
      /* @__PURE__ */ O(Wa, { children: [
        /* @__PURE__ */ h(Bt, { children: H.inputs.dropzone.fileNameLabel() }),
        " ",
        e.name
      ] }),
      /* @__PURE__ */ O(B5, { children: [
        /* @__PURE__ */ h(Bt, { children: H.inputs.dropzone.fileSizeLabel() }),
        H.inputs.file.sizeMb({ size: M0(e.size / eu, 2) })
      ] })
    ] }),
    /* @__PURE__ */ h(
      nu,
      {
        value: e,
        onRemove: n,
        onError: s,
        disableRemove: r,
        tempUrl: i,
        hideButtons: a
      }
    )
  ] });
}, nu = ({
  value: t,
  onRemove: e,
  onError: n,
  tempUrl: r,
  hideButtons: i,
  disableRemove: s
}) => i ? null : /* @__PURE__ */ O(x1, { children: [
  !ni(t) && /* @__PURE__ */ h(tu, { value: t, tempUrl: r, onError: n }),
  e && /* @__PURE__ */ h(Bn, { disabled: s, icon: "trash-alt", onClick: e, children: /* @__PURE__ */ h(Bt, { children: H.inputs.dropzone.deleteButton() }) })
] }), M7 = m.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`, ru = m(z0)`
  width: 100%;
  height: 6px;
  background-color: ${d.backgroundTertiary};
  border-radius: 999px;

  /* Fix overflow clipping in Safari */
  /* https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0 */
  transform: translateZ(0);
`, iu = m(Y0)`
  background-color: ${d.interactivePrimary};
  border-radius: 999px;
  height: 100%;
  transition: width 500ms;
`, D7 = ({ value: t, className: e }) => /* @__PURE__ */ h(ru, { className: e, value: t, children: /* @__PURE__ */ h(iu, { style: { width: t + "%" } }) }), k7 = m.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`, no = (t, e, n) => wn(async () => {
  try {
    return await e();
  } catch (r) {
    throw t(r), r;
  }
}, n), ro = `${v1}px`, ou = m.div`
  display: flex;
  flex-direction: ${({ $stacked: t }) => t ? "column" : "row"};
  flex-wrap: wrap;
  font-size: 15px;
  row-gap: 4px;
`, el = m.label`
  margin-bottom: 0px;
  font-weight: 400;
  line-height: 20px;
  color: ${d.contentSecondary};
  min-width: ${ro};
  max-width: ${ro};
  margin-right: ${ht}px;
  padding-top: ${({ $stacked: t }) => t ? "0px" : "8px"};
`, su = m.div`
  flex-grow: 1;
  overflow-wrap: break-word;
  min-width: 270px;
  flex-basis: ${({ $stacked: t }) => `${t ? "0px" : `${Sa}px`}`};
`, au = m.div`
  color: ${d.contentTertiary};
  font-size: 13px;
  font-weight: 400;
  white-space: pre-wrap;
  margin-top: 5px;
  max-width: ${ce};
  line-height: 20px;
`, lu = m.div`
  color: ${d.negativePrimary};
  font-size: 14px;
  margin-top: 5px;
  max-width: ${ce};
`, cu = ({
  label: t,
  children: e,
  hint: n,
  tooltip: r,
  error: i,
  className: s,
  renderInput: a,
  containerStyle: c,
  labelStyle: l,
  valueStyle: u,
  isRequired: g,
  stacked: A,
  customLabel: S
}) => {
  const C = y1(() => `form-label-${ut()}`, []), y = y1(() => a({ id: C }), [a, C]);
  if (!y.props.id)
    throw new Error("Input must have an id!");
  return /* @__PURE__ */ O(ou, { className: s, style: c, $stacked: A, children: [
    S || /* @__PURE__ */ O(el, { htmlFor: C, style: l, $stacked: A, children: [
      t,
      " ",
      g && /* @__PURE__ */ h("span", { children: H.common.required() }),
      r && /* @__PURE__ */ h(ft, { content: r })
    ] }),
    /* @__PURE__ */ O(su, { style: u, $stacked: A, children: [
      y,
      e,
      n && /* @__PURE__ */ h(au, { children: n }),
      i && /* @__PURE__ */ h(lu, { role: "alert", children: i })
    ] })
  ] });
}, w7 = Yt.memo(cu), uu = (
  // cspell: disable-next-line
  "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='14px' height='12px' viewBox='0 0 14 12' enable-background='new 0 0 14 12' xml:space='preserve'%3E%3Cpolygon points='3.862,7.931 0,4.069 7.725,4.069 '/%3E%3C/svg%3E"
), du = `
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("${uu}") !important;
  background-position: right 50%;
  background-repeat: no-repeat;
  padding: 0.375rem 1.5rem 0.375rem 0.75rem;
`, hu = pe`
  outline: ${(t) => t.invalid ? `1px solid ${d.negativePrimary}` : "none"} !important;
  border: ${(t) => t.invalid ? "none" : `1px solid ${d.borderPrimary}`} !important;
  background-color: ${d.backgroundPrimary};
  color: ${d.contentPrimary};
  border-radius: ${j} !important;
  padding: 0.5em;
  max-width: ${ce};
  flex-grow: 1;
  font-size: 15px;
  &::placeholder {
    color: ${d.contentTertiary};
  }
  &:focus:invalid {
    padding: 0.5em;
  }
  [disabled] {
    color: ${d.contentTertiary};
  }
  &:focus {
    box-shadow: none !important;
    ${(t) => t.invalid ? "" : Hn}
  }
  // this is to remove bootstrap's icons on the input
  ${(t) => t.type === "select" ? du : "background-image: none !important;"}
`, He = m(H0)`
  ${hu}
`, cr = (t) => t === void 0 || t === "" ? "" : JSON.stringify(t), fu = (t, e, n) => t || n || (e ? H.inputs.choice.selectOptionPrompt() : H.common.none()), bn = ({
  value: t,
  choices: e,
  selectOptionPrompt: n,
  onChange: r,
  invalid: i,
  id: s,
  disabled: a,
  required: c = !0,
  placeholder: l,
  ...u
}) => {
  const g = (A) => {
    const S = e.find((C) => cr(C.value) === A);
    r(S == null ? void 0 : S.value);
  };
  return /* @__PURE__ */ O(
    He,
    {
      ...u,
      type: "select",
      onChange: (A) => g(A.target.value),
      value: cr(t),
      invalid: i,
      id: s,
      disabled: a,
      required: c,
      children: [
        /* @__PURE__ */ h("option", { disabled: c, value: "", children: fu(n, c, l) }),
        e.map((A) => {
          const S = cr(A.value), C = Xr(A.label);
          return /* @__PURE__ */ h("option", { value: S, disabled: A.isDisabled, ...C, children: A.label }, S);
        })
      ]
    }
  );
}, mu = m.div`
  max-width: ${ce};
  display: flex;
  justify-content: space-between;
`, Tu = m.div`
  font-size: 13px;
  font-weight: 500;
  color: ${d.contentSecondary};
`, pu = m.div`
  font-size: 13px;
  color: ${d.contentTertiary};
  font-weight: 400;
  line-height: ${({ compact: t }) => t ? void 0 : "20px"};
  max-width: 450px;
`, tl = ({ value: t, maxLengthOption: e, isCompact: n }) => {
  const [r, i] = V(t.length || 0);
  return Ne(() => {
    i(t.length || 0);
  }, [t]), /* @__PURE__ */ O(mu, { children: [
    /* @__PURE__ */ h(pu, { compact: n, children: e.hint }),
    /* @__PURE__ */ O(Tu, { children: [
      r,
      "/",
      e.maxLength
    ] })
  ] });
}, Eu = m.div`
  margin-top: 7px;
`, gu = ({
  value: t,
  label: e,
  onChange: n,
  placeholder: r,
  invalid: i,
  type: s = "text",
  disabled: a,
  id: c,
  autoFocus: l,
  maxLengthOption: u,
  innerRef: g,
  ...A
}) => /* @__PURE__ */ O(x1, { children: [
  /* @__PURE__ */ h(
    He,
    {
      ...A,
      innerRef: g,
      "aria-label": e,
      id: c,
      type: s,
      value: t ?? "",
      invalid: i,
      onChange: (S) => n(S.target.value),
      placeholder: r,
      disabled: a,
      autoFocus: l
    }
  ),
  u && /* @__PURE__ */ h(Eu, { children: /* @__PURE__ */ h(tl, { value: t ?? "", maxLengthOption: u, isCompact: !0 }) })
] }), Au = m.div`
  flex-basis: 100%;
  min-width: 0px;
  margin-bottom: 16px;
`, _u = m.div`
  display: flex;
  flex-direction: row;
  max-width: 500px;

  > :not(:last-child) {
    margin-right: 5px;
  }
`, Cu = m.div`
  padding-bottom: 4px;
`, ur = { version: 1, country: "US" }, Nu = ({ value: t, onChange: e, apiUrl: n, onError: r, id: i = ut(), invalid: s }) => {
  const a = new W0(n, Ft.getCurrentLanguageCode()), { value: c } = no(r, async () => a.getCountries()), l = c ? c.map(($) => ({ value: $.code, label: $.name })) : [], [u, g] = V([]), [A, S] = V(), [C, y] = V([]), [N, v] = V(t ?? ur), X = {
    [se.FirstName]: ($) => v({ ...N, firstName: $ }),
    [se.LastName]: ($) => v({ ...N, lastName: $ }),
    [se.Country]: ($) => v({ ...N, country: $ }),
    [se.City]: ($) => v({ ...N, city: $ }),
    [se.PostalCode]: ($) => v({ ...N, zip: $ }),
    [se.Zone]: ($) => v({ ...N, province: $ }),
    [se.Address1]: ($) => v({ ...N, address1: $ }),
    [se.Address2]: ($) => v({ ...N, address2: $ })
  }, Z = {
    [se.FirstName]: N.firstName ?? "",
    [se.LastName]: N.lastName ?? "",
    [se.Country]: N.country ?? "",
    [se.City]: N.city ?? "",
    [se.PostalCode]: N.zip ?? "",
    [se.Zone]: N.province ?? "",
    [se.Address1]: N.address1 ?? "",
    [se.Address2]: N.address2 ?? ""
  };
  Ne(() => {
    e({ ...N });
  }, [N]), Ne(() => {
    ca(t, N) || v(t ?? ur);
  }, [t]), no(r, async () => {
    const $ = N.country ?? ur.country, te = await a.getCountry($);
    g(await a.getOrderedFields($)), y(te.zones.map((Se) => ({ value: Se.code, label: Se.name }))), S(a.createLabelTable(te)), te.zones.map((Se) => Se.code).includes(N.province ?? "") || v({ ...N, province: "" });
  }, [N.country]);
  const ae = ($, te) => /* @__PURE__ */ O(Au, { children: [
    /* @__PURE__ */ h(el, { htmlFor: i, children: te[$] }),
    $ === se.Country ? /* @__PURE__ */ h(
      bn,
      {
        choices: l,
        value: Z[$],
        onChange: X[$],
        id: i,
        invalid: s
      }
    ) : $ === se.Zone ? /* @__PURE__ */ h(
      bn,
      {
        choices: C,
        value: Z[$],
        onChange: X[$],
        id: i,
        invalid: s
      }
    ) : /* @__PURE__ */ h(gu, { label: $, value: Z[$], onChange: X[$], id: i, invalid: s })
  ] }, $);
  return /* @__PURE__ */ h(Cu, { children: A && u.map(($) => /* @__PURE__ */ h(_u, { children: $.filter((te) => te !== se.Phone && te !== se.Company).map((te) => ae(te, A)) }, $[0])) });
}, io = {
  // North America
  "UNITED STATES": "US",
  USA: "US",
  "UNITED STATES OF AMERICA": "US",
  CANADA: "CA",
  MEXICO: "MX",
  BAHAMAS: "BS",
  CUBA: "CU",
  "DOMINICAN REPUBLIC": "DO",
  HAITI: "HT",
  JAMAICA: "JM",
  "PUERTO RICO": "PR",
  "TRINIDAD AND TOBAGO": "TT",
  // South America
  ARGENTINA: "AR",
  BOLIVIA: "BO",
  BRAZIL: "BR",
  BRASIL: "BR",
  // Portuguese
  CHILE: "CL",
  COLOMBIA: "CO",
  ECUADOR: "EC",
  GUYANA: "GY",
  PARAGUAY: "PY",
  PERU: "PE",
  SURINAME: "SR",
  URUGUAY: "UY",
  VENEZUELA: "VE",
  // Europe
  "UNITED KINGDOM": "GB",
  UK: "GB",
  "GREAT BRITAIN": "GB",
  ENGLAND: "GB",
  SCOTLAND: "GB",
  WALES: "GB",
  "NORTHERN IRELAND": "GB",
  IRELAND: "IE",
  FRANCE: "FR",
  GERMANY: "DE",
  DEUTSCHLAND: "DE",
  // German
  SPAIN: "ES",
  ESPAÑA: "ES",
  // Spanish
  ITALY: "IT",
  ITALIA: "IT",
  // Italian
  PORTUGAL: "PT",
  NETHERLANDS: "NL",
  HOLLAND: "NL",
  BELGIUM: "BE",
  SWITZERLAND: "CH",
  AUSTRIA: "AT",
  POLAND: "PL",
  CZECHIA: "CZ",
  "CZECH REPUBLIC": "CZ",
  SLOVAKIA: "SK",
  HUNGARY: "HU",
  ROMANIA: "RO",
  BULGARIA: "BG",
  GREECE: "GR",
  SWEDEN: "SE",
  NORWAY: "NO",
  DENMARK: "DK",
  FINLAND: "FI",
  ICELAND: "IS",
  RUSSIA: "RU",
  UKRAINE: "UA",
  BELARUS: "BY",
  LITHUANIA: "LT",
  LATVIA: "LV",
  ESTONIA: "EE",
  MALTA: "MT",
  CYPRUS: "CY",
  LUXEMBOURG: "LU",
  MONACO: "MC",
  CROATIA: "HR",
  SLOVENIA: "SI",
  SERBIA: "RS",
  MONTENEGRO: "ME",
  ALBANIA: "AL",
  MACEDONIA: "MK",
  "BOSNIA AND HERZEGOVINA": "BA",
  // Asia
  CHINA: "CN",
  JAPAN: "JP",
  日本: "JP",
  // Japanese
  "SOUTH KOREA": "KR",
  KOREA: "KR",
  INDIA: "IN",
  INDONESIA: "ID",
  THAILAND: "TH",
  VIETNAM: "VN",
  PHILIPPINES: "PH",
  MALAYSIA: "MY",
  SINGAPORE: "SG",
  TAIWAN: "TW",
  "HONG KONG": "HK",
  PAKISTAN: "PK",
  BANGLADESH: "BD",
  "SRI LANKA": "LK",
  NEPAL: "NP",
  AFGHANISTAN: "AF",
  IRAN: "IR",
  IRAQ: "IQ",
  "SAUDI ARABIA": "SA",
  "UNITED ARAB EMIRATES": "AE",
  UAE: "AE",
  ISRAEL: "IL",
  JORDAN: "JO",
  LEBANON: "LB",
  SYRIA: "SY",
  TURKEY: "TR",
  KUWAIT: "KW",
  QATAR: "QA",
  BAHRAIN: "BH",
  OMAN: "OM",
  YEMEN: "YE",
  // Africa
  EGYPT: "EG",
  "SOUTH AFRICA": "ZA",
  NIGERIA: "NG",
  KENYA: "KE",
  ETHIOPIA: "ET",
  GHANA: "GH",
  MOROCCO: "MA",
  ALGERIA: "DZ",
  TUNISIA: "TN",
  LIBYA: "LY",
  SUDAN: "SD",
  TANZANIA: "TZ",
  UGANDA: "UG",
  ZIMBABWE: "ZW",
  ZAMBIA: "ZM",
  MOZAMBIQUE: "MZ",
  MADAGASCAR: "MG",
  CAMEROON: "CM",
  "IVORY COAST": "CI",
  "CÔTE D'IVOIRE": "CI",
  SENEGAL: "SN",
  ANGOLA: "AO",
  NAMIBIA: "NA",
  BOTSWANA: "BW",
  // Oceania
  AUSTRALIA: "AU",
  "NEW ZEALAND": "NZ",
  FIJI: "FJ",
  "PAPUA NEW GUINEA": "PG",
  SAMOA: "WS",
  TONGA: "TO",
  VANUATU: "VU",
  "SOLOMON ISLANDS": "SB",
  "NEW CALEDONIA": "NC",
  "FRENCH POLYNESIA": "PF",
  GUAM: "GU",
  PALAU: "PW",
  "MARSHALL ISLANDS": "MH",
  MICRONESIA: "FM",
  KIRIBATI: "KI",
  TUVALU: "TV",
  NAURU: "NR"
}, Su = [
  "ON",
  "QC",
  "NS",
  "NB",
  "MB",
  "BC",
  "PE",
  "SK",
  "AB",
  "NL",
  "NT",
  "YT",
  "NU",
  "Ontario",
  "Quebec",
  "Nova Scotia",
  "New Brunswick",
  "Manitoba",
  "British Columbia",
  "Prince Edward Island",
  "Saskatchewan",
  "Alberta",
  "Newfoundland",
  "Northwest Territories",
  "Yukon",
  "Nunavut"
], Iu = {
  ALABAMA: "AL",
  ALASKA: "AK",
  "AMERICAN SAMOA": "AS",
  ARIZONA: "AZ",
  ARKANSAS: "AR",
  CALIFORNIA: "CA",
  COLORADO: "CO",
  CONNECTICUT: "CT",
  DELAWARE: "DE",
  "DISTRICT OF COLUMBIA": "DC",
  FLORIDA: "FL",
  GEORGIA: "GA",
  GUAM: "GU",
  HAWAII: "HI",
  IDAHO: "ID",
  ILLINOIS: "IL",
  INDIANA: "IN",
  IOWA: "IA",
  KANSAS: "KS",
  KENTUCKY: "KY",
  LOUISIANA: "LA",
  MAINE: "ME",
  "MARSHALL ISLANDS": "MH",
  MARYLAND: "MD",
  MASSACHUSETTS: "MA",
  MICHIGAN: "MI",
  MINNESOTA: "MN",
  MISSISSIPPI: "MS",
  MISSOURI: "MO",
  MONTANA: "MT",
  NEBRASKA: "NE",
  NEVADA: "NV",
  "NEW HAMPSHIRE": "NH",
  "NEW JERSEY": "NJ",
  "NEW MEXICO": "NM",
  "NEW YORK": "NY",
  "NORTH CAROLINA": "NC",
  "NORTH DAKOTA": "ND",
  "NORTHERN MARIANA ISLANDS": "MP",
  OHIO: "OH",
  OKLAHOMA: "OK",
  OREGON: "OR",
  PALAU: "PW",
  PENNSYLVANIA: "PA",
  "PUERTO RICO": "PR",
  "RHODE ISLAND": "RI",
  "SOUTH CAROLINA": "SC",
  "SOUTH DAKOTA": "SD",
  TENNESSEE: "TN",
  TEXAS: "TX",
  UTAH: "UT",
  VERMONT: "VT",
  VIRGINIA: "VA",
  "VIRGIN ISLANDS": "VI",
  WASHINGTON: "WA",
  "WEST VIRGINIA": "WV",
  WISCONSIN: "WI",
  WYOMING: "WY"
}, yu = {
  // Include both codes and full names for comprehensive mapping
  ON: "ON",
  QC: "QC",
  NS: "NS",
  NB: "NB",
  MB: "MB",
  BC: "BC",
  PE: "PE",
  SK: "SK",
  AB: "AB",
  NL: "NL",
  NT: "NT",
  YT: "YT",
  NU: "NU",
  ONTARIO: "ON",
  QUEBEC: "QC",
  "NOVA SCOTIA": "NS",
  "NEW BRUNSWICK": "NB",
  MANITOBA: "MB",
  "BRITISH COLUMBIA": "BC",
  "PRINCE EDWARD ISLAND": "PE",
  SASKATCHEWAN: "SK",
  ALBERTA: "AB",
  NEWFOUNDLAND: "NL",
  "NORTHWEST TERRITORIES": "NT",
  YUKON: "YT",
  NUNAVUT: "NU"
}, oo = (t) => {
  if (!t)
    return "";
  const e = t.trim(), n = e.toUpperCase();
  if (n.length === 2)
    return n;
  const r = Iu[n];
  if (r)
    return r;
  const i = yu[n];
  return i || e;
}, so = (t) => {
  const e = t.toUpperCase().trim();
  if (e.length === 2)
    return e;
  const n = io[e];
  if (n)
    return n;
  for (const [r, i] of Object.entries(io))
    if (e.includes(r) || r.includes(e))
      return i;
  return e.includes("UNITED") && e.includes("STATES") ? "US" : e.includes("UNITED") && e.includes("KINGDOM") ? "GB" : e.includes("CZECH") ? "CZ" : e.includes("KOREA") && !e.includes("NORTH") ? "KR" : t.substring(0, 2).toUpperCase();
}, Ou = (t) => /\b[A-Z]\d[A-Z]\s?\d[A-Z]\d\b/i.test(t), vu = (t, e = "US") => t.includes("USA") || t.includes("United States") ? "US" : t.includes("Canada") ? "CA" : t.includes("UK") || t.includes("United Kingdom") ? "GB" : Su.some((n) => t.includes(n)) || Ou(t) ? "CA" : e, xu = m.div`
  position: relative;
  width: 100%;
`, Ru = m.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid ${({ invalid: t }) => t ? "#e53e3e" : "#e2e8f0"};
  border-radius: 8px;
  font-size: 16px;
  background-color: white;

  &:focus {
    outline: none;
    border-color: ${({ invalid: t }) => t ? "#e53e3e" : "#3182ce"};
    box-shadow: 0 0 0 3px ${({ invalid: t }) => t ? "#e53e3e20" : "#3182ce20"};
  }

  &::placeholder {
    color: #a0aec0;
  }
`, bu = m.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  margin: 0;
  padding: 0;
  list-style: none;
`, Lu = m.li`
  padding: 12px 16px;
  cursor: pointer;
  background-color: ${({ selected: t }) => t ? "#f7fafc" : "white"};
  border-bottom: 1px solid #f7fafc;

  &:hover {
    background-color: #f7fafc;
  }

  &:last-child {
    border-bottom: none;
  }
`, Pu = m.div`
  font-weight: 500;
  color: #2d3748;
`, Mu = m.div`
  font-size: 14px;
  color: #718096;
  margin-top: 2px;
`, Du = (t, e) => e && t ? e.includes(t) ? e : `${t} - ${e}` : e || t || "";
class ku extends oa {
  constructor(e) {
    super(e), this.search = async (n) => {
      if (n.length < 2) {
        this.setState({ suggestions: [], showSuggestions: !1 });
        return;
      }
      this.setState({ isLoading: !0 });
      try {
        const i = (await this.props.placesApi.autocompleteSuggestions.get({
          search: n,
          language: Ft.getCurrentLanguageCode()
        })).map((s) => ({
          label: s.label,
          value: {
            type: "Places",
            details: {
              placeId: s.placeId,
              sublabel: s.subLabel
            }
          }
        }));
        this.setState({
          suggestions: i,
          showSuggestions: i.length > 0,
          selectedIndex: -1
        });
      } catch (r) {
        this.props.onError(r), this.setState({ suggestions: [], showSuggestions: !1 });
      } finally {
        this.setState({ isLoading: !1 });
      }
    }, this.handleInputChange = (n) => {
      const r = n.target.value;
      if (this.setState({ inputValue: r }), r === "") {
        this.props.onChange({ address: "" }), this.setState({ suggestions: [], showSuggestions: !1 });
        return;
      }
      this.searchDebounced(r);
    }, this.handleSuggestionSelect = async (n) => {
      this.setState({
        inputValue: n.label,
        showSuggestions: !1,
        suggestions: [],
        selectedIndex: -1
      });
      try {
        const r = await this.props.placesApi.placeDetails.get({
          placeId: n.value.details.placeId,
          language: Ft.getCurrentLanguageCode()
        });
        if (!r.location)
          throw new Error("Location coordinates not available");
        const i = Du(r.name, r.address);
        this.setState({ inputValue: i });
        const [s, a] = r.location, c = {
          address: i,
          location: V0(s, a),
          addressComponents: r.addressComponents
        };
        this.props.onChange(c);
      } catch (r) {
        this.props.onError(r), this.props.onChange({ address: n.label });
      }
    }, this.handleInputBlur = () => {
      setTimeout(() => {
        var n;
        this.setState({ showSuggestions: !1, selectedIndex: -1 }), this.state.inputValue !== ((n = this.props.value) == null ? void 0 : n.address) && this.props.onChange({ address: this.state.inputValue });
      }, 200);
    }, this.handleInputFocus = () => {
      this.state.suggestions.length > 0 && this.setState({ showSuggestions: !0 });
    }, this.handleKeyDown = (n) => {
      if (!(!this.state.showSuggestions || this.state.suggestions.length === 0))
        switch (n.key) {
          case "ArrowDown":
            n.preventDefault(), this.setState((r) => ({
              selectedIndex: r.selectedIndex < r.suggestions.length - 1 ? r.selectedIndex + 1 : r.selectedIndex
            }));
            break;
          case "ArrowUp":
            n.preventDefault(), this.setState((r) => ({
              selectedIndex: r.selectedIndex > 0 ? r.selectedIndex - 1 : -1
            }));
            break;
          case "Enter":
            n.preventDefault(), this.state.selectedIndex >= 0 && this.state.selectedIndex < this.state.suggestions.length ? this.handleSuggestionSelect(this.state.suggestions[this.state.selectedIndex]) : (this.props.onChange({ address: this.state.inputValue }), this.setState({ showSuggestions: !1 }));
            break;
          case "Escape":
            this.setState({ showSuggestions: !1, selectedIndex: -1 });
            break;
        }
    }, this.state = {
      inputValue: "",
      // Always start with empty search field
      suggestions: [],
      showSuggestions: !1,
      selectedIndex: -1,
      isLoading: !1
    }, this.inputId = e.id || ut("location-input-"), this.searchDebounced = ua((n) => {
      this.search(n);
    }, 500);
  }
  render() {
    return /* @__PURE__ */ O(xu, { children: [
      /* @__PURE__ */ h(
        Ru,
        {
          id: this.inputId,
          type: "text",
          value: this.state.inputValue,
          onChange: this.handleInputChange,
          onBlur: this.handleInputBlur,
          onFocus: this.handleInputFocus,
          onKeyDown: this.handleKeyDown,
          placeholder: this.props.placeholder || "Enter a location...",
          invalid: this.props.invalid,
          autoComplete: "off"
        }
      ),
      this.state.showSuggestions && this.state.suggestions.length > 0 && /* @__PURE__ */ h(bu, { children: this.state.suggestions.map((e, n) => /* @__PURE__ */ O(
        Lu,
        {
          selected: n === this.state.selectedIndex,
          onMouseDown: () => {
            this.handleSuggestionSelect(e);
          },
          children: [
            /* @__PURE__ */ h(Pu, { children: e.label }),
            e.value.details.sublabel && /* @__PURE__ */ h(Mu, { children: e.value.details.sublabel })
          ]
        },
        e.value.details.placeId
      )) }),
      this.state.isLoading && /* @__PURE__ */ h(
        K1,
        {
          style: {
            position: "absolute",
            top: "50%",
            right: "12px",
            transform: "translateY(-50%)",
            width: "12px",
            height: "12px"
          }
        }
      )
    ] });
  }
}
const wu = m.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`, Hu = m.div`
  width: 100%;
`, $u = m.div`
  width: 100%;
`, ao = m.h3`
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: ${d.contentPrimary};
`, H7 = (t) => !t || typeof t != "object" ? { version: 1, country: "US" } : "address" in t && typeof t.address == "object" && t.address !== null ? t.address : "version" in t || "country" in t || "address1" in t ? t : { version: 1, country: "US" };
class $7 extends oa {
  constructor(e) {
    var n;
    super(e), this.buildCleanAddress = (r) => {
      const i = {};
      return i.version = r.version || 1, r.firstName && (i.firstName = r.firstName), r.lastName && (i.lastName = r.lastName), r.address1 && (i.address1 = r.address1), r.address2 && (i.address2 = r.address2), r.city && (i.city = r.city), r.province && (i.province = r.province), r.zip && (i.zip = r.zip), r.country && (i.country = r.country), i;
    }, this.mapLocationAddressToIAddress = (r) => {
      const i = this.state.addressValue;
      return {
        ...i,
        address1: r || i.address1
      };
    }, this.handleLocationAutocompleteChange = (r) => {
      var i;
      if (r.location && r.address) {
        let s;
        try {
          if (r.addressComponents) {
            const a = r.addressComponents;
            s = this.buildCleanAddress({
              version: 1,
              firstName: this.state.addressValue.firstName,
              lastName: this.state.addressValue.lastName,
              address1: a.number && a.street ? `${a.number} ${a.street}` : a.street || "",
              city: a.city || "",
              province: a.state ? oo(a.state) : "",
              zip: a.postal || "",
              country: a.country ? so(a.country) : this.state.addressValue.country || "US"
            });
          } else {
            const a = r.address.split(",").map((C) => C.trim());
            let c = "", l = "", u = "", g = "";
            if (a.length >= 3) {
              c = a[0], l = a[1];
              const C = vu(
                r.address,
                this.state.addressValue.country || "US"
              ), y = a[a.length - 1];
              y.length <= 3 || y.includes("United States") || y.includes("USA") || y.includes("Canada") || y.includes("UK") ? (g = y, u = a[a.length - 2]) : (u = y, g = C);
            }
            let A = "", S = "";
            if (u) {
              const C = u.match(/\b(\d{5}(-\d{4})?)\b/), y = u.match(/\b([A-Z]\d[A-Z]\s?\d[A-Z]\d)\b/i);
              C ? (S = C[1], A = u.substring(0, C.index).trim()) : y ? (S = y[1].toUpperCase(), A = u.substring(0, y.index).trim()) : A = u;
            }
            s = this.buildCleanAddress({
              version: 1,
              firstName: this.state.addressValue.firstName,
              lastName: this.state.addressValue.lastName,
              address1: c,
              city: l,
              province: oo(A),
              zip: S,
              country: g ? so(g) : this.state.addressValue.country || "US"
            });
          }
        } catch (a) {
          this.props.onError(a), s = this.buildCleanAddress({
            version: 1,
            firstName: this.state.addressValue.firstName,
            lastName: this.state.addressValue.lastName,
            address1: r.address || "",
            country: this.state.addressValue.country || "US"
          });
        }
        this.setState({
          addressValue: s,
          locationAutocompleteValue: r
        }), this.props.onChange({
          address: s,
          location: r.location
        });
      } else {
        const s = this.mapLocationAddressToIAddress(r.address || "");
        this.setState({
          addressValue: s,
          locationAutocompleteValue: r
        }), this.props.onChange({
          address: s,
          location: (i = this.props.value) == null ? void 0 : i.location
          // Preserve existing location data
        });
      }
    }, this.handleAddressChange = (r) => {
      var i;
      this.isAddressEqual(this.state.addressValue, r) || (this.setState({
        addressValue: r
      }), this.props.onChange({
        address: r,
        location: (i = this.props.value) == null ? void 0 : i.location
        // Preserve existing location data
      }));
    }, this.state = {
      addressValue: ((n = e.value) == null ? void 0 : n.address) || { version: 1, country: "US" },
      locationAutocompleteValue: {
        address: ""
        // Always start with empty search field
      }
    }, this.inputId = e.id || ut("address-v2-input-");
  }
  componentDidUpdate(e) {
    var n, r, i;
    if (!this.isAddressEqual((n = e.value) == null ? void 0 : n.address, (r = this.props.value) == null ? void 0 : r.address)) {
      const s = ((i = this.props.value) == null ? void 0 : i.address) || { version: 1, country: "US" };
      if (this.state.addressValue.country !== s.country && this.state.addressValue.firstName === s.firstName && this.state.addressValue.lastName === s.lastName && this.state.addressValue.address1 === s.address1 && this.state.addressValue.address2 === s.address2 && this.state.addressValue.city === s.city && this.state.addressValue.zip === s.zip && !s.province)
        return;
      this.setState({
        addressValue: s
      });
    }
  }
  isAddressEqual(e, n) {
    return e === n ? !0 : !e || !n ? !1 : e.firstName === n.firstName && e.lastName === n.lastName && e.address1 === n.address1 && e.address2 === n.address2 && e.city === n.city && e.province === n.province && e.zip === n.zip && e.country === n.country;
  }
  render() {
    return /* @__PURE__ */ O(wu, { children: [
      /* @__PURE__ */ O(Hu, { children: [
        /* @__PURE__ */ h(ao, { children: "Search for an address" }),
        /* @__PURE__ */ h(
          ku,
          {
            id: `${this.inputId}-location`,
            value: this.state.locationAutocompleteValue,
            onChange: this.handleLocationAutocompleteChange,
            placeholder: this.props.placeholder,
            invalid: this.props.invalid,
            placesApi: this.props.placesApi,
            onError: this.props.onError
          }
        )
      ] }),
      /* @__PURE__ */ O($u, { children: [
        /* @__PURE__ */ h(ao, { children: "Address Details" }),
        /* @__PURE__ */ h(
          Nu,
          {
            id: `${this.inputId}-address`,
            onChange: this.handleAddressChange,
            value: this.state.addressValue,
            apiUrl: this.props.apiUrl,
            onError: this.props.onError,
            invalid: this.props.invalid
          },
          `${this.inputId}-address-${this.state.addressValue.country || "US"}`
        )
      ] })
    ] });
  }
}
const Fu = m.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: ${d.backgroundPrimary};
  border: 1px solid ${d.borderSecondary};
  border-radius: 1px;
  display: inline-block;
  position: relative;
  height: 13px;
  width: 13px;
  flex-shrink: 0;
  cursor: pointer;
  // align with top of text
  align-self: flex-start;
  margin-top: 3px;

  &:disabled {
    background-color: ${d.backgroundSecondary};
    border-color: ${d.borderPrimary};
    cursor: not-allowed;
  }
  &:focus,
  &:active {
    border-radius: 2px !important;
    ${Hn}
    outline-offset: 1px;
  }
  &:checked,
  &:indeterminate {
    background-color: ${d.interactivePrimary};
    border-color: ${d.interactivePrimary};
  }

  &:checked:after {
    content: '';
    position: absolute;
    display: block;
    bottom: 2px;
    right: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(38deg);
    -ms-transform: rotate(38deg);
    transform: rotate(38deg);
  }

  &:indeterminate:after {
    content: '';
    position: absolute;
    display: block;
    bottom: 4px;
    right: 1.5px;
    width: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
  }
`, Bu = ({
  value: t,
  onChange: e,
  minDate: n,
  maxDate: r,
  invalid: i,
  isRequired: s = !0,
  id: a,
  ...c
}) => /* @__PURE__ */ h(
  He,
  {
    ...c,
    "aria-label": H.inputs.dateTime.selectDateLabel(),
    role: "textbox",
    type: "date",
    invalid: i,
    value: t,
    min: n,
    max: r,
    onChange: (l) => {
      s && l.target.value ? e(l.target.value) : s || e(l.target.value);
    },
    id: a
  }
);
let rn;
const Uu = new Uint8Array(16);
function Gu() {
  if (!rn && (rn = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !rn))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return rn(Uu);
}
const fe = [];
for (let t = 0; t < 256; ++t)
  fe.push((t + 256).toString(16).slice(1));
function Ku(t, e = 0) {
  return fe[t[e + 0]] + fe[t[e + 1]] + fe[t[e + 2]] + fe[t[e + 3]] + "-" + fe[t[e + 4]] + fe[t[e + 5]] + "-" + fe[t[e + 6]] + fe[t[e + 7]] + "-" + fe[t[e + 8]] + fe[t[e + 9]] + "-" + fe[t[e + 10]] + fe[t[e + 11]] + fe[t[e + 12]] + fe[t[e + 13]] + fe[t[e + 14]] + fe[t[e + 15]];
}
const zu = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), lo = {
  randomUUID: zu
};
function Dr(t, e, n) {
  if (lo.randomUUID && !e && !t)
    return lo.randomUUID();
  t = t || {};
  const r = t.random || (t.rng || Gu)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, e) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      e[n + i] = r[i];
    return e;
  }
  return Ku(r);
}
const ri = m.div`
  ${({ $isFullWidth: t }) => t ? "width: 100%;" : ""}

  .SingleDatePicker {
    ${({ $isFullWidth: t }) => t ? "width: 100%;" : ""}
    background-color: ${d.backgroundPrimary};
  }

  .DateInput {
    width: ${({ $isFullWidth: t }) => t ? "100%" : "130px"};
    min-width: ${({ $isFullWidth: t }) => t ? "200px" : "130px"};
    background: ${d.backgroundPrimary};
  }

  .DateInput_input {
    font-weight: 400;
    font-size: 15px;
    line-height: 15px;
    padding: 6px 7px 5px;
    text-align: center;
    background: ${d.backgroundPrimary};
    color: ${d.contentPrimary};
    &:focus-visible {
      outline: none;
      color: ${d.contentInvertedPrimary};
      background: ${d.interactivePrimary};
      border-radius: 6px; // border-radius of outer container minus padding
      border: 0px;
      &::placeholder {
        color: ${d.contentInvertedPrimary};
      }
    }
  }

  .DateInput .DateInput_input__focused {
    color: ${d.contentInvertedPrimary};
    background: ${d.interactivePrimary};
    border-radius: 6px; // border-radius of outer container minus padding
    border: 0px;
    &::placeholder {
      color: ${d.contentInvertedPrimary};
    }
  }

  .DayPicker,
  .CalendarMonth,
  .CalendarMonthGrid {
    background-color: ${d.backgroundPrimary};
  }

  .DayPickerNavigation_button {
    &:focus-visible {
      outline-color: ${d.focusOutline} !important;
      outline-style: solid !important;
      outline-width: 2px !important;
    }
  }

  .DateInput_fang {
    display: none !important;
  }

  .DateRangePickerInput,
  .SingleDatePickerInput {
    ${({ $isFullWidth: t }) => t ? "width: 100%;" : ""}
    border: 0;
    border-radius: ${j};
    padding: 4px;
    transition: all 0.3s ease;
    box-shadow: ${We};
    background-color: ${d.backgroundPrimary};
    &:hover,
    &:focus,
    &:active {
      box-shadow: ${ct};
    }
  }

  .SingleDatePickerInput__disabled,
  .DateInput_input__disabled {
    background: ${d.backgroundTertiary};
    font-style: normal;
    cursor: default !important;
  }

  .DateRangePicker_picker,
  .SingleDatePicker_picker {
    border-radius: 8px;
    z-index: 2;
  }

  .SingleDatePickerInput {
    height: 38px;
    line-height: 27px;
    .DateInput_input {
      cursor: pointer;
    }
  }

  .DateRangePickerInput_arrow {
    line-height: 0px;
    vertical-align: middle;
    padding: 0px 7px;
  }

  .DateRangePickerInput_arrow_svg {
    fill: ${d.interactivePrimary};
    height: 15px;
    width: 15px;
  }

  .CalendarDay__blocked_out_of_range {
    background: ${d.backgroundSecondary};
    &:hover {
      background: ${d.backgroundSecondary};
    }
  }

  .CalendarDay:focus-visible {
    ${jt}
    outline-offset: -2px;
    border-radius: 5px;
  }

  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: ${d.interactivePrimary};
    border: 1px solid ${d.interactivePrimary};
    color: ${d.contentInvertedPrimary};
  }

  .CalendarDay__selected_span:active,
  .CalendarDay__selected_span:hover {
    background: ${d.interactivePrimary};
    border: 1px solid ${d.interactivePrimary};
    color: ${d.contentInvertedPrimary};
  }

  .CalendarDay__selected_span {
    background: ${d.interactivePrimary};
    border: 1px solid ${d.interactivePrimary};
    color: ${d.contentInvertedPrimary};
  }

  .CalendarDay__hovered_span,
  .CalendarDay__hovered_span:active,
  .CalendarDay__hovered_span:hover {
    background: ${d.interactivePrimary};
    border: 1px solid ${d.interactivePrimary};
    color: ${d.contentInvertedPrimary};
  }

  .CalendarDay__selected:hover,
  .CalendarDay__selected_span:hover,
  .CalendarDay__hovered_span:hover {
    background: ${d.interactivePrimaryHover};
  }

  .DayPicker,
  .DayPicker_transitionContainer {
    border-radius: 8px;
  }

  .DayPickerNavigation_button__default {
    border: 0px;
    &:hover,
    &:focus,
    &:active {
      svg {
        fill: ${d.interactivePrimary};
      }
      border: 0px;
      outline: none;
      background: none;
    }
  }

  .DayPicker__horizontal {
    box-shadow: ${ct};
  }

  .DateRangePickerInput_calendarIcon,
  .SingleDatePickerInput_calendarIcon {
    margin: 0;
    padding: 3px 5px 0px 9px;
    vertical-align: top;
    outline: none;
  }
  .DateRangePickerInput_calendarIcon_svg,
  .SingleDatePickerInput_calendarIcon_svg {
    fill: ${d.contentPrimary};
  }

  .CalendarDay__highlighted_calendar,
  .CalendarDay__highlighted_calendar:hover {
    background: ${d.interactivePrimary};
    color: ${d.contentInvertedPrimary};
  }

  .CalendarMonth_caption {
    color: ${d.contentPrimary};
  }
`, Yu = m(ri)`
  .DateInput {
    background: inherit;
    width: 100%;
  }

  .DateInput_input {
    background: inherit;
    &:focus,
    &:focus-visible,
    &:active {
      background: ${t1.interactivePrimary};
      border-radius: 4px;
    }
  }

  .DateInput .DateInput_input__focused {
    background: ${t1.interactivePrimary};
    border-radius: 4px;
  }

  .SingleDatePickerInput {
    border-radius: 0px;
    box-shadow: none;
    &:hover,
    &:focus,
    &:active {
      box-shadow: none;
      background: ${t1.backgroundPrimaryHover};
    }
  }

  .SingleDatePicker_picker {
    top: 50px !important; // Necessary to override the internal style
    right: -41px !important;
    z-index: 3;
  }
`, Wu = m.div`
  color: ${t1.contentPrimary};
  background: ${t1.borderPrimary};
  border-radius: ${j};
  box-shadow: ${We};
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 1px;
  transition: box-shadow 0.3s ease;
  &:hover {
    box-shadow: ${ct};
  }
`, nl = m(Xt)`
  color: ${t1.contentPrimary};
  padding: 8px 15px;
  &:hover {
    // We need to use !important here to override the AbstractButton use of !important
    background: ${t1.backgroundPrimaryHover} !important;
  }
  &:focus {
    box-shadow: none;
  }
`, Vu = m(nl)`
  border-radius: ${j} 0 0 ${j};
`, ju = m(nl)`
  border-radius: 0 ${j} ${j} 0;
`, Xu = ({
  style: t,
  focused: e,
  onFocusChange: n,
  dateFormat: r = Ye,
  ...i
}) => {
  const [s, a] = V(e);
  return Ne(() => {
    const c = document.querySelector(".SingleDatePickerInput"), l = (u) => {
      u.key === "Escape" && a(!1), u.key === "Enter" && a(!0);
    };
    return c == null || c.addEventListener("keydown", l), () => c == null ? void 0 : c.removeEventListener("keydown", l);
  }, []), /* @__PURE__ */ h(ri, { style: t, $isFullWidth: r !== Ye, children: /* @__PURE__ */ h(
    ma,
    {
      focused: s,
      onFocusChange: ({ focused: c }) => a(c),
      displayFormat: r,
      isOutsideRange: () => !1,
      hideKeyboardShortcutsPanel: !0,
      screenReaderInputMessage: H.date.dateInputMessage(),
      ...i
    }
  ) });
};
Xu.displayName = "StyledSingleDatePicker";
const Qu = ({
  style: t,
  focused: e,
  date: n,
  onDateChange: r,
  onFocusChange: i,
  dateFormat: s = Ye,
  ...a
}) => {
  const [c, l] = V(e);
  Ne(() => {
    const A = document.querySelector(".SingleDatePickerInput"), S = (C) => {
      C.key === "Escape" && l(!1), C.key === "Enter" && l(!0);
    };
    return A == null || A.addEventListener("keydown", S), () => A == null ? void 0 : A.removeEventListener("keydown", S);
  }, []);
  const u = () => {
    n && r(n.subtract(1, "day"));
  }, g = () => {
    n && r(n.add(1, "day"));
  };
  return /* @__PURE__ */ O(Wu, { children: [
    /* @__PURE__ */ h(Vu, { onClick: u, children: /* @__PURE__ */ h(ge, { icon: "chevron-left" }) }),
    /* @__PURE__ */ h(Yu, { style: t, $isFullWidth: s !== Ye, children: /* @__PURE__ */ h(
      ma,
      {
        focused: c,
        date: n,
        onDateChange: r,
        onFocusChange: ({ focused: A }) => l(A),
        displayFormat: s,
        isOutsideRange: () => !1,
        hideKeyboardShortcutsPanel: !0,
        screenReaderInputMessage: H.date.dateInputMessage(),
        ...a
      }
    ) }),
    /* @__PURE__ */ h(ju, { onClick: g, children: /* @__PURE__ */ h(ge, { icon: "chevron-right" }) })
  ] });
};
Qu.displayName = "StyledSingleDatePickerWithDayNavigation";
const qu = (t) => /* @__PURE__ */ h(ri, { children: /* @__PURE__ */ h(
  X0,
  {
    displayFormat: Ye,
    startDatePlaceholderText: Ye,
    endDatePlaceholderText: Ye,
    numberOfMonths: 1,
    isDayBlocked: () => !1,
    isOutsideRange: () => !1,
    horizontalMargin: 20,
    minimumNights: 0,
    ...t
  }
) }), Zu = (t) => t ? t === "startDate" ? H.date.dateRangePicker.startDateMessage() : H.date.dateRangePicker.endDateMessage() : H.date.dateInputMessage(), F7 = ({ value: t, onChange: e, showIcon: n = !1 }) => {
  const [r, i] = V(null), s = at("startDate"), a = at(r), c = (l) => {
    r && (s.current = r), a.current = l, i(l);
  };
  return Ne(() => {
    const l = document.querySelector(".DateRangePickerInput"), u = (g) => {
      g.key === "Escape" && c(null), g.key === "Enter" && !a.current && c(s.current);
    };
    return l == null || l.addEventListener("keydown", u), () => l == null ? void 0 : l.removeEventListener("keydown", u);
  }, []), /* @__PURE__ */ h(
    qu,
    {
      startDateId: Dr(),
      endDateId: Dr(),
      startDate: t != null && t.startDate ? O1(t.startDate, Ye) : null,
      endDate: t != null && t.endDate ? O1(t.endDate, Ye) : null,
      onDatesChange: ({ startDate: l, endDate: u }) => {
        e({
          startDate: (l == null ? void 0 : l.format(Ye)) ?? null,
          endDate: (u == null ? void 0 : u.format(Ye)) ?? null
        });
      },
      focusedInput: r,
      onFocusChange: (l) => {
        c(l);
      },
      showDefaultInputIcon: n,
      screenReaderInputMessage: Zu(r)
    }
  );
}, co = (t, e) => `(${O1.unix(t).tz(e).format("h:mm A")}/${O1.unix(t).tz("UTC").format("H:mm")} UTC)`, Ju = m.div`
  > * {
    margin-top: 7px;

    &:first-child {
      margin-top: 0px;
    }
  }
`, ed = m.div`
  color: ${d.contentTertiary};
  font-size: 13px;
  line-height: 16px;
`, td = ({ ts: t, timezone: e, onChange: n }) => {
  if (!n1(t))
    return null;
  const r = O1.unix(t).tz(e), i = r.hours() === r.clone().add(1, "hour").hours(), s = r.hours() === r.clone().subtract(1, "hour").hours();
  if (!i && !s)
    return null;
  const a = i ? t : t - Ut, c = a + Ut;
  return /* @__PURE__ */ O(Ju, { children: [
    /* @__PURE__ */ h(
      bn,
      {
        value: t,
        choices: [
          {
            label: `${H.inputs.dateTime.dst.fallBack.beforeTimeSetBack()} ${co(
              a,
              e
            )}`,
            value: a
          },
          {
            label: `${H.inputs.dateTime.dst.fallBack.afterTimeSetBack()} ${co(
              c,
              e
            )}`,
            value: c
          }
        ],
        onChange: n
      }
    ),
    /* @__PURE__ */ h(ed, { children: H.inputs.dateTime.dst.fallBack.hint() })
  ] });
}, nd = m.div`
  color: ${d.negativePrimary};
  font-size: 15px;
  line-height: 20px;
`, rd = ({ date: t, time: e, timezone: n }) => {
  if (!t || !n1(e))
    return null;
  const r = (i) => Nn.buildTimestamp(t, i, n);
  return r(e) === r(e + Ut) ? /* @__PURE__ */ h(nd, { role: "alert", children: H.inputs.dateTime.dst.springForward.hint() }) : null;
}, id = m.span`
  width: 50%;
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
`, ii = 60, oi = 60 * ii, uo = (t) => D0(`${t}`, 2, "0"), od = (t) => Math.floor(t % Vt / oi), sd = (t) => Math.floor(t % Vt % oi / ii), kr = (t) => `${uo(od(t))}:${uo(sd(t))}`, wr = (t, e = "startOfDay") => {
  const n = t.split(":");
  return e === "endOfDay" && n[0] === "00" && n[1] === "00" ? Vt : parseInt(n[0], 10) * oi + parseInt(n[1], 10) * ii;
};
var ad = /* @__PURE__ */ ((t) => (t.StartOfDay = "startOfDay", t.EndOfDay = "endOfDay", t))(ad || {});
const ld = ({
  value: t,
  invalid: e,
  onChange: n,
  text: r,
  id: i,
  midnightMode: s,
  ...a
}) => {
  const c = t !== void 0 ? kr(t) : void 0;
  return /* @__PURE__ */ O("div", { style: { display: "flex", width: "100%" }, children: [
    /* @__PURE__ */ h(
      He,
      {
        ...a,
        id: i,
        "aria-label": H.inputs.dateTime.selectTimeLabel(),
        role: "textbox",
        type: "time",
        invalid: e,
        value: c,
        "aria-valuetext": c ? H.inputs.dateTime.accessibleTimeHint({ time: c }) : "",
        onChange: (l) => {
          l.target.value && n(wr(l.target.value, s));
        }
      }
    ),
    r && /* @__PURE__ */ h(id, { children: r })
  ] });
}, cd = m.div`
  display: flex;
  flex-direction: column;

  > * {
    margin-top: 7px;

    &:first-child {
      margin-top: 0px;
    }
  }
`, ud = m.div`
  display: flex;
  max-width: ${ce};
  align-items: center;
`, dd = m.div`
  margin-right: 10px;
  min-width: ${v9};
`, ho = (t, e) => {
  const n = O1.unix(t).tz(e).startOf("day"), r = O1.unix(t).tz(e);
  return r.diff(n, "seconds") + hd(n, r);
}, hd = (t, e) => t.isDST() === e.isDST() ? 0 : t.isDST() ? -Ut : Ut, B7 = ({
  value: t,
  onChange: e,
  timezone: n = O1.tz.guess(),
  minDate: r,
  maxDate: i,
  isRequired: s = !0,
  id: a,
  invalid: c
}) => {
  const [l, u] = V(t ? Nn.parseDate(t, n) : void 0), [g, A] = V(t ? ho(t, n) : void 0);
  return Ne(() => {
    t && (u(Nn.parseDate(t, n)), A(ho(t, n)));
  }, [t, n]), Ne(() => {
    l !== void 0 && l !== "" && g !== void 0 ? e(Nn.buildTimestamp(l, g, n)) : l === "" && e(null);
  }, [l, g]), /* @__PURE__ */ O(cd, { children: [
    /* @__PURE__ */ O(ud, { children: [
      /* @__PURE__ */ h(dd, { id: a, children: /* @__PURE__ */ h(
        Bu,
        {
          value: l,
          onChange: u,
          minDate: r,
          maxDate: i,
          isRequired: s,
          invalid: c
        }
      ) }),
      /* @__PURE__ */ h(ld, { value: g, onChange: A, invalid: c })
    ] }),
    /* @__PURE__ */ h(rd, { date: l, time: g, timezone: n }),
    /* @__PURE__ */ h(td, { ts: t, timezone: n, onChange: (S) => e(S) })
  ] });
}, fd = 1e3, md = m.div`
  display: flex;
  flex-direction: column;
  outline: ${({ $invalid: t }) => t ? `1px solid ${d.negativePrimary}` : "unset"};
  border-radius: 8px;
`, Td = m.div`
  position: relative;
`, pd = m.div`
  display: flex;
  z-index: 16; // higher than canvas, lower than input box
  bottom: 0;
  right: 0;
  margin: 0 8px 8px 0;
  align-items: center;
  position: absolute;
`, Ed = m(Bn)`
  margin-left: 8px;
`, gd = (t, e) => {
  const n = t.split(",")[1], r = new Uint8Array([...atob(n)].map((i) => i.charCodeAt(0)));
  return new File([r], `${e}.png`, { type: "image/png", lastModified: j0.toTs(/* @__PURE__ */ new Date()) });
};
function U7({
  onChange: t,
  onError: e,
  width: n,
  upload: r,
  invalid: i
}) {
  const s = at(null), [a, c] = V(!1), [l] = V(Dr()), u = () => {
    var C;
    (C = s.current) == null || C.clear();
  }, A = ua(async () => {
    var C;
    try {
      c(!0);
      const y = (C = s.current.canvasContainer) == null ? void 0 : C.childNodes[1].toDataURL(), N = gd(y, l), v = await r(N);
      t(v);
    } catch (y) {
      e(y);
    } finally {
      c(!1);
    }
  }, fd), S = {
    ref: s,
    hideGrid: !0,
    canvasWidth: "100%",
    canvasHeight: 300,
    brushRadius: 2,
    lazyRadius: 0,
    style: { borderRadius: j, border: `solid 1px ${d.borderPrimary}` },
    onChange: A
  };
  return /* @__PURE__ */ h(md, { style: { width: n ?? "100%" }, $invalid: i, children: /* @__PURE__ */ O(Td, { children: [
    /* @__PURE__ */ h(Q0, { ...S }),
    /* @__PURE__ */ O(pd, { children: [
      a && /* @__PURE__ */ h(K1, {}),
      /* @__PURE__ */ h(Ed, { buttonTheme: ze, onClick: u, children: H.inputs.drawing.clear() })
    ] })
  ] }) });
}
function rl(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Ad(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var si = { exports: {} }, Hr = { exports: {} };
(function(t, e) {
  e = t.exports = K;
  var n;
  typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? n = function() {
    var f = Array.prototype.slice.call(arguments, 0);
    f.unshift("SEMVER"), console.log.apply(console, f);
  } : n = function() {
  }, e.SEMVER_SPEC_VERSION = "2.0.0";
  var r = 256, i = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991, s = 16, a = r - 6, c = e.re = [], l = e.safeRe = [], u = e.src = [], g = 0, A = "[a-zA-Z0-9-]", S = [
    ["\\s", 1],
    ["\\d", r],
    [A, a]
  ];
  function C(f) {
    for (var E = 0; E < S.length; E++) {
      var _ = S[E][0], x = S[E][1];
      f = f.split(_ + "*").join(_ + "{0," + x + "}").split(_ + "+").join(_ + "{1," + x + "}");
    }
    return f;
  }
  var y = g++;
  u[y] = "0|[1-9]\\d*";
  var N = g++;
  u[N] = "\\d+";
  var v = g++;
  u[v] = "\\d*[a-zA-Z-]" + A + "*";
  var X = g++;
  u[X] = "(" + u[y] + ")\\.(" + u[y] + ")\\.(" + u[y] + ")";
  var Z = g++;
  u[Z] = "(" + u[N] + ")\\.(" + u[N] + ")\\.(" + u[N] + ")";
  var ae = g++;
  u[ae] = "(?:" + u[y] + "|" + u[v] + ")";
  var $ = g++;
  u[$] = "(?:" + u[N] + "|" + u[v] + ")";
  var te = g++;
  u[te] = "(?:-(" + u[ae] + "(?:\\." + u[ae] + ")*))";
  var Se = g++;
  u[Se] = "(?:-?(" + u[$] + "(?:\\." + u[$] + ")*))";
  var Ae = g++;
  u[Ae] = A + "+";
  var F = g++;
  u[F] = "(?:\\+(" + u[Ae] + "(?:\\." + u[Ae] + ")*))";
  var J = g++, he = "v?" + u[X] + u[te] + "?" + u[F] + "?";
  u[J] = "^" + he + "$";
  var p1 = "[v=\\s]*" + u[Z] + u[Se] + "?" + u[F] + "?", Re = g++;
  u[Re] = "^" + p1 + "$";
  var ee = g++;
  u[ee] = "((?:<|>)?=?)";
  var Qe = g++;
  u[Qe] = u[N] + "|x|X|\\*";
  var Be = g++;
  u[Be] = u[y] + "|x|X|\\*";
  var L1 = g++;
  u[L1] = "[v=\\s]*(" + u[Be] + ")(?:\\.(" + u[Be] + ")(?:\\.(" + u[Be] + ")(?:" + u[te] + ")?" + u[F] + "?)?)?";
  var j1 = g++;
  u[j1] = "[v=\\s]*(" + u[Qe] + ")(?:\\.(" + u[Qe] + ")(?:\\.(" + u[Qe] + ")(?:" + u[Se] + ")?" + u[F] + "?)?)?";
  var ki = g++;
  u[ki] = "^" + u[ee] + "\\s*" + u[L1] + "$";
  var wi = g++;
  u[wi] = "^" + u[ee] + "\\s*" + u[j1] + "$";
  var Hi = g++;
  u[Hi] = "(?:^|[^\\d])(\\d{1," + s + "})(?:\\.(\\d{1," + s + "}))?(?:\\.(\\d{1," + s + "}))?(?:$|[^\\d])";
  var Zt = g++;
  u[Zt] = "(?:~>?)";
  var X1 = g++;
  u[X1] = "(\\s*)" + u[Zt] + "\\s+", c[X1] = new RegExp(u[X1], "g"), l[X1] = new RegExp(C(u[X1]), "g");
  var Lc = "$1~", $i = g++;
  u[$i] = "^" + u[Zt] + u[L1] + "$";
  var Fi = g++;
  u[Fi] = "^" + u[Zt] + u[j1] + "$";
  var Jt = g++;
  u[Jt] = "(?:\\^)";
  var Q1 = g++;
  u[Q1] = "(\\s*)" + u[Jt] + "\\s+", c[Q1] = new RegExp(u[Q1], "g"), l[Q1] = new RegExp(C(u[Q1]), "g");
  var Pc = "$1^", Bi = g++;
  u[Bi] = "^" + u[Jt] + u[L1] + "$";
  var Ui = g++;
  u[Ui] = "^" + u[Jt] + u[j1] + "$";
  var rr = g++;
  u[rr] = "^" + u[ee] + "\\s*(" + p1 + ")$|^$";
  var ir = g++;
  u[ir] = "^" + u[ee] + "\\s*(" + he + ")$|^$";
  var P1 = g++;
  u[P1] = "(\\s*)" + u[ee] + "\\s*(" + p1 + "|" + u[L1] + ")", c[P1] = new RegExp(u[P1], "g"), l[P1] = new RegExp(C(u[P1]), "g");
  var Mc = "$1$2$3", Gi = g++;
  u[Gi] = "^\\s*(" + u[L1] + ")\\s+-\\s+(" + u[L1] + ")\\s*$";
  var Ki = g++;
  u[Ki] = "^\\s*(" + u[j1] + ")\\s+-\\s+(" + u[j1] + ")\\s*$";
  var zi = g++;
  u[zi] = "(<|>)?=?\\s*\\*";
  for (var i1 = 0; i1 < g; i1++)
    n(i1, u[i1]), c[i1] || (c[i1] = new RegExp(u[i1]), l[i1] = new RegExp(C(u[i1])));
  e.parse = M1;
  function M1(f, E) {
    if ((!E || typeof E != "object") && (E = {
      loose: !!E,
      includePrerelease: !1
    }), f instanceof K)
      return f;
    if (typeof f != "string" || f.length > r)
      return null;
    var _ = E.loose ? l[Re] : l[J];
    if (!_.test(f))
      return null;
    try {
      return new K(f, E);
    } catch {
      return null;
    }
  }
  e.valid = Dc;
  function Dc(f, E) {
    var _ = M1(f, E);
    return _ ? _.version : null;
  }
  e.clean = kc;
  function kc(f, E) {
    var _ = M1(f.trim().replace(/^[=v]+/, ""), E);
    return _ ? _.version : null;
  }
  e.SemVer = K;
  function K(f, E) {
    if ((!E || typeof E != "object") && (E = {
      loose: !!E,
      includePrerelease: !1
    }), f instanceof K) {
      if (f.loose === E.loose)
        return f;
      f = f.version;
    } else if (typeof f != "string")
      throw new TypeError("Invalid Version: " + f);
    if (f.length > r)
      throw new TypeError("version is longer than " + r + " characters");
    if (!(this instanceof K))
      return new K(f, E);
    n("SemVer", f, E), this.options = E, this.loose = !!E.loose;
    var _ = f.trim().match(E.loose ? l[Re] : l[J]);
    if (!_)
      throw new TypeError("Invalid Version: " + f);
    if (this.raw = f, this.major = +_[1], this.minor = +_[2], this.patch = +_[3], this.major > i || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > i || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > i || this.patch < 0)
      throw new TypeError("Invalid patch version");
    _[4] ? this.prerelease = _[4].split(".").map(function(x) {
      if (/^[0-9]+$/.test(x)) {
        var L = +x;
        if (L >= 0 && L < i)
          return L;
      }
      return x;
    }) : this.prerelease = [], this.build = _[5] ? _[5].split(".") : [], this.format();
  }
  K.prototype.format = function() {
    return this.version = this.major + "." + this.minor + "." + this.patch, this.prerelease.length && (this.version += "-" + this.prerelease.join(".")), this.version;
  }, K.prototype.toString = function() {
    return this.version;
  }, K.prototype.compare = function(f) {
    return n("SemVer.compare", this.version, this.options, f), f instanceof K || (f = new K(f, this.options)), this.compareMain(f) || this.comparePre(f);
  }, K.prototype.compareMain = function(f) {
    return f instanceof K || (f = new K(f, this.options)), q1(this.major, f.major) || q1(this.minor, f.minor) || q1(this.patch, f.patch);
  }, K.prototype.comparePre = function(f) {
    if (f instanceof K || (f = new K(f, this.options)), this.prerelease.length && !f.prerelease.length)
      return -1;
    if (!this.prerelease.length && f.prerelease.length)
      return 1;
    if (!this.prerelease.length && !f.prerelease.length)
      return 0;
    var E = 0;
    do {
      var _ = this.prerelease[E], x = f.prerelease[E];
      if (n("prerelease compare", E, _, x), _ === void 0 && x === void 0)
        return 0;
      if (x === void 0)
        return 1;
      if (_ === void 0)
        return -1;
      if (_ === x)
        continue;
      return q1(_, x);
    } while (++E);
  }, K.prototype.inc = function(f, E) {
    switch (f) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", E);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", E);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", E), this.inc("pre", E);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", E), this.inc("pre", E);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre":
        if (this.prerelease.length === 0)
          this.prerelease = [0];
        else {
          for (var _ = this.prerelease.length; --_ >= 0; )
            typeof this.prerelease[_] == "number" && (this.prerelease[_]++, _ = -2);
          _ === -1 && this.prerelease.push(0);
        }
        E && (this.prerelease[0] === E ? isNaN(this.prerelease[1]) && (this.prerelease = [E, 0]) : this.prerelease = [E, 0]);
        break;
      default:
        throw new Error("invalid increment argument: " + f);
    }
    return this.format(), this.raw = this.version, this;
  }, e.inc = wc;
  function wc(f, E, _, x) {
    typeof _ == "string" && (x = _, _ = void 0);
    try {
      return new K(f, _).inc(E, x).version;
    } catch {
      return null;
    }
  }
  e.diff = Hc;
  function Hc(f, E) {
    if (or(f, E))
      return null;
    var _ = M1(f), x = M1(E), L = "";
    if (_.prerelease.length || x.prerelease.length) {
      L = "pre";
      var M = "prerelease";
    }
    for (var D in _)
      if ((D === "major" || D === "minor" || D === "patch") && _[D] !== x[D])
        return L + D;
    return M;
  }
  e.compareIdentifiers = q1;
  var Yi = /^[0-9]+$/;
  function q1(f, E) {
    var _ = Yi.test(f), x = Yi.test(E);
    return _ && x && (f = +f, E = +E), f === E ? 0 : _ && !x ? -1 : x && !_ ? 1 : f < E ? -1 : 1;
  }
  e.rcompareIdentifiers = $c;
  function $c(f, E) {
    return q1(E, f);
  }
  e.major = Fc;
  function Fc(f, E) {
    return new K(f, E).major;
  }
  e.minor = Bc;
  function Bc(f, E) {
    return new K(f, E).minor;
  }
  e.patch = Uc;
  function Uc(f, E) {
    return new K(f, E).patch;
  }
  e.compare = o1;
  function o1(f, E, _) {
    return new K(f, _).compare(new K(E, _));
  }
  e.compareLoose = Gc;
  function Gc(f, E) {
    return o1(f, E, !0);
  }
  e.rcompare = Kc;
  function Kc(f, E, _) {
    return o1(E, f, _);
  }
  e.sort = zc;
  function zc(f, E) {
    return f.sort(function(_, x) {
      return e.compare(_, x, E);
    });
  }
  e.rsort = Yc;
  function Yc(f, E) {
    return f.sort(function(_, x) {
      return e.rcompare(_, x, E);
    });
  }
  e.gt = gt;
  function gt(f, E, _) {
    return o1(f, E, _) > 0;
  }
  e.lt = en;
  function en(f, E, _) {
    return o1(f, E, _) < 0;
  }
  e.eq = or;
  function or(f, E, _) {
    return o1(f, E, _) === 0;
  }
  e.neq = Wi;
  function Wi(f, E, _) {
    return o1(f, E, _) !== 0;
  }
  e.gte = sr;
  function sr(f, E, _) {
    return o1(f, E, _) >= 0;
  }
  e.lte = ar;
  function ar(f, E, _) {
    return o1(f, E, _) <= 0;
  }
  e.cmp = tn;
  function tn(f, E, _, x) {
    switch (E) {
      case "===":
        return typeof f == "object" && (f = f.version), typeof _ == "object" && (_ = _.version), f === _;
      case "!==":
        return typeof f == "object" && (f = f.version), typeof _ == "object" && (_ = _.version), f !== _;
      case "":
      case "=":
      case "==":
        return or(f, _, x);
      case "!=":
        return Wi(f, _, x);
      case ">":
        return gt(f, _, x);
      case ">=":
        return sr(f, _, x);
      case "<":
        return en(f, _, x);
      case "<=":
        return ar(f, _, x);
      default:
        throw new TypeError("Invalid operator: " + E);
    }
  }
  e.Comparator = be;
  function be(f, E) {
    if ((!E || typeof E != "object") && (E = {
      loose: !!E,
      includePrerelease: !1
    }), f instanceof be) {
      if (f.loose === !!E.loose)
        return f;
      f = f.value;
    }
    if (!(this instanceof be))
      return new be(f, E);
    f = f.trim().split(/\s+/).join(" "), n("comparator", f, E), this.options = E, this.loose = !!E.loose, this.parse(f), this.semver === At ? this.value = "" : this.value = this.operator + this.semver.version, n("comp", this);
  }
  var At = {};
  be.prototype.parse = function(f) {
    var E = this.options.loose ? l[rr] : l[ir], _ = f.match(E);
    if (!_)
      throw new TypeError("Invalid comparator: " + f);
    this.operator = _[1], this.operator === "=" && (this.operator = ""), _[2] ? this.semver = new K(_[2], this.options.loose) : this.semver = At;
  }, be.prototype.toString = function() {
    return this.value;
  }, be.prototype.test = function(f) {
    return n("Comparator.test", f, this.options.loose), this.semver === At ? !0 : (typeof f == "string" && (f = new K(f, this.options)), tn(f, this.operator, this.semver, this.options));
  }, be.prototype.intersects = function(f, E) {
    if (!(f instanceof be))
      throw new TypeError("a Comparator is required");
    (!E || typeof E != "object") && (E = {
      loose: !!E,
      includePrerelease: !1
    });
    var _;
    if (this.operator === "")
      return _ = new ie(f.value, E), nn(this.value, _, E);
    if (f.operator === "")
      return _ = new ie(this.value, E), nn(f.semver, _, E);
    var x = (this.operator === ">=" || this.operator === ">") && (f.operator === ">=" || f.operator === ">"), L = (this.operator === "<=" || this.operator === "<") && (f.operator === "<=" || f.operator === "<"), M = this.semver.version === f.semver.version, D = (this.operator === ">=" || this.operator === "<=") && (f.operator === ">=" || f.operator === "<="), W = tn(this.semver, "<", f.semver, E) && (this.operator === ">=" || this.operator === ">") && (f.operator === "<=" || f.operator === "<"), z = tn(this.semver, ">", f.semver, E) && (this.operator === "<=" || this.operator === "<") && (f.operator === ">=" || f.operator === ">");
    return x || L || M && D || W || z;
  }, e.Range = ie;
  function ie(f, E) {
    if ((!E || typeof E != "object") && (E = {
      loose: !!E,
      includePrerelease: !1
    }), f instanceof ie)
      return f.loose === !!E.loose && f.includePrerelease === !!E.includePrerelease ? f : new ie(f.raw, E);
    if (f instanceof be)
      return new ie(f.value, E);
    if (!(this instanceof ie))
      return new ie(f, E);
    if (this.options = E, this.loose = !!E.loose, this.includePrerelease = !!E.includePrerelease, this.raw = f.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map(function(_) {
      return this.parseRange(_.trim());
    }, this).filter(function(_) {
      return _.length;
    }), !this.set.length)
      throw new TypeError("Invalid SemVer Range: " + this.raw);
    this.format();
  }
  ie.prototype.format = function() {
    return this.range = this.set.map(function(f) {
      return f.join(" ").trim();
    }).join("||").trim(), this.range;
  }, ie.prototype.toString = function() {
    return this.range;
  }, ie.prototype.parseRange = function(f) {
    var E = this.options.loose, _ = E ? l[Ki] : l[Gi];
    f = f.replace(_, t0), n("hyphen replace", f), f = f.replace(l[P1], Mc), n("comparator trim", f, l[P1]), f = f.replace(l[X1], Lc), f = f.replace(l[Q1], Pc);
    var x = E ? l[rr] : l[ir], L = f.split(" ").map(function(M) {
      return Vc(M, this.options);
    }, this).join(" ").split(/\s+/);
    return this.options.loose && (L = L.filter(function(M) {
      return !!M.match(x);
    })), L = L.map(function(M) {
      return new be(M, this.options);
    }, this), L;
  }, ie.prototype.intersects = function(f, E) {
    if (!(f instanceof ie))
      throw new TypeError("a Range is required");
    return this.set.some(function(_) {
      return _.every(function(x) {
        return f.set.some(function(L) {
          return L.every(function(M) {
            return x.intersects(M, E);
          });
        });
      });
    });
  }, e.toComparators = Wc;
  function Wc(f, E) {
    return new ie(f, E).set.map(function(_) {
      return _.map(function(x) {
        return x.value;
      }).join(" ").trim().split(" ");
    });
  }
  function Vc(f, E) {
    return n("comp", f, E), f = Qc(f, E), n("caret", f), f = jc(f, E), n("tildes", f), f = Zc(f, E), n("xrange", f), f = e0(f, E), n("stars", f), f;
  }
  function _e(f) {
    return !f || f.toLowerCase() === "x" || f === "*";
  }
  function jc(f, E) {
    return f.trim().split(/\s+/).map(function(_) {
      return Xc(_, E);
    }).join(" ");
  }
  function Xc(f, E) {
    var _ = E.loose ? l[Fi] : l[$i];
    return f.replace(_, function(x, L, M, D, W) {
      n("tilde", f, x, L, M, D, W);
      var z;
      return _e(L) ? z = "" : _e(M) ? z = ">=" + L + ".0.0 <" + (+L + 1) + ".0.0" : _e(D) ? z = ">=" + L + "." + M + ".0 <" + L + "." + (+M + 1) + ".0" : W ? (n("replaceTilde pr", W), z = ">=" + L + "." + M + "." + D + "-" + W + " <" + L + "." + (+M + 1) + ".0") : z = ">=" + L + "." + M + "." + D + " <" + L + "." + (+M + 1) + ".0", n("tilde return", z), z;
    });
  }
  function Qc(f, E) {
    return f.trim().split(/\s+/).map(function(_) {
      return qc(_, E);
    }).join(" ");
  }
  function qc(f, E) {
    n("caret", f, E);
    var _ = E.loose ? l[Ui] : l[Bi];
    return f.replace(_, function(x, L, M, D, W) {
      n("caret", f, x, L, M, D, W);
      var z;
      return _e(L) ? z = "" : _e(M) ? z = ">=" + L + ".0.0 <" + (+L + 1) + ".0.0" : _e(D) ? L === "0" ? z = ">=" + L + "." + M + ".0 <" + L + "." + (+M + 1) + ".0" : z = ">=" + L + "." + M + ".0 <" + (+L + 1) + ".0.0" : W ? (n("replaceCaret pr", W), L === "0" ? M === "0" ? z = ">=" + L + "." + M + "." + D + "-" + W + " <" + L + "." + M + "." + (+D + 1) : z = ">=" + L + "." + M + "." + D + "-" + W + " <" + L + "." + (+M + 1) + ".0" : z = ">=" + L + "." + M + "." + D + "-" + W + " <" + (+L + 1) + ".0.0") : (n("no pr"), L === "0" ? M === "0" ? z = ">=" + L + "." + M + "." + D + " <" + L + "." + M + "." + (+D + 1) : z = ">=" + L + "." + M + "." + D + " <" + L + "." + (+M + 1) + ".0" : z = ">=" + L + "." + M + "." + D + " <" + (+L + 1) + ".0.0"), n("caret return", z), z;
    });
  }
  function Zc(f, E) {
    return n("replaceXRanges", f, E), f.split(/\s+/).map(function(_) {
      return Jc(_, E);
    }).join(" ");
  }
  function Jc(f, E) {
    f = f.trim();
    var _ = E.loose ? l[wi] : l[ki];
    return f.replace(_, function(x, L, M, D, W, z) {
      n("xRange", f, x, L, M, D, W, z);
      var qe = _e(M), Ze = qe || _e(D), Le = Ze || _e(W), xe = Le;
      return L === "=" && xe && (L = ""), qe ? L === ">" || L === "<" ? x = "<0.0.0" : x = "*" : L && xe ? (Ze && (D = 0), W = 0, L === ">" ? (L = ">=", Ze ? (M = +M + 1, D = 0, W = 0) : (D = +D + 1, W = 0)) : L === "<=" && (L = "<", Ze ? M = +M + 1 : D = +D + 1), x = L + M + "." + D + "." + W) : Ze ? x = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0" : Le && (x = ">=" + M + "." + D + ".0 <" + M + "." + (+D + 1) + ".0"), n("xRange return", x), x;
    });
  }
  function e0(f, E) {
    return n("replaceStars", f, E), f.trim().replace(l[zi], "");
  }
  function t0(f, E, _, x, L, M, D, W, z, qe, Ze, Le, xe) {
    return _e(_) ? E = "" : _e(x) ? E = ">=" + _ + ".0.0" : _e(L) ? E = ">=" + _ + "." + x + ".0" : E = ">=" + E, _e(z) ? W = "" : _e(qe) ? W = "<" + (+z + 1) + ".0.0" : _e(Ze) ? W = "<" + z + "." + (+qe + 1) + ".0" : Le ? W = "<=" + z + "." + qe + "." + Ze + "-" + Le : W = "<=" + W, (E + " " + W).trim();
  }
  ie.prototype.test = function(f) {
    if (!f)
      return !1;
    typeof f == "string" && (f = new K(f, this.options));
    for (var E = 0; E < this.set.length; E++)
      if (n0(this.set[E], f, this.options))
        return !0;
    return !1;
  };
  function n0(f, E, _) {
    for (var x = 0; x < f.length; x++)
      if (!f[x].test(E))
        return !1;
    if (E.prerelease.length && !_.includePrerelease) {
      for (x = 0; x < f.length; x++)
        if (n(f[x].semver), f[x].semver !== At && f[x].semver.prerelease.length > 0) {
          var L = f[x].semver;
          if (L.major === E.major && L.minor === E.minor && L.patch === E.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  }
  e.satisfies = nn;
  function nn(f, E, _) {
    try {
      E = new ie(E, _);
    } catch {
      return !1;
    }
    return E.test(f);
  }
  e.maxSatisfying = r0;
  function r0(f, E, _) {
    var x = null, L = null;
    try {
      var M = new ie(E, _);
    } catch {
      return null;
    }
    return f.forEach(function(D) {
      M.test(D) && (!x || L.compare(D) === -1) && (x = D, L = new K(x, _));
    }), x;
  }
  e.minSatisfying = i0;
  function i0(f, E, _) {
    var x = null, L = null;
    try {
      var M = new ie(E, _);
    } catch {
      return null;
    }
    return f.forEach(function(D) {
      M.test(D) && (!x || L.compare(D) === 1) && (x = D, L = new K(x, _));
    }), x;
  }
  e.minVersion = o0;
  function o0(f, E) {
    f = new ie(f, E);
    var _ = new K("0.0.0");
    if (f.test(_) || (_ = new K("0.0.0-0"), f.test(_)))
      return _;
    _ = null;
    for (var x = 0; x < f.set.length; ++x) {
      var L = f.set[x];
      L.forEach(function(M) {
        var D = new K(M.semver.version);
        switch (M.operator) {
          case ">":
            D.prerelease.length === 0 ? D.patch++ : D.prerelease.push(0), D.raw = D.format();
          case "":
          case ">=":
            (!_ || gt(_, D)) && (_ = D);
            break;
          case "<":
          case "<=":
            break;
          default:
            throw new Error("Unexpected operation: " + M.operator);
        }
      });
    }
    return _ && f.test(_) ? _ : null;
  }
  e.validRange = s0;
  function s0(f, E) {
    try {
      return new ie(f, E).range || "*";
    } catch {
      return null;
    }
  }
  e.ltr = a0;
  function a0(f, E, _) {
    return lr(f, E, "<", _);
  }
  e.gtr = l0;
  function l0(f, E, _) {
    return lr(f, E, ">", _);
  }
  e.outside = lr;
  function lr(f, E, _, x) {
    f = new K(f, x), E = new ie(E, x);
    var L, M, D, W, z;
    switch (_) {
      case ">":
        L = gt, M = ar, D = en, W = ">", z = ">=";
        break;
      case "<":
        L = en, M = sr, D = gt, W = "<", z = "<=";
        break;
      default:
        throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    if (nn(f, E, x))
      return !1;
    for (var qe = 0; qe < E.set.length; ++qe) {
      var Ze = E.set[qe], Le = null, xe = null;
      if (Ze.forEach(function(E1) {
        E1.semver === At && (E1 = new be(">=0.0.0")), Le = Le || E1, xe = xe || E1, L(E1.semver, Le.semver, x) ? Le = E1 : D(E1.semver, xe.semver, x) && (xe = E1);
      }), Le.operator === W || Le.operator === z || (!xe.operator || xe.operator === W) && M(f, xe.semver))
        return !1;
      if (xe.operator === z && D(f, xe.semver))
        return !1;
    }
    return !0;
  }
  e.prerelease = c0;
  function c0(f, E) {
    var _ = M1(f, E);
    return _ && _.prerelease.length ? _.prerelease : null;
  }
  e.intersects = u0;
  function u0(f, E, _) {
    return f = new ie(f, _), E = new ie(E, _), f.intersects(E);
  }
  e.coerce = d0;
  function d0(f) {
    if (f instanceof K)
      return f;
    if (typeof f != "string")
      return null;
    var E = f.match(l[Hi]);
    return E == null ? null : M1(E[1] + "." + (E[2] || "0") + "." + (E[3] || "0"));
  }
})(Hr, Hr.exports);
var _d = Hr.exports;
function Cd(t, e) {
  return t.replace(/{{([0-9a-zA-Z-_. ]+)}}/g, function(n, r) {
    return typeof e[r] == "number" && isNaN(e[r]) ? "NaN" : JSON.stringify(e[r]);
  }).replace(/{([0-9a-zA-Z-_. ]+)}/g, function(n, r) {
    return e[r];
  });
}
function Nd(t) {
  return t !== null && "" + t == "[object Object]" && t.constructor === Object;
}
function Sd(t, e) {
  if (t.length === 0)
    return "";
  if (t.length === 1)
    return t[0];
  if (t.length === 2)
    return t.join(" " + e + " ");
  if (t.length > 2)
    return t.join(", " + e + " ");
}
function Id(t) {
  return t === null ? "null" : Nd(t) ? "plain object" : Array.isArray(t) ? "array" : t instanceof Date ? "date" : typeof t;
}
function yd(t, e) {
  return Array.isArray(e) ? e.indexOf(t) !== -1 : t in e;
}
function ai(t, e, n) {
  var r, i;
  if (t)
    return !0;
  throw n = n || {}, i = n.errorClass || Error, e = Cd(e, n), r = new i(e), r.attributes = n, r;
}
function Od(t, e, n, r) {
  var i = Id(t);
  r = r || {};
  var s = r.condition || n.indexOf(i) !== -1, a = r.errorMessage || "Parameter `{parameterName}` must be a {expectedTypesMessage}, not {parameterType} `{{parameterValue}}`";
  ai(s, a, {
    errorClass: TypeError,
    expectedTypesMessage: Sd(n, "or"),
    parameterName: e,
    parameterType: i,
    parameterValue: t
  });
}
function vd(t, e, n, r) {
  ai(
    yd(t, e),
    n,
    Object.assign({ errorClass: RangeError }, r)
  );
}
const xd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  assert: ai,
  assertRange: vd,
  assertType: Od
}, Symbol.toStringTag, { value: "Module" })), il = /* @__PURE__ */ Ad(xd);
var dr, fo;
function Rd() {
  if (fo)
    return dr;
  fo = 1;
  let t, e;
  const n = process.env.NODE_ENV === "development";
  n && ({ assert: t, assertType: e } = il);
  function r(i, s, a) {
    if (n)
      try {
        e(i, "poolLimit", ["number"]), e(s, "array", ["array"]), e(a, "iteratorFn", ["function"]);
      } catch (A) {
        return Promise.reject(A);
      }
    let c = 0;
    const l = [], u = [], g = function() {
      if (c === s.length)
        return Promise.resolve();
      const A = s[c++], S = Promise.resolve().then(() => a(A, s));
      l.push(S);
      let C = Promise.resolve();
      if (i <= s.length) {
        const y = S.then(() => u.splice(u.indexOf(y), 1));
        u.push(y), u.length >= i && (C = Promise.race(u));
      }
      return C.then(() => g());
    };
    return g().then(() => Promise.all(l));
  }
  return dr = r, dr;
}
var hr, mo;
function bd() {
  if (mo)
    return hr;
  mo = 1;
  let t, e;
  const n = process.env.NODE_ENV === "development";
  n && ({ assert: t, assertType: e } = il);
  async function r(i, s, a) {
    n && (e(i, "poolLimit", ["number"]), e(s, "array", ["array"]), e(a, "iteratorFn", ["function"]));
    const c = [], l = [];
    for (const u of s) {
      const g = Promise.resolve().then(() => a(u, s));
      if (c.push(g), i <= s.length) {
        const A = g.then(() => l.splice(l.indexOf(A), 1));
        l.push(A), l.length >= i && await Promise.race(l);
      }
    }
    return Promise.all(c);
  }
  return hr = r, hr;
}
var Ln, Ld = _d;
Ld.satisfies(process.version, "<8") ? Ln = Rd() : Ln = bd();
si.exports = Ln;
si.exports.default = Ln;
var Pd = si.exports;
const Md = /* @__PURE__ */ rl(Pd);
G1.add(L0);
const Dd = m.div`
  display: flex;
  flex-flow: column;
`, kd = m.span`
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 8px;
  color: ${d.negativePrimary};
  font-size: 13px;
  line-height: 20px;
`, wd = (t) => Array.isArray(t) ? t.map((e) => /* @__PURE__ */ h(To, { children: e }, e)) : typeof t == "string" ? /* @__PURE__ */ h(To, { children: t }) : null, To = ({ children: t }) => /* @__PURE__ */ h(Z0, { role: "alert", children: /* @__PURE__ */ O(kd, { children: [
  /* @__PURE__ */ h(ge, { icon: "exclamation-circle" }),
  /* @__PURE__ */ h(Pr, { children: H.inputs.dropzone.error() }),
  t
] }) }), Hd = ({ errors: t }) => /* @__PURE__ */ h(Dd, { children: wd(t) }), $d = (t, e, n) => {
  if (t.code === "file-invalid-type") {
    const r = e.join(", ");
    return e.length > 1 ? H.inputs.dropzone.invalidFileTypeMultipleFormats({ fileTypes: r }) : H.inputs.dropzone.invalidFileTypeSingle({ fileTypes: r });
  } else {
    if (t.code === "file-too-large")
      return n ? H.inputs.dropzone.invalidFileSize({ fileSize: n / 1e6 }) : t.message;
    if (t.code === "too-many-files")
      return H.inputs.dropzone.tooManyFiles();
  }
  return t.message;
}, Fd = (t) => (t == null ? void 0 : t.response) !== void 0, Bd = (t, e) => {
  if (t.length === 0)
    return;
  const n = t.join(", "), r = Number((e / 1e6).toFixed(2));
  return H.inputs.dropzone.description({ fileTypes: n, maxFileSizeMB: r });
};
G1.add(aa);
const po = m.div`
  width: 100%;
  max-width: ${({ width: t }) => t ?? "100%"};
  word-break: break-word;
  height: ${({ $coverContainer: t }) => t ? "100%" : "unset"};
`, Eo = m.div`
  border: solid 1px ${d.borderPrimary};
  outline: ${({ $invalid: t }) => t ? `1px solid ${d.negativePrimary}` : "unset"};
  border-radius: 8px;
  height: ${({ $coverContainer: t }) => t ? "100%" : "unset"};
`, Ud = m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 8px;
  background-color: ${d.backgroundPrimary};
  gap: 4px;
  height: ${({ $coverContainer: t }) => t ? "100%" : "unset"};
`, Gd = m.div`
  display: flex;
  justify-content: center;
`, Kd = m.div`
  font-size: 13px;
  line-height: 20px;
  color: ${d.contentSecondary};
`, zd = m.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 20px;
  color: ${d.contentPrimary};
`, Yd = m.span`
  color: ${d.interactivePrimary};
  cursor: pointer;
`, Wd = m.div`
  padding: 16px 16px;
  background-color: ${d.backgroundPrimary};
`, ol = ({
  onDrop: t,
  width: e,
  onError: n,
  label: r,
  error: i,
  accept: s,
  maxSizeInBytes: a,
  multiple: c,
  children: l,
  disabled: u = !1,
  maxFiles: g = 10,
  // Only used if multiple === true
  id: A,
  onStartUploading: S,
  coverContainer: C,
  invalid: y
}) => {
  const [N, v] = V(!1), [X, Z] = V([]), [ae, $] = V([]), te = a ?? 2e7, Se = s.length > 0 ? s : J0, Ae = Bd(Se, te), F = c || !1, J = g === "unlimited" ? void 0 : g;
  Ne(() => {
    const ee = i !== void 0 ? X.concat(i) : X;
    $(ee);
  }, [i, X]);
  const { acceptedFiles: he, getRootProps: p1, getInputProps: Re } = Ta({
    maxFiles: F ? J : 1,
    multiple: c,
    disabled: u || N,
    maxSize: te,
    // Use acceptedFileExtensions once OPEN-398 is addressed. For now, always accept all file types and let the backend reject bad types.
    accept: void 0,
    onDrop: () => {
      Z([]), $([]);
    },
    onDropRejected: (ee) => {
      const Qe = ee[0].errors.map((Be) => $d(Be, s, te));
      Z(Qe);
    },
    onError: (ee) => Z([ee.message])
  });
  return wn(async () => {
    var ee;
    if (he.length === 1 || F && he.length > 0) {
      v(!0), S && S({ totalAccepted: he.length });
      try {
        await Md(10, he, async (Qe) => t(Qe));
      } catch (Qe) {
        const Be = Qe;
        n(Be), Fd(Be) ? Z([((ee = Be.response) == null ? void 0 : ee.data.message) ?? H.inputs.dropzone.genericError()]) : Z([Be.message]);
      }
      v(!1);
    }
  }, [he]), N && !c ? /* @__PURE__ */ h(po, { width: e, $coverContainer: C, children: /* @__PURE__ */ h(Eo, { $coverContainer: C, $invalid: y, children: /* @__PURE__ */ h(Wd, { children: /* @__PURE__ */ h(Va, {}) }) }) }) : /* @__PURE__ */ O(po, { width: e, $coverContainer: C, children: [
    /* @__PURE__ */ O(Eo, { $coverContainer: C, $invalid: y, children: [
      /* @__PURE__ */ O(
        Ud,
        {
          ...p1(),
          $hasErrors: (ae == null ? void 0 : ae.length) >= 1,
          role: "button",
          $coverContainer: C,
          children: [
            /* @__PURE__ */ h(Pr, { children: r }),
            /* @__PURE__ */ h("input", { ...Re(), id: A, "data-testid": A }),
            /* @__PURE__ */ h(Bn, { disabled: u, icon: "upload", onClick: () => {
            }, children: F ? H.inputs.dropzone.chooseFilesButton() : H.inputs.dropzone.chooseFileButton() }),
            /* @__PURE__ */ h(q0.Root, { children: /* @__PURE__ */ O(zd, { children: [
              /* @__PURE__ */ h(Yd, { children: /* @__PURE__ */ h(Pr, { children: H.inputs.dropzone.noFileSelected() }) }),
              /* @__PURE__ */ h(Gd, { children: H.inputs.dropzone.dragDropFile() }),
              Ae && /* @__PURE__ */ h(Kd, { children: Ae })
            ] }) })
          ]
        }
      ),
      l
    ] }),
    !F && X && /* @__PURE__ */ h(Hd, { errors: ae })
  ] });
};
G1.add(la);
const Vd = m.div`
  max-width: ${ce};
  border: 1px solid ${d.borderPrimary};
  border-radius: 8px;
  padding: 16px 16px;
  background-color: ${d.backgroundPrimary};
`;
function G7({
  value: t,
  onChange: e,
  disableRemove: n,
  upload: r,
  tempUrl: i,
  onError: s,
  label: a,
  error: c,
  accept: l,
  maxSizeInBytes: u,
  id: g,
  coverContainer: A,
  invalid: S
}) {
  return t ? /* @__PURE__ */ h(Vd, { children: /* @__PURE__ */ h(
    Ja,
    {
      value: t,
      disableRemove: n,
      onRemove: () => e(null),
      tempUrl: i,
      onError: s
    }
  ) }) : /* @__PURE__ */ h(
    ol,
    {
      label: a,
      width: ce,
      error: c,
      accept: l,
      maxSizeInBytes: u,
      onDrop: async (C) => {
        const y = await r(C);
        e(y);
      },
      onError: s,
      id: g,
      coverContainer: A,
      invalid: S
    }
  );
}
G1.add(la);
const jd = m.div`
  max-width: ${ce};
  background-color: ${d.backgroundPrimary};
  border-radius: 8px;
`, Xd = m.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-top: 0px;
  gap: 16px;
`, Qd = m.div`
  display: flex;
  align-items: center;
  gap: 160x;
`, fr = m.div`
  margin-left: 10px;
`, sl = m.hr`
  border: '1px solid ${d.borderPrimary}';
  margin: 0px;
`;
function K7({
  value: t,
  onChange: e,
  disableRemove: n,
  hideButtons: r,
  upload: i,
  tempUrl: s,
  onError: a,
  label: c,
  error: l,
  accept: u,
  maxSizeInBytes: g,
  maxFiles: A,
  showCount: S = !1,
  id: C,
  invalid: y
}) {
  const [N, { push: v, removeAt: X }] = Xi(t ?? []), [Z, { push: ae, clear: $ }] = Xi([]), [te, { inc: Se, dec: Ae }] = Qi(0), [F, { inc: J, dec: he }] = Qi(N.length);
  return Ne(() => {
    e([...N]);
  }, [N]), /* @__PURE__ */ h(jd, { children: /* @__PURE__ */ h(
    ol,
    {
      multiple: !0,
      label: c,
      width: ce,
      error: l,
      accept: u,
      maxSizeInBytes: g,
      maxFiles: A,
      onDrop: async (Re) => {
        Se();
        try {
          const ee = await i(Re);
          v(ee);
        } catch (ee) {
          throw Ae(), ae(Re), ee;
        }
        Ae();
      },
      onError: a,
      id: C,
      onStartUploading: ({ totalAccepted: Re }) => {
        J(Re), he(Z.length), $();
      },
      invalid: y,
      children: F > 0 && /* @__PURE__ */ O(Xd, { children: [
        S && /* @__PURE__ */ h(Zd, { totalCount: F, completedCount: N.length, failedCount: Z.length }),
        /* @__PURE__ */ h(
          qd,
          {
            uploadingCount: te,
            files: N,
            failedFiles: Z,
            removeAt: X,
            disableRemove: n,
            hideButtons: r,
            tempUrl: s,
            onError: a
          }
        )
      ] })
    }
  ) });
}
function qd({
  files: t,
  uploadingCount: e,
  failedFiles: n,
  disableRemove: r,
  hideButtons: i,
  removeAt: s,
  tempUrl: a,
  onError: c
}) {
  return /* @__PURE__ */ O(x1, { children: [
    /* @__PURE__ */ h(sl, {}),
    t.map((l, u) => /* @__PURE__ */ h(
      Ja,
      {
        value: l,
        disableRemove: r,
        hideButtons: i,
        onRemove: () => s(u),
        tempUrl: a,
        onError: c
      },
      u
    )),
    n.map((l, u) => /* @__PURE__ */ h(K5, { name: l.name }, u)),
    k0(e).map((l) => /* @__PURE__ */ h(Va, {}, l))
  ] });
}
function Zd({
  completedCount: t,
  failedCount: e,
  totalCount: n
}) {
  const r = n - t - e, i = r > 0, s = t > 0, a = e > 0;
  return /* @__PURE__ */ O(x1, { children: [
    /* @__PURE__ */ h(sl, {}),
    /* @__PURE__ */ O(Qd, { children: [
      i ? /* @__PURE__ */ h(K1, {}) : /* @__PURE__ */ h(ge, { icon: "check-circle", size: "lg", color: d.accentCoolGrayPrimary }),
      i && /* @__PURE__ */ h(fr, { children: H.inputs.multipleFile.inProgress({ count: r }) }, "in-progress-count"),
      s && /* @__PURE__ */ h(fr, { children: H.inputs.multipleFile.completed({ count: t }) }, "completed-count"),
      a && /* @__PURE__ */ h(fr, { children: H.inputs.multipleFile.failed({ count: e }) }, "failed-count")
    ] })
  ] });
}
class Jd {
  /**
   * Build a variable picker for the markdown editor toolbar.
   * @param variables Should be a non-empty array (although nothing will break if it's not)
   */
  static build(e) {
    const n = this.buildEntries(e);
    return {
      name: "variables",
      className: "fa fa-caret",
      text: H.inputs.markdown.variables(),
      title: H.inputs.markdown.variablesHint(),
      children: n
    };
  }
  static buildEntries(e) {
    const n = [];
    for (const { key: r, values: i, groupLabel: s } of e) {
      s && n.push({
        name: "group-" + r,
        className: "group-heading",
        action: () => {
        },
        title: s,
        text: s
      });
      for (const { key: a, label: c, insertAs: l, linkLabel: u } of i)
        n.push({
          name: "variable-" + a,
          action: (g) => {
            let A = `{{${a}}}`;
            l === Ji.Link ? A = `[${u || c}](${A})` : l === Ji.Logic && (A = `{{#if (${a})}}True part{{else}}False part{{/if}}`), g.codemirror.replaceSelection(A);
          },
          className: "no-icon",
          title: c,
          text: c
        });
    }
    return n;
  }
}
const al = pe`
  background-color: ${d.backgroundPrimary};
  border: none;
  border-radius: 8px;
  padding: 0px;
  box-shadow: ${We};
  display: flex;
  flex-direction: column;
  height: calc(var(--radix-popover-content-available-height) - 16px);
  max-height: fit-content;
  overflow-y: auto;
`, eh = m(i9)`
  ${al}
`, th = ({ children: t, alignRight: e, className: n, style: r, ...i }) => /* @__PURE__ */ h(eh, { className: n, align: e ? "end" : "start", style: r, ...i, sideOffset: 8, children: t }), nh = ({ isOpen: t, toggle: e, children: n }) => /* @__PURE__ */ h(o9, { open: t, onOpenChange: e, children: n }), go = m.div`
  margin-right: auto;
  display: flex;
  align-items: center;
`, Ao = m(ge)`
  align-self: center;
`, ll = m(pa)`
  border: 0px;
  background-color: ${d.backgroundPrimary};
  cursor: pointer;
  color: ${d.contentPrimary};
  font-weight: 400;
  font-size: 0.94rem;
  border-radius: ${j};
  line-height: 22.5px;
  min-height: 36.5px;
  display: flex;
  width: auto;
  align-items: center;
`, rh = m(ll)`
  ${jt}
  padding: 7px 12px;
  box-shadow: ${We};
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: box-shadow 150ms ease;
  &:hover,
  &:active,
  &:disabled {
    box-shadow: ${ct};
  }
  &:focus {
    outline: none;
  }
`, ih = m(ll)`
  background-color: ${({ isOpen: t }) => t ? d.backgroundTertiary : "transparent"};
  padding: 3px 16px 3px 8px;
  text-align: left;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out;
  &:hover,
  &:active,
  &:disabled {
    background-color: ${d.backgroundTertiary};
  }
`, oh = m.span`
  margin-right: ${({ $hideToggle: t }) => t ? "0px" : "16px"};
`, sh = m.span`
  margin-right: ${({ $hideToggle: t }) => t ? "0px" : "8px"};
`, ah = m(pa)`
  align-items: center;
  background: none;
  padding: 0;
  border: none;
  ${jt}
  box-shadow: ${({ isOpen: t }) => t ? "0 0 0 2px rgb(204 204 204 / 50%)" : "0 0 0 0 transparent"};
  &:focus {
    outline: none;
  }
`, lh = m.div`
  display: flex;
`, ch = ({
  isOpen: t,
  disabled: e,
  width: n,
  customIcon: r,
  icon: i,
  toggleTitle: s,
  toggleStyle: a = "button",
  children: c,
  className: l,
  hideToggle: u,
  ...g
}) => /* @__PURE__ */ h(lh, { children: c ? /* @__PURE__ */ h(ah, { className: l, disabled: e, ...g, children: c }) : a === "text" ? /* @__PURE__ */ O(ih, { className: l, disabled: e, ...g, children: [
  /* @__PURE__ */ O(go, { children: [
    r || i && /* @__PURE__ */ h(U1, { icon: i, marginRight: s ? "8px" : "0px" }),
    s && /* @__PURE__ */ h(sh, { $hideToggle: u, children: s })
  ] }),
  s && !u && /* @__PURE__ */ h(Ao, { icon: t ? "caret-up" : "caret-down" })
] }) : /* @__PURE__ */ O(rh, { className: l, disabled: e, ...g, children: [
  /* @__PURE__ */ O(go, { children: [
    r || i && /* @__PURE__ */ h(U1, { icon: i, marginRight: s ? "8px" : "0px" }),
    s && /* @__PURE__ */ h(oh, { $hideToggle: u, children: s })
  ] }),
  s && !u && /* @__PURE__ */ h(Ao, { icon: t ? "caret-up" : "caret-down" })
] }) }), z7 = ({
  isOpen: t,
  toggle: e,
  toggleButton: n,
  icon: r,
  disabled: i = !1,
  toggleTitle: s,
  toggleStyle: a,
  customIcon: c,
  alignRight: l = !1,
  children: u,
  style: g,
  hideToggle: A,
  ariaLabel: S,
  /**
   * Currently this only works when actions are conditionally rendered from `outside`
   * of the action component. Because we wrap many actions in `withPermissions`,
   * 'inside' each component, filtering out null is not straightforward.
   *
   * todo: Refine this so the Popover is hidden correctly based on actions hidden from `within`
   * as well as from `outside`.
   */
  hideWhenNoChildren: C = !1
}) => {
  const y = N0.toArray(u).length === 0;
  return C && y ? null : /* @__PURE__ */ O(nh, { isOpen: t, toggle: e, children: [
    /* @__PURE__ */ h(
      ch,
      {
        disabled: i,
        isOpen: t,
        customIcon: c,
        icon: r,
        toggleTitle: s,
        toggleStyle: a,
        hideToggle: A,
        "aria-label": S,
        children: n
      }
    ),
    /* @__PURE__ */ h(r9, { children: /* @__PURE__ */ h(th, { alignRight: l, style: { zIndex: b9, ...g }, "aria-label": S, children: u }) })
  ] });
}, uh = m.div`
  text-align: start !important;
`, dh = m.div`
  color: ${d.contentPrimary};
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
  margin-bottom: 5px;
`, hh = m.div`
  color: ${d.contentSecondary};
  font-size: 13px;
  line-height: 22.5px;
  font-weight: 350;
`, cl = ({ title: t, description: e }) => /* @__PURE__ */ O(uh, { children: [
  /* @__PURE__ */ O(dh, { children: [
    " ",
    t
  ] }),
  /* @__PURE__ */ h(hh, { children: e })
] }), fh = m(Xt)`
  padding: 0.5rem 1rem;
  text-align: start;
  white-space: pre-line;
  justify-content: start;
  width: ${({ width: t }) => t || "auto"};
  box-shadow: none !important;
  &:hover {
    background-color: ${d.backgroundSecondary} !important;
  }
  &:focus {
    outline: none;
    box-shadow: none;
  }
  &:focus-visible {
    outline-offset: -2px;
    border-radius: 8px;
  }
  border-radius: unset;
  background-color: ${({ backgroundColor: t }) => t || "unset"};
`, Y7 = ({
  onClick: t,
  title: e,
  icon: n,
  description: r,
  width: i,
  disabled: s,
  iconColor: a,
  validateActionText: c,
  backgroundColor: l
}) => /* @__PURE__ */ h(
  fh,
  {
    iconColor: a,
    disabled: s,
    width: i,
    onClick: () => {
      t();
    },
    icon: n,
    validateActionText: c,
    backgroundColor: l,
    children: r ? /* @__PURE__ */ h(cl, { title: e, description: r }) : e
  }
), mh = m(ei)`
  padding: 0.5rem 1rem;
  text-align: start;
  white-space: pre-line;
  width: ${({ width: t }) => t || "auto"};
  justify-content: start;
  box-shadow: none !important;
  &:hover {
    background-color: ${d.backgroundSecondary} !important;
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline-offset: -2px;
    border-radius: 8px;
  }
`, W7 = ({
  onClick: t,
  title: e,
  icon: n,
  width: r,
  disabled: i,
  description: s,
  iconColor: a,
  validateActionText: c
}) => /* @__PURE__ */ h(
  mh,
  {
    iconColor: a,
    disabled: i,
    width: r,
    onClick: async () => {
      await t();
    },
    icon: n,
    validateActionText: c,
    children: s ? /* @__PURE__ */ h(cl, { title: e, description: s }) : e
  }
), Th = m.div`
  ${({ width: t }) => t ? `width: ${t};` : ""};

  .EasyMDEContainer .CodeMirror {
    border-color: ${d.borderPrimary};
    border-bottom-left-radius: ${j};
    border-bottom-right-radius: ${j};
    padding-top: 0;
    ${({ height: t }) => t ? `height: ${t};` : ""};
  }

  .cm-s-easymde .cm-header-1 {
    font-size: 22px;
  }

  .cm-s-easymde .cm-header-2 {
    font-size: 20px;
  }

  .cm-s-easymde .cm-header-3 {
    font-size: 18px;
  }
  .cm-s-easymde .cm-header-4,
  .cm-s-easymde .cm-header-5,
  .cm-s-easymde .cm-header-6 {
    font-size: 16px;
  }

  .editor-toolbar {
    border-color: ${d.borderPrimary};
    border-top-left-radius: ${j};
    border-top-right-radius: ${j};
    background-color: ${d.backgroundPrimary};

    i.separator {
      border-left-color: ${d.borderPrimary};
    }

    .easymde-dropdown,
    button {
      color: ${d.contentPrimary};
      border-radius: 3px;

      &.active,
      &:hover {
        border-color: ${d.borderPrimary};
      }

      &.variables {
        font-weight: 400;
        font-size: 15px;
        background: none;
        padding: 0 8px;
      }
    }

    .easymde-dropdown-content {
      ${al};
      top: 28px;
      left: 0;
      overflow: auto;
      max-height: 400px;

      button {
        padding: 8px 12px;
        font-weight: 400;
        height: auto;
        border: none;
        text-align: left;

        &:hover {
          background-color: ${d.backgroundPrimaryHover};
        }
      }

      .group-heading {
        user-select: none;
        cursor: default;
        font-size: 13px;
        color: ${d.contentSecondary};
        padding-top: 16px;

        &:hover {
          background-color: initial;
        }
      }
    }
  }
`, ph = (t, e, n) => [
  "bold",
  "italic",
  "heading-1",
  "heading-2",
  "heading-3",
  "|",
  "quote",
  "ordered-list",
  "unordered-list",
  "strikethrough",
  "|",
  "horizontal-rule",
  t ? "upload-image" : "image",
  {
    name: "link",
    action: e9.drawLink,
    className: "fa fa-link",
    title: "Create Web Link"
  },
  ...n ? [
    {
      name: "page break",
      action: (r) => {
        const i = r.codemirror, s = i.getDoc(), a = s.getCursor();
        s.replaceRange(`<br class="page-break" />
`, a), i.focus();
      },
      className: "fa fa-minus-square-o",
      title: "Create a Page Break"
    }
  ] : [],
  ...e != null && e.length ? ["|", Jd.build(e)] : [],
  "|",
  {
    name: "guide",
    action: (r) => window.open("https://help.sparelabs.com/en/articles/8955229-formatting-case-letter-templates", "_blank"),
    className: "fa fa-question-circle",
    title: "formatting guide"
  }
], Eh = {
  status: !1,
  autofocus: !0,
  spellChecker: !1,
  shortcuts: {
    togglePreview: null,
    toggleFullScreen: null
  }
}, V7 = ({
  id: t,
  value: e,
  onChange: n,
  options: r,
  height: i,
  width: s,
  variableDefinitions: a,
  usePageBreak: c
}) => {
  const l = y1(() => {
    const u = ph(r == null ? void 0 : r.uploadImage, a, c);
    return {
      ...Eh,
      toolbar: u,
      ...r
    };
  }, []);
  return /* @__PURE__ */ h(Th, { height: i, width: s, children: /* @__PURE__ */ h(t9, { value: e ?? void 0, onChange: n, options: l, id: t }) });
}, gh = pe`
  color: ${({ badgeTheme: t }) => t.textColor};
  background-color: ${({ badgeTheme: t }) => t.backgroundColor};
  border-radius: 4px;
  outline: ${({ badgeTheme: t }) => t.borderColor ? `1px solid ${t.borderColor}` : "none"};
  outline-offset: ${({ badgeTheme: t }) => t.borderColor ? "-1px" : "none"};
  width: fit-content;
  white-space: nowrap;
  background: ${({ badgeTheme: t }) => t.background};
`, Ah = m.div.withConfig({
  shouldForwardProp: (t) => t !== "badgeTheme"
})`
  ${gh}
  padding: 4px 8px;
  font-size: 13px;
  line-height: 14px;
`, j7 = {
  textColor: d.positiveHighContrast,
  backgroundColor: d.positiveLowContrast,
  hoverBackgroundColor: d.positiveLowContrastHover
}, X7 = {
  textColor: d.interactiveHighContrast,
  backgroundColor: d.interactiveLowContrast,
  hoverBackgroundColor: d.interactiveLowContrastHover
}, Q7 = {
  textColor: d.negativeHighContrast,
  backgroundColor: d.negativeLowContrast,
  hoverBackgroundColor: d.negativeLowContrastHover
}, q7 = {
  textColor: d.warningHighContrast,
  backgroundColor: d.warningLowContrast,
  hoverBackgroundColor: d.warningLowContrastHover
}, Z7 = {
  textColor: d.contentPrimary,
  backgroundColor: d.backgroundTertiary,
  hoverBackgroundColor: d.backgroundTertiaryHover
}, J7 = {
  textColor: d.contentInvertedPrimary,
  backgroundColor: "rgba(0,0,0,0.24)",
  hoverBackgroundColor: "rgba(0,0,0,0.24)"
}, eg = {
  textColor: d.accentGrayHighContrast,
  backgroundColor: d.accentGrayLowContrast,
  hoverBackgroundColor: d.accentGrayLowContrastHover
}, tg = {
  textColor: d.accentPurpleHighContrast,
  backgroundColor: d.accentPurpleLowContrast,
  hoverBackgroundColor: d.accentPurpleLowContrastHover
}, ng = {
  textColor: d.accentCoolGrayHighContrast,
  backgroundColor: d.accentCoolGrayLowContrast,
  hoverBackgroundColor: d.accentCoolGrayLowContrastHover
}, rg = {
  textColor: d.accentCoolGrayHighContrast,
  backgroundColor: d.accentCoolGrayLowContrast,
  hoverBackgroundColor: d.accentCoolGrayLowContrastHover,
  background: ia.ai
}, _h = m(({ maxWidth: t, bannerTheme: e, fontSize: n, ...r }) => /* @__PURE__ */ h("div", { ...r }))`
  max-width: ${(t) => t.maxWidth};
  background-color: ${({ bannerTheme: t }) => t.backgroundColor};
  color: ${({ bannerTheme: t }) => t.textColor};
  border-radius: 8px;
  font-size: ${(t) => t.fontSize};
  padding: 16px;
  gap: 16px;
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-bottom: 8px;
  white-space: pre-line;
  background: ${({ bannerTheme: t }) => t.background};
`, Ch = ({
  bannerTheme: t,
  children: e,
  className: n,
  maxWidth: r = `${x9}px`,
  fontSize: i = "15px"
}) => /* @__PURE__ */ O(_h, { bannerTheme: t, maxWidth: r, fontSize: i, className: n, children: [
  t.icon && /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(U1, { icon: t.icon, color: t.textColor }) }),
  /* @__PURE__ */ h("div", { style: { display: "contents" }, children: e })
] }), ig = {
  backgroundColor: d.interactiveLowContrast,
  textColor: d.interactiveHighContrast,
  icon: "info-circle"
}, og = {
  backgroundColor: d.positiveLowContrast,
  textColor: d.positiveHighContrast,
  icon: "check"
}, sg = {
  backgroundColor: d.negativeLowContrast,
  textColor: d.negativeHighContrast,
  icon: "exclamation-triangle"
}, ag = {
  backgroundColor: d.warningLowContrast,
  textColor: d.warningHighContrast,
  icon: "exclamation-triangle"
}, lg = {
  backgroundColor: d.accentCoolGrayLowContrast,
  textColor: d.accentCoolGrayHighContrast,
  icon: "info-circle"
}, cg = {
  backgroundColor: d.accentGrayLowContrast,
  textColor: d.accentGrayHighContrast,
  icon: "info-circle"
}, ug = {
  backgroundColor: d.accentPurpleLowContrast,
  textColor: d.accentPurpleHighContrast,
  icon: "info-circle"
}, dg = {
  backgroundColor: d.accentPurpleLowContrast,
  background: ia.ai,
  textColor: d.contentPrimary,
  icon: "sparkles"
}, Nh = {
  backgroundColor: d.accentPurpleLowContrast,
  textColor: d.accentPurpleHighContrast,
  icon: "magic"
}, hg = () => /* @__PURE__ */ h(Ch, { bannerTheme: Nh, children: H.foundations.restrictedToRootAdmins() }), Sh = m.div`
  white-space: pre-wrap;
  font-size: 13px;
  color: ${d.contentTertiary};
  font-weight: 400;
  padding: 5px 1px;
  line-height: 20px;
  max-width: ${ce};
`, Ih = m.label`
  display: flex;
  align-items: center;
  margin-bottom: 0;
`, yh = m.span`
  margin-right: 5px;
  margin-bottom: 0px;
`, Oh = m(Fu)`
  margin-right: 5px;
`, vh = m.div`
  margin-left: 4px;
`, xh = (t, e, n) => {
  const r = e || [];
  r.includes(t) ? n(r.filter((i) => i !== t)) : n([...r, t]);
}, ul = ({ values: t, choice: e, containerId: n, onChange: r, readOnly: i, ...s }) => {
  const a = lt(e.value) ? e.value : JSON.stringify(e.value), c = Xr(e.label), l = `${n}_${a}`;
  return /* @__PURE__ */ O(Yt.Fragment, { children: [
    /* @__PURE__ */ O(Ih, { htmlFor: l, children: [
      !i && /* @__PURE__ */ h(
        Oh,
        {
          ...s,
          ...c,
          name: a,
          id: l,
          "aria-label": e.label,
          type: "checkbox",
          readOnly: i,
          disabled: e.disabled,
          checked: (t || []).includes(e.value),
          onChange: () => xh(e.value, t, r)
        }
      ),
      /* @__PURE__ */ h(yh, { className: "multi-choice-label", children: e.label }),
      e.hint && /* @__PURE__ */ h(ft, { content: e.hint }),
      e.badge && /* @__PURE__ */ h(vh, { children: /* @__PURE__ */ h(Ah, { badgeTheme: e.badge.badgeTheme, children: e.badge.children }) })
    ] }),
    e.displayHint && /* @__PURE__ */ O(Sh, { children: [
      " ",
      e.displayHint
    ] })
  ] }, a);
}, Rh = m.div`
  padding-top: 12px;
  line-height: 1;
`, bh = m.div`
  display: grid;
  align-items: top;
  grid-template-columns: 1fr 2fr;
  padding-bottom: 12px;
`, Lh = m.h2`
  font-weight: normal;
  padding-top: 3px;

  // font-size, height and border-bottom set so this appears as a line in the middle of the <h2> tag
  border-bottom: 1px solid ${d.borderPrimary};
  font-size: 15px;
  height: 12px;
`, Ph = m.span`
  padding-right: 4px;
  background: ${({ $backgroundColor: t }) => t || d.backgroundPrimary};
`, Mh = m.span`
  // Setting background so the name covers the line from NameContainer.
  background: ${({ $backgroundColor: t }) => t || d.backgroundPrimary};
  color: ${d.contentSecondary};
  padding-right: 4px;
`, Dh = m.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-left: 8px;
  padding-top: 2px;
  gap: 8px;
`, fg = ({ id: t, groups: e, ...n }) => /* @__PURE__ */ h(Rh, { children: e.map((r) => /* @__PURE__ */ O(bh, { children: [
  /* @__PURE__ */ O(Lh, { children: [
    /* @__PURE__ */ h(Mh, { $backgroundColor: n.backgroundColor, children: r.name }),
    r.hint && /* @__PURE__ */ h(Ph, { $backgroundColor: n.backgroundColor, children: /* @__PURE__ */ h(ft, { content: r.hint }) })
  ] }),
  /* @__PURE__ */ h(Dh, { children: r.choices.map((i) => /* @__PURE__ */ Wr(
    ul,
    {
      ...n,
      choice: i,
      containerId: lt(t) ? t : ut("grouped-multiple-choice-input-"),
      key: lt(i.value) ? i.value : JSON.stringify(i.value)
    }
  )) })
] }, r.name)) }), kh = m.div`
  display: flex;
  flex-direction: ${({ stacked: t }) => t ? "column" : "row"};
  row-gap: 8px;
  column-gap: ${({ compact: t }) => t ? "5px" : "16px"};
  flex-wrap: wrap;
  padding: 8px 0px;
  max-width: ${ce};
  line-height: initial;

  > * {
    margin: 0px;
  }
`, mg = ({
  choices: t,
  groups: e,
  values: n,
  className: r,
  id: i,
  stacked: s,
  compact: a,
  autoFocus: c,
  ...l
}) => {
  const u = lt(i) ? i : ut("multiple-choice-input-");
  return /* @__PURE__ */ h(kh, { className: r, id: u, stacked: s, compact: a, children: t.map((g) => /* @__PURE__ */ Wr(
    ul,
    {
      ...l,
      choice: g,
      values: n,
      containerId: u,
      key: lt(g.value) ? g.value : JSON.stringify(g.value)
    }
  )) });
}, Tg = ({
  label: t,
  value: e,
  onChange: n,
  allowDecimals: r = !1,
  innerRef: i,
  ...s
}) => /* @__PURE__ */ h(
  He,
  {
    ...s,
    innerRef: i,
    "aria-label": t,
    value: (e == null ? void 0 : e.toString()) ?? "",
    onChange: (a) => {
      n(
        a.target.value ? r ? parseFloat(a.target.value) : parseInt(a.target.value) : void 0
      );
    },
    role: "textbox",
    type: "number"
  }
), pg = ({
  label: t,
  value: e,
  onChange: n,
  allowDecimals: r = !1,
  step: i,
  innerRef: s,
  ...a
}) => {
  const [c, l] = V(() => (e == null ? void 0 : e.toString()) ?? ""), u = i ?? (r ? "any" : "1");
  return Ne(() => {
    l((e == null ? void 0 : e.toString()) ?? "");
  }, [e]), /* @__PURE__ */ h(
    He,
    {
      ...a,
      innerRef: s,
      "aria-label": t,
      value: c,
      onChange: (S) => {
        const C = S.target.value;
        if (l(C), C === "" || C === "-") {
          n(void 0);
          return;
        }
        const y = r ? parseFloat(C) : parseInt(C);
        isNaN(y) || n(y);
      },
      onBlur: (S) => {
        const C = S.target.value;
        if (C === "" || C === "-" || C === ".") {
          e != null ? (l(e.toString()), n(e)) : (l(""), n(void 0)), a.onBlur && a.onBlur(S);
          return;
        }
        let y = r ? parseFloat(C) : parseInt(C);
        if (isNaN(y)) {
          e != null ? l(e.toString()) : (l(""), n(void 0)), a.onBlur && a.onBlur(S);
          return;
        }
        if (typeof i == "number" && i > 0) {
          y = Math.round(y / i) * i;
          const X = (i.toString().split(".")[1] || "").length;
          y = parseFloat(y.toFixed(Math.max(X, 10)));
        }
        const N = typeof a.min == "string" ? parseFloat(a.min) : a.min, v = typeof a.max == "string" ? parseFloat(a.max) : a.max;
        N !== void 0 && !isNaN(N) && y < N && (y = N), v !== void 0 && !isNaN(v) && y > v && (y = v), l(y.toString()), n(y), a.onBlur && a.onBlur(S);
      },
      onWheel: (S) => S.currentTarget.blur(),
      role: "textbox",
      type: "number",
      step: u,
      inputMode: r ? "decimal" : "numeric"
    }
  );
}, li = pe`
  background-color: ${d.backgroundPrimary};
  color: ${d.contentPrimary};
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 0 0 1px ${d.borderPrimary} inset;
  padding: 8px;
  font-size: 15px;
  border: none;
  line-height: 1;
  display: flex;
  align-items: center;
  height: ${dt};
`, wh = m(da)`
  max-width: ${ce};
  height: ${dt};
`, Hh = m(He)`
  height: ${dt};
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
`, $h = m.div`
  ${li}
`, Eg = ({
  onChange: t,
  value: e,
  placeholder: n,
  invalid: r,
  unit: i,
  id: s,
  allowDecimals: a = !1,
  ...c
}) => {
  const l = (e == null ? void 0 : e.toString()) ?? "";
  return /* @__PURE__ */ O(wh, { children: [
    /* @__PURE__ */ h(
      Hh,
      {
        ...c,
        role: "textbox",
        type: "number",
        value: l,
        onChange: (u) => {
          const g = u.target.value;
          if (!g) {
            t(void 0);
            return;
          }
          const A = a ? parseFloat(g) : parseInt(g, 10);
          t(A);
        },
        $hasUnits: !0,
        id: s
      }
    ),
    /* @__PURE__ */ h($h, { children: i })
  ] });
}, Fh = m($0)`
  ${li};
  &:active,
  &:not(disabled) {
    background-color: ${d.backgroundPrimary} !important;
    color: ${d.contentPrimary} !important;
    box-shadow: 0 0 0 1px ${d.borderPrimary} inset !important;
    transform: none !important;
  }
  &:focus {
    ${Hn}
  }
  &:hover {
    background-color: ${d.backgroundPrimaryHover} !important;
  }
  &::after {
    margin-left: 8px;
    margin-right: 2px;
    align-items: center;
  }
`, Bh = m(F0)`
  border: none;
  border-radius: 8px;
  padding: 0px;
  margin-top: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  min-width: 0;
`, Uh = m(B0)`
  line-height: ${dt};
  font-size: 15px;
  padding: 0 8px;
  margin: 0;
`, Gh = m.div`
  ${li}
`, Kh = ({ units: t, selectedUnit: e, onChange: n }) => {
  if (!t.length)
    throw new Error("Must provide at least one unit");
  const [r, i] = V(!1);
  return /* @__PURE__ */ h(
    U0,
    {
      addonType: "append",
      isOpen: r,
      toggle: () => i(!r),
      disabled: t.length === 1,
      children: t.length === 1 ? /* @__PURE__ */ h(Gh, { children: e }) : /* @__PURE__ */ O(x1, { children: [
        /* @__PURE__ */ h(Fh, { caret: !0, children: e }),
        /* @__PURE__ */ h(Bh, { children: t.map((a) => /* @__PURE__ */ h(Uh, { onClick: () => n(a), children: a }, a)) })
      ] })
    }
  );
}, zh = m(da)`
  max-width: ${ce};
  height: ${dt};
`, Yh = m(He)`
  height: ${dt};
  border-top-right-radius: ${(t) => t.$hasUnits ? "0 !important" : ""};
  border-bottom-right-radius: ${(t) => t.$hasUnits ? "0 !important" : ""};
`, Wh = (t, e, n) => {
  if (!t)
    return t;
  let r;
  return typeof e == "number" ? r = t / e : r = e.convert(t), n ? r : Math.round(r);
}, Vh = (t, e, n) => {
  if (!t)
    return;
  const r = n ? parseFloat(t) : parseInt(t, 10);
  let i;
  return typeof e == "number" ? i = r * e : typeof e == "string" ? i = r : i = e.invert(r), n ? i : Math.round(i);
}, gg = ({
  onChange: t,
  onUnitChange: e,
  value: n,
  placeholder: r,
  units: i,
  invalid: s,
  defaultUnit: a,
  id: c,
  allowDecimals: l = !1,
  ...u
}) => {
  var N;
  const g = Object.keys(i);
  if (g.length === 0)
    throw new Error("Must provide at least one unit");
  const [A, S] = V((a == null ? void 0 : a(n)) ?? g[0]), C = i[A];
  if (C === void 0 || typeof C == "number" && C < 1 || typeof C == "string" && C.length === 0) {
    const v = typeof C == "object" ? "[UnitConversionFunction]" : String(C);
    throw new Error(`Unit multiplier value of '${v}' for '${A}' must be a positive integer`);
  }
  const y = (typeof C != "string" ? (N = Wh(n, C, l)) == null ? void 0 : N.toString() : n == null ? void 0 : n.toString()) ?? "";
  return /* @__PURE__ */ O(zh, { children: [
    /* @__PURE__ */ h(
      Yh,
      {
        ...u,
        role: "textbox",
        type: "number",
        value: y,
        onChange: (v) => t(Vh(v.target.value, C, l)),
        $hasUnits: !!g.length,
        id: c
      }
    ),
    /* @__PURE__ */ h(
      Kh,
      {
        units: g,
        selectedUnit: A,
        onChange: (v) => {
          e && e(v), S(v);
        }
      }
    )
  ] });
}, Ag = ({
  onChange: t,
  value: e,
  id: n,
  autoFocus: r,
  onSubmit: i,
  onFocus: s,
  onBlur: a,
  inputProps: c,
  className: l,
  readOnly: u,
  invalid: g
}) => {
  const [A, S] = V(!1);
  return /* @__PURE__ */ h(
    a9,
    {
      containerClass: l,
      country: s9.guessCountry(Ft.getCurrentLanguageCode()),
      value: e,
      onChange: (C) => t(C ? `+${C}` : ""),
      onFocus: (C, y) => {
        S(!0), s == null || s(C, y);
      },
      onBlur: (C, y) => {
        S(!1), a == null || a(C, y);
      },
      inputStyle: {
        paddingTop: "0.5em",
        paddingBottom: "0.5em",
        borderRadius: j,
        border: `1px solid ${d.borderPrimary}`,
        backgroundColor: d.backgroundPrimary,
        color: d.contentPrimary,
        maxWidth: "500px",
        width: "100%",
        fontSize: "15px",
        ...A ? {
          outlineColor: d.interactivePrimary,
          outlineStyle: "solid",
          outlineWidth: xn,
          boxShadow: "none"
        } : {},
        ...u ? {
          backgroundColor: d.backgroundTertiary,
          color: d.contentTertiary
        } : {},
        ...g ? {
          outlineColor: d.negativePrimary,
          outlineStyle: "solid",
          outlineWidth: xn
        } : {}
      },
      inputProps: { ...c, id: n, autoFocus: r },
      onEnterKeyPress: i,
      disabled: u
    }
  );
}, jh = pe`
  background-color: ${d.backgroundPrimary};
`, Xh = (t) => pe`
  background-image: url(${t});
`, Qh = pe`
  &:hover {
    box-shadow: ${ct};
  }
`, qh = pe`
  cursor: pointer;
  &:hover {
    background-color: ${d.interactivePrimaryHover};
    color: ${d.contentInvertedPrimary};
  }
`, ci = Wt(({ value: t, loading: e, ...n }, r) => /* @__PURE__ */ h("div", { ref: r, ...n }));
ci.displayName = "CircleDiv";
const Zh = m(ci)`
  height: 100px;
  width: 100px;
  border-radius: 50%;
  border: solid 1px ${d.borderPrimary};
  outline: none;
  background-position: center;
  background-size: cover;
  transition: all 0.3s ease;
  ${({ value: t, loading: e }) => t && !e ? Xh(t) : jh}
  ${({ loading: t }) => t ? "" : Qh}
`, Jh = m(ci)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  padding: 20px;
  background-color: 'transparent';
  transition: all 0.3s ease;
  color: ${({ value: t, loading: e }) => t && !e ? "transparent" : d.contentSecondary};
  ${({ loading: t }) => t ? "" : qh}
`, ef = {
  outlineColor: d.interactivePrimary,
  outlineStyle: "solid",
  outlineWidth: "1.5px"
}, _g = ({ value: t, onChange: e, onError: n, upload: r, id: i }) => {
  const [s, a] = V(!1), { acceptedFiles: c, getRootProps: l, isFileDialogActive: u, isFocused: g, getInputProps: A, isDragActive: S, isDragAccept: C } = Ta({
    maxFiles: 1,
    disabled: s
  }), y = y1(
    () => S || C || u || g ? ef : {},
    [S, C, u, g]
  );
  return wn(async () => {
    if (c.length === 1) {
      a(!0);
      try {
        const { url: N } = await r(c[0]);
        e(N);
      } catch (N) {
        n(N);
      }
      a(!1);
    }
  }, [c]), /* @__PURE__ */ O(Zh, { value: t, loading: s, ...l({ style: y }), children: [
    /* @__PURE__ */ h("input", { ...A(), id: i }),
    /* @__PURE__ */ h(Jh, { value: t, loading: s, children: s ? H.inputs.shared.uploading() : H.inputs.photo.prompt() })
  ] });
}, tf = m.div`
  position: relative;
  max-width: ${ce};
`, nf = m.div`
  color: ${({ valid: t }) => t ? d.interactivePrimary : d.contentTertiary};
  position: absolute;
  top: 50%;
  right: 2em;
  transform: translateY(-50%);
`, rf = (t, e, n) => n1(t) ? eo.format(t, n) : n1(e) ? eo.format(e, n) : "-", Cg = ({
  value: t,
  currency: e,
  invalid: n,
  onChange: r,
  placeholder: i,
  onFocus: s,
  id: a
}) => /* @__PURE__ */ O(tf, { children: [
  /* @__PURE__ */ h(
    He,
    {
      role: "textbox",
      type: "number",
      value: n1(t) ? t : "",
      placeholder: i == null ? void 0 : i.toString(),
      step: 1,
      invalid: n,
      onChange: (c) => {
        const l = parseInt(c.target.value, 10);
        r(n1(l) ? l : void 0);
      },
      onFocus: s,
      id: a
    }
  ),
  /* @__PURE__ */ h(nf, { valid: n1(t), children: rf(t, i, e) })
] }), of = m.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  height: 12px;
  width: 12px;
  background-color: ${d.backgroundPrimary};
  border: 1px solid ${({ invalid: t }) => t ? d.negativePrimary : d.borderPrimary};
  border-radius: 50%;
  display: inline-block;
  position: relative;
  &:invalid {
    border: 1px solid ${d.negativePrimary};
  }
  &:focus {
    ${Hn}
    outline-color: ${(t) => t.invalid ? d.negativePrimary : d.interactivePrimary} !important;
    outline-offset: 1px;
  }
  &:checked {
    background-color: ${(t) => t.invalid ? d.negativePrimary : d.interactivePrimary};
    border-color: ${(t) => t.invalid ? d.negativePrimary : d.interactivePrimary};
  }
  &:checked:after {
    content: ' ';
    border-radius: 50%;
    position: absolute;
    width: 4px;
    height: 4px;
    top: 3px;
    left: 3px;
    background: ${d.contentInvertedPrimary};
  }
`, Ng = m.div`
  display: flex;
  flex-direction: row;
`, sf = m.span`
  color: ${d.contentPrimary};
  padding-left: 10px;
`, Sg = m.label`
  cursor: pointer;
  color: ${d.contentPrimary};
  &:hover {
    color: ${d.interactivePrimary} !important;
  }
  &:hover ${sf} {
    color: ${d.interactivePrimary} !important;
  }
  margin-bottom: 0px;
`, Ig = ({ checked: t, onChange: e, invalid: n, id: r, value: i, ...s }) => /* @__PURE__ */ h(
  of,
  {
    type: "radio",
    checked: t,
    onChange: e,
    invalid: n,
    id: r,
    value: i == null ? "" : i.toString(),
    ...s
  }
), af = 36, lf = 104, dl = m.div`
  display: inline-flex;
  flex-direction: column;
  flex-grow: 0;
  flex-wrap: 1;
  align-items: center;
  height: ${({ size: t }) => `${t}px`};
  width: ${({ size: t }) => `${t}px`};
  text-align: center;
  font-size: 12px;
  line-height: 12px;
  color: ${({ disabled: t }) => t ? d.contentTertiary : d.contentPrimary};
  cursor: ${({ onClick: t, disabled: e }) => e ? "not-allowed" : t ? "pointer" : "default"};
  justify-content: center;
`, cf = m(dl)`
  background-color: ${d.backgroundPrimary};
  border-radius: 5px;
  box-shadow: ${We};
`, uf = ({
  containerSize: t,
  option: e,
  disabled: n,
  renderOption: r,
  isSelected: i,
  onChange: s,
  ...a
}) => {
  const c = Xr(e.value), l = {
    ...a,
    ...c,
    size: t ?? af,
    role: "radio",
    "aria-label": e.value,
    "aria-disabled": !!n,
    disabled: !!n
  }, u = r ? r(e) : e.value;
  return i ? /* @__PURE__ */ h(cf, { ...l, "aria-checked": !0, children: u }) : /* @__PURE__ */ h(dl, { ...l, onClick: () => !n && s && s(e), children: u });
}, df = m.div`
  flex-direction: row;
`, ui = ({
  id: t,
  choices: e,
  value: n,
  onChange: r,
  containerSize: i,
  disabled: s,
  renderOption: a,
  ...c
}) => /* @__PURE__ */ h(df, { role: "radiogroup", id: t, children: e.map((l) => /* @__PURE__ */ Wr(
  uf,
  {
    ...c,
    key: l.value,
    isSelected: l.value === n,
    option: l,
    onChange: r,
    containerSize: i,
    disabled: s || l.disabled,
    renderOption: a
  }
)) }), yg = ({
  iconMap: t,
  onChange: e,
  value: n,
  disabled: r,
  id: i,
  ...s
}) => {
  const a = (c) => /* @__PURE__ */ h(ge, { icon: c });
  return /* @__PURE__ */ h(
    ui,
    {
      ...s,
      choices: Object.entries(t).map(([c, l]) => ({
        value: c,
        icon: l
      })),
      renderOption: (c) => a(c.icon),
      onChange: (c) => e(c.value),
      value: n,
      disabled: r,
      id: i
    }
  );
}, hf = m.div`
  height: 16px;
  width: 16px;
  border-radius: 16px;
  background-color: ${(t) => t.color};
  display: inline-block;
`, Og = ({
  colorChoices: t,
  onChange: e,
  value: n,
  disabled: r,
  id: i,
  ...s
}) => {
  const a = (c) => /* @__PURE__ */ h(hf, { color: c });
  return /* @__PURE__ */ h(
    ui,
    {
      ...s,
      choices: t.map((c) => ({
        value: c
      })),
      renderOption: (c) => a(c.value),
      onChange: (c) => e(c.value),
      value: n,
      disabled: r,
      id: i
    }
  );
}, ff = m(ge)`
  font-size: 24px;
  margin-bottom: 15px;
`, vg = ({
  iconMap: t,
  choices: e,
  onChange: n,
  disabled: r,
  value: i,
  id: s,
  ...a
}) => {
  const c = (l, u) => /* @__PURE__ */ O(x1, { children: [
    /* @__PURE__ */ h(ff, { icon: u }),
    l
  ] });
  return /* @__PURE__ */ h(
    ui,
    {
      ...a,
      choices: e.map((l) => ({
        ...l,
        icon: t[l.value]
      })),
      renderOption: (l) => c(l.label, l.icon),
      disabled: r,
      onChange: (l) => n(l.value),
      containerSize: lf,
      value: i,
      id: s
    }
  );
}, mf = Wt(
  ({
    value: t,
    label: e,
    onChange: n,
    invalid: r,
    placeholder: i,
    id: s,
    maxLengthOption: a,
    style: c,
    disabled: l,
    onKeyDown: u,
    onBlur: g,
    height: A = 200,
    ...S
  }, C) => /* @__PURE__ */ O(x1, { children: [
    /* @__PURE__ */ h(
      He,
      {
        ...S,
        ref: C,
        "aria-label": e,
        type: "textarea",
        value: t ?? "",
        invalid: r,
        onChange: (y) => n(y.target.value),
        style: c ?? { height: A, marginTop: "8px", marginBottom: "7px" },
        placeholder: i,
        disabled: l,
        onKeyDown: u,
        onBlur: g,
        id: s
      }
    ),
    a && /* @__PURE__ */ h(tl, { value: t ?? "", maxLengthOption: a })
  ] })
);
mf.displayName = "TextAreaInput";
const Tf = m.span`
  width: 1500px;
  display: inline-flex;
  align-items: center;
`, pf = m.span`
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  margin-right: 5px;
`, Ef = m.div`
  display: flex;
  width: 100%;
`, xg = ({ value: t, invalid: e, onChange: n, text: r }) => {
  const [i, s] = V(t == null ? void 0 : t.startTs), [a, c] = V(t == null ? void 0 : t.endTs);
  return Ne(() => {
    i !== void 0 && a !== void 0 && n({ startTs: i, endTs: a });
  }, [i, a]), /* @__PURE__ */ O(Ef, { children: [
    r && /* @__PURE__ */ h(Tf, { children: r }),
    /* @__PURE__ */ h(
      He,
      {
        "aria-label": "Time",
        role: "textbox",
        type: "time",
        invalid: e,
        value: i !== void 0 ? kr(i) : void 0,
        onChange: (l) => {
          l.target.value && s(wr(l.target.value));
        }
      }
    ),
    /* @__PURE__ */ h(pf, { children: "-" }),
    /* @__PURE__ */ h(
      He,
      {
        "aria-label": "Time",
        role: "textbox",
        type: "time",
        invalid: e,
        value: a !== void 0 ? kr(a) : void 0,
        onChange: (l) => {
          l.target.value && c(wr(l.target.value));
        }
      }
    )
  ] });
}, Rg = ({ value: t, onChange: e, invalid: n, id: r, ...i }) => /* @__PURE__ */ h(
  bn,
  {
    ...i,
    choices: [
      { value: !0, label: H.inputs.choice.yes() },
      { value: !1, label: H.inputs.choice.no() }
    ],
    value: t,
    invalid: n,
    onChange: e,
    id: r
  }
), bg = m.div`
  display: flex;
  flex-direction: column;
  gap: ${({ gap: t }) => t || "8px"};
`, gf = m.fieldset`
  display: flex;
  flex-direction: row;
  font-size: 15px;
`, Af = m.legend`
  margin-bottom: 4px;
  float: left;
  line-height: 20px;
  font-size: inherit;
  color: ${d.contentSecondary};
  min-width: ${v1}px;
  width: ${v1}px;
  margin-right: ${ht}px;
`, _f = m.div`
  flex-grow: 1;
  overflow-wrap: break-word;
  min-width: 270px;
`, Lg = ({ legend: t, children: e, error: n, containerStyles: r }) => /* @__PURE__ */ O(gf, { style: r, children: [
  /* @__PURE__ */ h(Af, { children: t }),
  /* @__PURE__ */ O(_f, { children: [
    e,
    n && /* @__PURE__ */ h(Fn, { role: "alert", children: n })
  ] })
] }), Cf = m.fieldset`
  display: flex;
  font-size: 15px;
  height: fit-content;
`, Nf = m.legend`
  padding-top: 8px;
  margin-bottom: 0px;
  line-height: 20px;
  font-size: inherit;
  color: ${d.contentSecondary};
  width: auto;
`, Sf = m.div`
  display: flex;
  margin-right: 12px;
  align-items: center;
  height: fit-content;
  min-width: ${v1}px;
  width: ${v1}px;
`, If = m.div`
  flex-grow: 1;
  overflow-wrap: break-word;
  min-width: 270px;
`, yf = m.div`
  margin-top: 8px;
  background-color: ${d.borderPrimary};
  height: 1px;
  flex: 1;
  margin-left: ${ht}px;
`, Pg = ({ legend: t, children: e, error: n, containerStyles: r }) => /* @__PURE__ */ O(Cf, { style: r, children: [
  /* @__PURE__ */ O(Sf, { children: [
    /* @__PURE__ */ h(Nf, { children: t }),
    /* @__PURE__ */ h(yf, {})
  ] }),
  /* @__PURE__ */ O(If, { children: [
    e,
    n && /* @__PURE__ */ h(Fn, { role: "alert", children: n })
  ] })
] }), Mg = m(Qr)`
  max-width: 100%;
  padding-bottom: 16px;
  line-height: 20px;
`, Of = m.div`
  height: 120px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), ${d.backgroundPrimary});
`, vf = m.div`
  max-height: 350px;
  position: relative;
  overflow: hidden;
`, xf = m.div`
  position: relative;
  display: flex;
  gap: 10px;
  flex-direction: column;
`, hl = m.button`
  display: flex;
  justify-content: center;
  position: absolute;
  text-align: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  bottom: 0;
  color: ${d.interactivePrimary};
  gap: 4px;
  background: transparent;
  border: none;

  &:focus {
    outline: none;
  }

  &:hover {
    color: ${d.interactivePrimaryHover};
    cursor: pointer;
  }

  &:hover,
  &:focus {
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), ${d.backgroundSecondary});
  }
`, Rf = m(hl)`
  position: unset;

  &:hover,
  &:focus {
    background: inherit;
  }
`, _o = m(ge)`
  width: 15px;
  height: 15px;
  align-self: center;
`, bf = ({
  children: t,
  showLessButton: e = !1,
  isInitiallyExpanded: n = !1,
  ...r
}) => {
  const [i, s] = V(n), a = () => s(!i);
  return i ? /* @__PURE__ */ O(xf, { children: [
    t,
    e && /* @__PURE__ */ O(Rf, { onClick: a, children: [
      /* @__PURE__ */ h("span", { children: H.showMoreContainer.showLess() }),
      /* @__PURE__ */ h(_o, { icon: "chevron-up", "aria-hidden": !0 })
    ] })
  ] }) : /* @__PURE__ */ O(vf, { ...r, children: [
    /* @__PURE__ */ h(Of, {}),
    t,
    /* @__PURE__ */ O(hl, { onClick: a, children: [
      /* @__PURE__ */ h("span", { children: H.showMoreContainer.showMore() }),
      /* @__PURE__ */ h(_o, { icon: "chevron-down", "aria-hidden": !0 })
    ] })
  ] });
}, Dg = m(bf)`
  border-radius: ${j};
  box-shadow: ${We};
`;
function R1() {
}
R1.prototype = {
  diff: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.callback;
    typeof r == "function" && (i = r, r = {}), this.options = r;
    var s = this;
    function a(N) {
      return i ? (setTimeout(function() {
        i(void 0, N);
      }, 0), !0) : N;
    }
    e = this.castInput(e), n = this.castInput(n), e = this.removeEmpty(this.tokenize(e)), n = this.removeEmpty(this.tokenize(n));
    var c = n.length, l = e.length, u = 1, g = c + l;
    r.maxEditLength && (g = Math.min(g, r.maxEditLength));
    var A = [{
      newPos: -1,
      components: []
    }], S = this.extractCommon(A[0], n, e, 0);
    if (A[0].newPos + 1 >= c && S + 1 >= l)
      return a([{
        value: this.join(n),
        count: n.length
      }]);
    function C() {
      for (var N = -1 * u; N <= u; N += 2) {
        var v = void 0, X = A[N - 1], Z = A[N + 1], ae = (Z ? Z.newPos : 0) - N;
        X && (A[N - 1] = void 0);
        var $ = X && X.newPos + 1 < c, te = Z && 0 <= ae && ae < l;
        if (!$ && !te) {
          A[N] = void 0;
          continue;
        }
        if (!$ || te && X.newPos < Z.newPos ? (v = Pf(Z), s.pushComponent(v.components, void 0, !0)) : (v = X, v.newPos++, s.pushComponent(v.components, !0, void 0)), ae = s.extractCommon(v, n, e, N), v.newPos + 1 >= c && ae + 1 >= l)
          return a(Lf(s, v.components, n, e, s.useLongestToken));
        A[N] = v;
      }
      u++;
    }
    if (i)
      (function N() {
        setTimeout(function() {
          if (u > g)
            return i();
          C() || N();
        }, 0);
      })();
    else
      for (; u <= g; ) {
        var y = C();
        if (y)
          return y;
      }
  },
  pushComponent: function(e, n, r) {
    var i = e[e.length - 1];
    i && i.added === n && i.removed === r ? e[e.length - 1] = {
      count: i.count + 1,
      added: n,
      removed: r
    } : e.push({
      count: 1,
      added: n,
      removed: r
    });
  },
  extractCommon: function(e, n, r, i) {
    for (var s = n.length, a = r.length, c = e.newPos, l = c - i, u = 0; c + 1 < s && l + 1 < a && this.equals(n[c + 1], r[l + 1]); )
      c++, l++, u++;
    return u && e.components.push({
      count: u
    }), e.newPos = c, l;
  },
  equals: function(e, n) {
    return this.options.comparator ? this.options.comparator(e, n) : e === n || this.options.ignoreCase && e.toLowerCase() === n.toLowerCase();
  },
  removeEmpty: function(e) {
    for (var n = [], r = 0; r < e.length; r++)
      e[r] && n.push(e[r]);
    return n;
  },
  castInput: function(e) {
    return e;
  },
  tokenize: function(e) {
    return e.split("");
  },
  join: function(e) {
    return e.join("");
  }
};
function Lf(t, e, n, r, i) {
  for (var s = 0, a = e.length, c = 0, l = 0; s < a; s++) {
    var u = e[s];
    if (u.removed) {
      if (u.value = t.join(r.slice(l, l + u.count)), l += u.count, s && e[s - 1].added) {
        var A = e[s - 1];
        e[s - 1] = e[s], e[s] = A;
      }
    } else {
      if (!u.added && i) {
        var g = n.slice(c, c + u.count);
        g = g.map(function(C, y) {
          var N = r[l + y];
          return N.length > C.length ? N : C;
        }), u.value = t.join(g);
      } else
        u.value = t.join(n.slice(c, c + u.count));
      c += u.count, u.added || (l += u.count);
    }
  }
  var S = e[a - 1];
  return a > 1 && typeof S.value == "string" && (S.added || S.removed) && t.equals("", S.value) && (e[a - 2].value += S.value, e.pop()), e;
}
function Pf(t) {
  return {
    newPos: t.newPos,
    components: t.components.slice(0)
  };
}
function Mf(t, e) {
  if (typeof t == "function")
    e.callback = t;
  else if (t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
var Co = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/, No = /\S/, di = new R1();
di.equals = function(t, e) {
  return this.options.ignoreCase && (t = t.toLowerCase(), e = e.toLowerCase()), t === e || this.options.ignoreWhitespace && !No.test(t) && !No.test(e);
};
di.tokenize = function(t) {
  for (var e = t.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/), n = 0; n < e.length - 1; n++)
    !e[n + 1] && e[n + 2] && Co.test(e[n]) && Co.test(e[n + 2]) && (e[n] += e[n + 2], e.splice(n + 1, 2), n--);
  return e;
};
function Df(t, e, n) {
  return n = Mf(n, {
    ignoreWhitespace: !0
  }), di.diff(t, e, n);
}
var hi = new R1();
hi.tokenize = function(t) {
  var e = [], n = t.split(/(\n|\r\n)/);
  n[n.length - 1] || n.pop();
  for (var r = 0; r < n.length; r++) {
    var i = n[r];
    r % 2 && !this.options.newlineIsToken ? e[e.length - 1] += i : (this.options.ignoreWhitespace && (i = i.trim()), e.push(i));
  }
  return e;
};
function kf(t, e, n) {
  return hi.diff(t, e, n);
}
var wf = new R1();
wf.tokenize = function(t) {
  return t.split(/(\S.+?[.!?])(?=\s+|$)/);
};
var Hf = new R1();
Hf.tokenize = function(t) {
  return t.split(/([{}:;,]|\s+)/);
};
function Sn(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Sn = function(e) {
    return typeof e;
  } : Sn = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Sn(t);
}
var $f = Object.prototype.toString, Gt = new R1();
Gt.useLongestToken = !0;
Gt.tokenize = hi.tokenize;
Gt.castInput = function(t) {
  var e = this.options, n = e.undefinedReplacement, r = e.stringifyReplacer, i = r === void 0 ? function(s, a) {
    return typeof a > "u" ? n : a;
  } : r;
  return typeof t == "string" ? t : JSON.stringify($r(t, null, null, i), i, "  ");
};
Gt.equals = function(t, e) {
  return R1.prototype.equals.call(Gt, t.replace(/,([\r\n])/g, "$1"), e.replace(/,([\r\n])/g, "$1"));
};
function $r(t, e, n, r, i) {
  e = e || [], n = n || [], r && (t = r(i, t));
  var s;
  for (s = 0; s < e.length; s += 1)
    if (e[s] === t)
      return n[s];
  var a;
  if ($f.call(t) === "[object Array]") {
    for (e.push(t), a = new Array(t.length), n.push(a), s = 0; s < t.length; s += 1)
      a[s] = $r(t[s], e, n, r, i);
    return e.pop(), n.pop(), a;
  }
  if (t && t.toJSON && (t = t.toJSON()), Sn(t) === "object" && t !== null) {
    e.push(t), a = {}, n.push(a);
    var c = [], l;
    for (l in t)
      t.hasOwnProperty(l) && c.push(l);
    for (c.sort(), s = 0; s < c.length; s += 1)
      l = c[s], a[l] = $r(t[l], e, n, r, l);
    e.pop(), n.pop();
  } else
    a = t;
  return a;
}
var Fr = new R1();
Fr.tokenize = function(t) {
  return t.slice();
};
Fr.join = Fr.removeEmpty = function(t) {
  return t;
};
var f1 = /* @__PURE__ */ ((t) => (t.Added = "added", t.Removed = "removed", t.Modified = "modified", t.Unchanged = "unchanged", t))(f1 || {});
class Ff {
  /**
   * Utilizing the O(ND) difference algorithm implemented by JSDiff calculates that line and word differences between two strings.
   */
  static calculate(e, n) {
    return this.calculateLineDifferences(e, n).map(this.calculateWordDifferences);
  }
  static calculateLineDifferences(e, n) {
    var s, a, c, l;
    const r = this.diffLinesWrapper(e, n), i = [];
    for (const [u, g] of r.entries()) {
      const A = this.parseLines(g, r[u + 1]);
      if (!(g.added && ((s = r[u - 1]) != null && s.removed)) && (!g.removed && !g.added && i.push(
        ...A.map((S) => ({
          previous: S,
          current: S,
          differenceType: "unchanged"
          /* Unchanged */
        }))
      ), g.removed && !((a = r[u + 1]) != null && a.added) && i.push(
        ...A.map((S) => ({
          previous: S,
          current: "",
          differenceType: "removed"
          /* Removed */
        }))
      ), g.added && !((c = r[u - 1]) != null && c.removed) && i.push(...A.map((S) => ({
        previous: "",
        current: S,
        differenceType: "added"
        /* Added */
      }))), g.removed && ((l = r[u + 1]) != null && l.added))) {
        const S = this.parseLines(r[u + 1], r[u + 2]);
        for (let C = 0; C < Math.max(A.length, S.length); C++)
          i.push({
            previous: A[C] ?? "",
            current: S[C] ?? "",
            differenceType: this.getDifferenceType(A[C], S[C])
          });
      }
    }
    return i;
  }
  static calculateWordDifferences(e) {
    const n = {
      previous: [],
      current: [],
      differenceType: e.differenceType
    }, r = Df(e.previous, e.current, { ignoreWhitespace: !1 });
    for (const i of r)
      i.removed && n.previous.push({ value: i.value, different: !0 }), i.added && n.current.push({ value: i.value, different: !0 }), !i.added && !i.removed && (n.previous.push({ value: i.value, different: !1 }), n.current.push({ value: i.value, different: !1 }));
    return n;
  }
  /**
   * Wrapper around `diffLines` injects missing new line removals and additions.
   */
  static diffLinesWrapper(e, n) {
    var s, a;
    const r = kf(e.trim(), n.trim(), {
      ignoreWhitespace: !1,
      newlineIsToken: !0,
      ignoreCase: !1
    }).filter((c) => {
      const l = c.added || c.removed, u = c.value === `
`;
      return l || !u;
    }), i = [];
    for (const [c, l] of r.entries()) {
      const u = r[c - 1], g = r[c + 1], A = ((s = u == null ? void 0 : u.value) == null ? void 0 : s.endsWith(`
`)) && ((a = g == null ? void 0 : g.value) == null ? void 0 : a.startsWith(`
`));
      l.added && A && i.push({ count: 1, added: void 0, removed: !0, value: `
` }), i.push(l), l.removed && A && i.push({ count: 1, added: !0, removed: void 0, value: `
` });
    }
    return i;
  }
  /**
   * Parses a change value into a list of lines and considers all scenarios where a new line character would cause an unnecessary empty line.
   */
  static parseLines(e, n) {
    const r = e.value.split(`
`), i = e.added || e.removed, s = n === void 0;
    return r.every((a) => a === "") && i ? (r.pop(), r) : (e.value.startsWith(`
`) && (!i || s) && r.shift(), e.value.endsWith(`
`) && r.pop(), r);
  }
  static getDifferenceType(e, n) {
    return e === n ? "unchanged" : e === void 0 ? "added" : n === void 0 ? "removed" : "modified";
  }
}
var ue = /* @__PURE__ */ ((t) => (t.Previous = "previous", t.Current = "current", t))(ue || {});
const s1 = (t, e) => {
  if (!t)
    return !1;
  switch (e) {
    case "previous":
      return [f1.Modified, f1.Removed].includes(t.differenceType);
    case "current":
      return [f1.Modified, f1.Added].includes(t.differenceType);
  }
}, xt = "4px", Br = {
  [ue.Previous]: {
    lineBackground: d.negativeLowContrast,
    itemBackground: d.negativeLowContrastActive,
    text: d.negativeHighContrast
  },
  [ue.Current]: {
    lineBackground: d.positiveLowContrast,
    itemBackground: d.positiveLowContrastActive,
    text: d.positiveHighContrast
  }
}, fl = pe`
  min-height: 20px;
  line-height: 20px;
  font-size: 15px;
`, Bf = m.div`
  border-radius: ${j};
  padding: 16px 8px;
  border: 1px solid ${d.borderPrimary};
  background-color: ${d.backgroundSecondary};
`, So = m.label`
  flex: 50%;
  color: ${d.contentSecondary};
  padding: 0px 8px;
  ${fl}
`, ml = m.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  ${fl}
`, Io = m.div`
  flex: 50%;
  background-color: ${({ different: t, type: e }) => t ? Br[e].lineBackground : ""};
  color: ${({ different: t, type: e }) => t ? Br[e].text : ""};
  padding: 0px 8px;
  border-top-left-radius: ${({ isTop: t }) => t ? xt : ""};
  border-top-right-radius: ${({ isTop: t }) => t ? xt : ""};
  border-bottom-left-radius: ${({ isBottom: t }) => t ? xt : ""};
  border-bottom-right-radius: ${({ isBottom: t }) => t ? xt : ""};
`, yo = m.span`
  background-color: ${({ different: t, type: e }) => t ? Br[e].itemBackground : ""};
  white-space: pre-wrap;
  border-radius: ${xt};
`, Uf = () => /* @__PURE__ */ O(ml, { children: [
  /* @__PURE__ */ h(So, { children: "Previous Value" }),
  /* @__PURE__ */ h(So, { children: "Current Value" })
] }), kg = ({ previous: t, current: e }) => {
  const n = y1(() => Ff.calculate(t, e), [t, e]);
  return /* @__PURE__ */ O(Bf, { children: [
    /* @__PURE__ */ h(Uf, {}),
    n.map((r, i) => /* @__PURE__ */ O(ml, { children: [
      /* @__PURE__ */ h(
        Io,
        {
          different: s1(r, ue.Previous),
          type: ue.Previous,
          isTop: s1(r, ue.Previous) && !s1(n[i - 1], ue.Previous),
          isBottom: s1(r, ue.Previous) && !s1(n[i + 1], ue.Previous),
          children: r.previous.map((s, a) => /* @__PURE__ */ h(
            yo,
            {
              different: s.different && r.differenceType === f1.Modified,
              type: ue.Previous,
              children: s.value
            },
            `${i}-${a}-${ue.Previous}`
          ))
        }
      ),
      /* @__PURE__ */ h(
        Io,
        {
          different: [f1.Modified, f1.Added].includes(r.differenceType),
          type: ue.Current,
          isTop: s1(r, ue.Current) && !s1(n[i - 1], ue.Current),
          isBottom: s1(r, ue.Current) && !s1(n[i + 1], ue.Current),
          children: r.current.map((s, a) => /* @__PURE__ */ h(
            yo,
            {
              different: s.different && r.differenceType === f1.Modified,
              type: ue.Current,
              children: s.value
            },
            `${i}-${a}-${ue.Current}`
          ))
        }
      )
    ] }, i))
  ] });
};
class wg {
  static format(e, n, r) {
    const i = (r == null ? void 0 : r.includeUnchangedValues) ?? !0, s = {}, a = qi([...Object.keys(e), ...Object.keys(n)]);
    for (const c of a) {
      const l = this.toString(e[c]), u = this.toString(n[c]);
      this.isDifferent(l, u) ? s[c] = {
        previous: l,
        current: u
      } : i && (s[c] = e[c]);
    }
    return s;
  }
  static getDifferences(e, n) {
    const r = {}, i = qi([...Object.keys(e), ...Object.keys(n)]);
    for (const s of i) {
      const a = e[s], c = n[s];
      ca(a, c) || (r[s] = {
        previous: a,
        current: c
      });
    }
    return r;
  }
  static toString(e) {
    return vn(e) ? JSON.stringify(e, null, 2) : Array.isArray(e) ? e.map((n) => vn(n) ? JSON.stringify(n) : Zi(n)).join(", ") : Zi(e);
  }
  static isDifferent(e, n) {
    return e.trim() !== n.trim();
  }
}
const Hg = (t) => vn(t) && Object.keys(t).every((e) => ["previous", "current"].includes(e) && lt(t[e])), $g = (t) => vn(t) && Object.keys(t).every((e) => e === "current" || e === "previous"), Tl = 14 * Vt, pl = "autoSave:";
class Gf {
  constructor(e) {
    this.debouncedSave = l9((n, r) => {
      try {
        const i = {
          data: n,
          expiry: Lt.getNowTs() + r
        };
        localStorage.setItem(this.key, JSON.stringify(i));
      } catch (i) {
        console.error("[AutoSave] Error saving data", i);
      }
    }, 500), this.key = `${pl}${e}`;
  }
  load() {
    const e = this.loadWrappedData();
    return (e == null ? void 0 : e.data) ?? null;
  }
  loadWrappedData() {
    const e = localStorage.getItem(this.key);
    if (!e)
      return null;
    try {
      const n = JSON.parse(e);
      if (n.expiry > Lt.getNowTs())
        return n;
    } catch {
      console.error("[AutoSave] Error loading auto save data. Existing data:", e);
    }
    return localStorage.removeItem(this.key), null;
  }
  save(e, n = Tl) {
    this.debouncedSave(e, n);
  }
  clear() {
    this.debouncedSave.cancel(), localStorage.removeItem(this.key);
  }
}
const Fg = ({
  key: t,
  initialValue: e,
  expiry: n = Tl,
  onLoad: r,
  isEmpty: i = () => !1
}) => {
  const [s, a] = V(e), c = y1(() => {
    const g = new Gf(t), A = g.load();
    return !A || i(A) ? (g.clear(), a(e)) : (r == null || r(), a(A)), g;
  }, [t]);
  return [s, (g) => a((A) => {
    const S = typeof g == "function" ? g(A) : g;
    return i(S) ? c.clear() : c.save(S, n), S;
  }), () => {
    c.clear();
  }];
}, Kf = 7 * Vt;
class Ur {
  static run() {
    localStorage.setItem(this.STORAGE_KEY, Lt.getNowTs().toString());
    const e = Object.keys(localStorage);
    for (const n of e)
      n.startsWith(pl) && this.shouldClearKey(n) && localStorage.removeItem(n);
  }
  static shouldClearKey(e) {
    const n = localStorage.getItem(e);
    if (!n)
      return !0;
    try {
      return JSON.parse(n).expiry < Lt.getNowTs();
    } catch {
      return console.error("[AutoSave] Error checking auto save data. Existing data:", n), !0;
    }
  }
  static shouldRun() {
    const e = Number(localStorage.getItem(this.STORAGE_KEY));
    return isNaN(e) ? !0 : Lt.getNowTs() - e > Kf;
  }
}
Ur.STORAGE_KEY = "autoSaveCleanUp:lastRun";
const Bg = () => {
  Ne(() => {
    Ur.shouldRun() && Ur.run();
  }, []);
}, zf = 100, Yf = () => {
  const [t, e] = V(null), [n, r] = V(0), i = n1(t), s = () => {
    e(Date.now()), r(0);
  }, a = () => {
    e(null), r(0);
  };
  return g0(() => i && r(Date.now() - t), i ? zf : null), { time: n, start: s, stop: a };
}, Ug = ({ time: t, start: e = !1 }) => {
  const n = Yf(), r = n.time > 0, i = () => {
    n.start();
  }, s = () => {
    n.stop();
  };
  return A0(() => {
    e && i();
  }), Ne(() => {
    n.time >= t && s();
  }, [n.time]), {
    timeRemaining: r ? Math.max(t - n.time, 0) : 0,
    start: i,
    stop: s
  };
}, Gg = m.div`
  .mapboxgl-ctrl-bottom-left,
  .mapboxgl-ctrl-bottom-right {
    display: none !important;
  }

  @media only percy {
    display: none;
  }
`;
var Ve = {};
const Wf = [
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
];
Ve.REPLACEMENT_CHARACTER = "�";
Ve.CODE_POINTS = {
  EOF: -1,
  NULL: 0,
  TABULATION: 9,
  CARRIAGE_RETURN: 13,
  LINE_FEED: 10,
  FORM_FEED: 12,
  SPACE: 32,
  EXCLAMATION_MARK: 33,
  QUOTATION_MARK: 34,
  NUMBER_SIGN: 35,
  AMPERSAND: 38,
  APOSTROPHE: 39,
  HYPHEN_MINUS: 45,
  SOLIDUS: 47,
  DIGIT_0: 48,
  DIGIT_9: 57,
  SEMICOLON: 59,
  LESS_THAN_SIGN: 60,
  EQUALS_SIGN: 61,
  GREATER_THAN_SIGN: 62,
  QUESTION_MARK: 63,
  LATIN_CAPITAL_A: 65,
  LATIN_CAPITAL_F: 70,
  LATIN_CAPITAL_X: 88,
  LATIN_CAPITAL_Z: 90,
  RIGHT_SQUARE_BRACKET: 93,
  GRAVE_ACCENT: 96,
  LATIN_SMALL_A: 97,
  LATIN_SMALL_F: 102,
  LATIN_SMALL_X: 120,
  LATIN_SMALL_Z: 122,
  REPLACEMENT_CHARACTER: 65533
};
Ve.CODE_POINT_SEQUENCES = {
  DASH_DASH_STRING: [45, 45],
  //--
  DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
  //DOCTYPE
  CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
  //[CDATA[
  SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
  //script
  PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
  //PUBLIC
  SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
  //SYSTEM
};
Ve.isSurrogate = function(t) {
  return t >= 55296 && t <= 57343;
};
Ve.isSurrogatePair = function(t) {
  return t >= 56320 && t <= 57343;
};
Ve.getSurrogatePairCodePoint = function(t, e) {
  return (t - 55296) * 1024 + 9216 + e;
};
Ve.isControlCodePoint = function(t) {
  return t !== 32 && t !== 10 && t !== 13 && t !== 9 && t !== 12 && t >= 1 && t <= 31 || t >= 127 && t <= 159;
};
Ve.isUndefinedCodePoint = function(t) {
  return t >= 64976 && t <= 65007 || Wf.indexOf(t) > -1;
};
var fi = {
  controlCharacterInInputStream: "control-character-in-input-stream",
  noncharacterInInputStream: "noncharacter-in-input-stream",
  surrogateInInputStream: "surrogate-in-input-stream",
  nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
  endTagWithAttributes: "end-tag-with-attributes",
  endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
  unexpectedSolidusInTag: "unexpected-solidus-in-tag",
  unexpectedNullCharacter: "unexpected-null-character",
  unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
  invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
  unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
  missingEndTagName: "missing-end-tag-name",
  unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
  unknownNamedCharacterReference: "unknown-named-character-reference",
  missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
  unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
  unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
  eofBeforeTagName: "eof-before-tag-name",
  eofInTag: "eof-in-tag",
  missingAttributeValue: "missing-attribute-value",
  missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
  missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
  missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
  missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
  missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
  missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
  missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
  abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
  abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
  cdataInHtmlContent: "cdata-in-html-content",
  incorrectlyOpenedComment: "incorrectly-opened-comment",
  eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
  eofInDoctype: "eof-in-doctype",
  nestedComment: "nested-comment",
  abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
  eofInComment: "eof-in-comment",
  incorrectlyClosedComment: "incorrectly-closed-comment",
  eofInCdata: "eof-in-cdata",
  absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
  nullCharacterReference: "null-character-reference",
  surrogateCharacterReference: "surrogate-character-reference",
  characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
  controlCharacterReference: "control-character-reference",
  noncharacterCharacterReference: "noncharacter-character-reference",
  missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
  missingDoctypeName: "missing-doctype-name",
  invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
  duplicateAttribute: "duplicate-attribute",
  nonConformingDoctype: "non-conforming-doctype",
  missingDoctype: "missing-doctype",
  misplacedDoctype: "misplaced-doctype",
  endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
  closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
  disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
  openElementsLeftAfterEof: "open-elements-left-after-eof",
  abandonedHeadElementChild: "abandoned-head-element-child",
  misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
  nestedNoscriptInHead: "nested-noscript-in-head",
  eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};
const tt = Ve, mr = fi, D1 = tt.CODE_POINTS, Vf = 65536;
let jf = class {
  constructor() {
    this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Vf;
  }
  _err() {
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(e) {
    if (this.pos !== this.lastCharPos) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (tt.isSurrogatePair(n))
        return this.pos++, this._addGap(), tt.getSurrogatePairCodePoint(e, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, D1.EOF;
    return this._err(mr.surrogateInInputStream), e;
  }
  dropParsedChunk() {
    this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
  }
  write(e, n) {
    this.html ? this.html += e : this.html = e, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(e) {
    this.html = this.html.substring(0, this.pos + 1) + e + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
  }
  advance() {
    if (this.pos++, this.pos > this.lastCharPos)
      return this.endOfChunkHit = !this.lastChunkWritten, D1.EOF;
    let e = this.html.charCodeAt(this.pos);
    return this.skipNextNewLine && e === D1.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : e === D1.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, D1.LINE_FEED) : (this.skipNextNewLine = !1, tt.isSurrogate(e) && (e = this._processSurrogate(e)), e > 31 && e < 127 || e === D1.LINE_FEED || e === D1.CARRIAGE_RETURN || e > 159 && e < 64976 || this._checkForProblematicCharacters(e), e);
  }
  _checkForProblematicCharacters(e) {
    tt.isControlCodePoint(e) ? this._err(mr.controlCharacterInInputStream) : tt.isUndefinedCodePoint(e) && this._err(mr.noncharacterInInputStream);
  }
  retreat() {
    this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
  }
};
var Xf = jf, Qf = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);
const qf = Xf, Q = Ve, B1 = Qf, I = fi, T = Q.CODE_POINTS, k1 = Q.CODE_POINT_SEQUENCES, Zf = {
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, El = 1, gl = 2, Al = 4, Jf = El | gl | Al, U = "DATA_STATE", nt = "RCDATA_STATE", Rt = "RAWTEXT_STATE", h1 = "SCRIPT_DATA_STATE", _l = "PLAINTEXT_STATE", Oo = "TAG_OPEN_STATE", vo = "END_TAG_OPEN_STATE", Tr = "TAG_NAME_STATE", xo = "RCDATA_LESS_THAN_SIGN_STATE", Ro = "RCDATA_END_TAG_OPEN_STATE", bo = "RCDATA_END_TAG_NAME_STATE", Lo = "RAWTEXT_LESS_THAN_SIGN_STATE", Po = "RAWTEXT_END_TAG_OPEN_STATE", Mo = "RAWTEXT_END_TAG_NAME_STATE", Do = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", ko = "SCRIPT_DATA_END_TAG_OPEN_STATE", wo = "SCRIPT_DATA_END_TAG_NAME_STATE", Ho = "SCRIPT_DATA_ESCAPE_START_STATE", $o = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", Ue = "SCRIPT_DATA_ESCAPED_STATE", Fo = "SCRIPT_DATA_ESCAPED_DASH_STATE", pr = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", on = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", Bo = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", Uo = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", Go = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", a1 = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", Ko = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", zo = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", sn = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", Yo = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", Je = "BEFORE_ATTRIBUTE_NAME_STATE", an = "ATTRIBUTE_NAME_STATE", Er = "AFTER_ATTRIBUTE_NAME_STATE", gr = "BEFORE_ATTRIBUTE_VALUE_STATE", ln = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", cn = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", un = "ATTRIBUTE_VALUE_UNQUOTED_STATE", Ar = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", g1 = "SELF_CLOSING_START_TAG_STATE", _t = "BOGUS_COMMENT_STATE", Wo = "MARKUP_DECLARATION_OPEN_STATE", Vo = "COMMENT_START_STATE", jo = "COMMENT_START_DASH_STATE", A1 = "COMMENT_STATE", Xo = "COMMENT_LESS_THAN_SIGN_STATE", Qo = "COMMENT_LESS_THAN_SIGN_BANG_STATE", qo = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", Zo = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", dn = "COMMENT_END_DASH_STATE", hn = "COMMENT_END_STATE", Jo = "COMMENT_END_BANG_STATE", es = "DOCTYPE_STATE", fn = "BEFORE_DOCTYPE_NAME_STATE", mn = "DOCTYPE_NAME_STATE", ts = "AFTER_DOCTYPE_NAME_STATE", ns = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", rs = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", _r = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", Cr = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", Nr = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", is = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", os = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", ss = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", Ct = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", Nt = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", Sr = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", l1 = "BOGUS_DOCTYPE_STATE", Tn = "CDATA_SECTION_STATE", as = "CDATA_SECTION_BRACKET_STATE", ls = "CDATA_SECTION_END_STATE", Z1 = "CHARACTER_REFERENCE_STATE", cs = "NAMED_CHARACTER_REFERENCE_STATE", us = "AMBIGUOS_AMPERSAND_STATE", ds = "NUMERIC_CHARACTER_REFERENCE_STATE", hs = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", fs = "DECIMAL_CHARACTER_REFERENCE_START_STATE", ms = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", Ts = "DECIMAL_CHARACTER_REFERENCE_STATE", St = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
function ne(t) {
  return t === T.SPACE || t === T.LINE_FEED || t === T.TABULATION || t === T.FORM_FEED;
}
function Pt(t) {
  return t >= T.DIGIT_0 && t <= T.DIGIT_9;
}
function Ge(t) {
  return t >= T.LATIN_CAPITAL_A && t <= T.LATIN_CAPITAL_Z;
}
function $1(t) {
  return t >= T.LATIN_SMALL_A && t <= T.LATIN_SMALL_Z;
}
function N1(t) {
  return $1(t) || Ge(t);
}
function Ir(t) {
  return N1(t) || Pt(t);
}
function Cl(t) {
  return t >= T.LATIN_CAPITAL_A && t <= T.LATIN_CAPITAL_F;
}
function Nl(t) {
  return t >= T.LATIN_SMALL_A && t <= T.LATIN_SMALL_F;
}
function e4(t) {
  return Pt(t) || Cl(t) || Nl(t);
}
function In(t) {
  return t + 32;
}
function oe(t) {
  return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode(t >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | t & 1023));
}
function _1(t) {
  return String.fromCharCode(In(t));
}
function ps(t, e) {
  const n = B1[++t];
  let r = ++t, i = r + n - 1;
  for (; r <= i; ) {
    const s = r + i >>> 1, a = B1[s];
    if (a < e)
      r = s + 1;
    else if (a > e)
      i = s - 1;
    else
      return B1[s + n];
  }
  return -1;
}
let $e = class ye {
  constructor() {
    this.preprocessor = new qf(), this.tokenQueue = [], this.allowCDATA = !1, this.state = U, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
  }
  //Errors
  _err() {
  }
  _errOnNextCodePoint(e) {
    this._consume(), this._err(e), this._unconsume();
  }
  //API
  getNextToken() {
    for (; !this.tokenQueue.length && this.active; ) {
      this.consumedAfterSnapshot = 0;
      const e = this._consume();
      this._ensureHibernation() || this[this.state](e);
    }
    return this.tokenQueue.shift();
  }
  write(e, n) {
    this.active = !0, this.preprocessor.write(e, n);
  }
  insertHtmlAtCurrentPos(e) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(e);
  }
  //Hibernation
  _ensureHibernation() {
    if (this.preprocessor.endOfChunkHit) {
      for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
        this.preprocessor.retreat();
      return this.active = !1, this.tokenQueue.push({ type: ye.HIBERNATION_TOKEN }), !0;
    }
    return !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume() {
    this.consumedAfterSnapshot--, this.preprocessor.retreat();
  }
  _reconsumeInState(e) {
    this.state = e, this._unconsume();
  }
  _consumeSequenceIfMatch(e, n, r) {
    let i = 0, s = !0;
    const a = e.length;
    let c = 0, l = n, u;
    for (; c < a; c++) {
      if (c > 0 && (l = this._consume(), i++), l === T.EOF) {
        s = !1;
        break;
      }
      if (u = e[c], l !== u && (r || l !== In(u))) {
        s = !1;
        break;
      }
    }
    if (!s)
      for (; i--; )
        this._unconsume();
    return s;
  }
  //Temp buffer
  _isTempBufferEqualToScriptString() {
    if (this.tempBuff.length !== k1.SCRIPT_STRING.length)
      return !1;
    for (let e = 0; e < this.tempBuff.length; e++)
      if (this.tempBuff[e] !== k1.SCRIPT_STRING[e])
        return !1;
    return !0;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: ye.START_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: []
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: ye.END_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      attrs: []
    };
  }
  _createCommentToken() {
    this.currentToken = {
      type: ye.COMMENT_TOKEN,
      data: ""
    };
  }
  _createDoctypeToken(e) {
    this.currentToken = {
      type: ye.DOCTYPE_TOKEN,
      name: e,
      forceQuirks: !1,
      publicId: null,
      systemId: null
    };
  }
  _createCharacterToken(e, n) {
    this.currentCharacterToken = {
      type: e,
      chars: n
    };
  }
  _createEOFToken() {
    this.currentToken = { type: ye.EOF_TOKEN };
  }
  //Tag attributes
  _createAttr(e) {
    this.currentAttr = {
      name: e,
      value: ""
    };
  }
  _leaveAttrName(e) {
    ye.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(I.duplicateAttribute), this.state = e;
  }
  _leaveAttrValue(e) {
    this.state = e;
  }
  //Token emission
  _emitCurrentToken() {
    this._emitCurrentCharacterToken();
    const e = this.currentToken;
    this.currentToken = null, e.type === ye.START_TAG_TOKEN ? this.lastStartTagName = e.tagName : e.type === ye.END_TAG_TOKEN && (e.attrs.length > 0 && this._err(I.endTagWithAttributes), e.selfClosing && this._err(I.endTagWithTrailingSolidus)), this.tokenQueue.push(e);
  }
  _emitCurrentCharacterToken() {
    this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
  }
  _emitEOFToken() {
    this._createEOFToken(), this._emitCurrentToken();
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(e, n) {
    this.currentCharacterToken && this.currentCharacterToken.type !== e && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += n : this._createCharacterToken(e, n);
  }
  _emitCodePoint(e) {
    let n = ye.CHARACTER_TOKEN;
    ne(e) ? n = ye.WHITESPACE_CHARACTER_TOKEN : e === T.NULL && (n = ye.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(n, oe(e));
  }
  _emitSeveralCodePoints(e) {
    for (let n = 0; n < e.length; n++)
      this._emitCodePoint(e[n]);
  }
  //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
  //So we can avoid additional checks here.
  _emitChars(e) {
    this._appendCharToCurrentCharacterToken(ye.CHARACTER_TOKEN, e);
  }
  // Character reference helpers
  _matchNamedCharacterReference(e) {
    let n = null, r = 1, i = ps(0, e);
    for (this.tempBuff.push(e); i > -1; ) {
      const s = B1[i], a = s < Jf;
      a && s & El && (n = s & gl ? [B1[++i], B1[++i]] : [B1[++i]], r = 0);
      const l = this._consume();
      if (this.tempBuff.push(l), r++, l === T.EOF)
        break;
      a ? i = s & Al ? ps(i, l) : -1 : i = l === s ? ++i : -1;
    }
    for (; r--; )
      this.tempBuff.pop(), this._unconsume();
    return n;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === ln || this.returnState === cn || this.returnState === un;
  }
  _isCharacterReferenceAttributeQuirk(e) {
    if (!e && this._isCharacterReferenceInAttribute()) {
      const n = this._consume();
      return this._unconsume(), n === T.EQUALS_SIGN || Ir(n);
    }
    return !1;
  }
  _flushCodePointsConsumedAsCharacterReference() {
    if (this._isCharacterReferenceInAttribute())
      for (let e = 0; e < this.tempBuff.length; e++)
        this.currentAttr.value += oe(this.tempBuff[e]);
    else
      this._emitSeveralCodePoints(this.tempBuff);
    this.tempBuff = [];
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  [U](e) {
    this.preprocessor.dropParsedChunk(), e === T.LESS_THAN_SIGN ? this.state = Oo : e === T.AMPERSAND ? (this.returnState = U, this.state = Z1) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this._emitCodePoint(e)) : e === T.EOF ? this._emitEOFToken() : this._emitCodePoint(e);
  }
  //  RCDATA state
  //------------------------------------------------------------------
  [nt](e) {
    this.preprocessor.dropParsedChunk(), e === T.AMPERSAND ? (this.returnState = nt, this.state = Z1) : e === T.LESS_THAN_SIGN ? this.state = xo : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? this._emitEOFToken() : this._emitCodePoint(e);
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  [Rt](e) {
    this.preprocessor.dropParsedChunk(), e === T.LESS_THAN_SIGN ? this.state = Lo : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? this._emitEOFToken() : this._emitCodePoint(e);
  }
  // Script data state
  //------------------------------------------------------------------
  [h1](e) {
    this.preprocessor.dropParsedChunk(), e === T.LESS_THAN_SIGN ? this.state = Do : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? this._emitEOFToken() : this._emitCodePoint(e);
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  [_l](e) {
    this.preprocessor.dropParsedChunk(), e === T.NULL ? (this._err(I.unexpectedNullCharacter), this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? this._emitEOFToken() : this._emitCodePoint(e);
  }
  // Tag open state
  //------------------------------------------------------------------
  [Oo](e) {
    e === T.EXCLAMATION_MARK ? this.state = Wo : e === T.SOLIDUS ? this.state = vo : N1(e) ? (this._createStartTagToken(), this._reconsumeInState(Tr)) : e === T.QUESTION_MARK ? (this._err(I.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState(_t)) : e === T.EOF ? (this._err(I.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(I.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(U));
  }
  // End tag open state
  //------------------------------------------------------------------
  [vo](e) {
    N1(e) ? (this._createEndTagToken(), this._reconsumeInState(Tr)) : e === T.GREATER_THAN_SIGN ? (this._err(I.missingEndTagName), this.state = U) : e === T.EOF ? (this._err(I.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(I.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState(_t));
  }
  // Tag name state
  //------------------------------------------------------------------
  [Tr](e) {
    ne(e) ? this.state = Je : e === T.SOLIDUS ? this.state = g1 : e === T.GREATER_THAN_SIGN ? (this.state = U, this._emitCurrentToken()) : Ge(e) ? this.currentToken.tagName += _1(e) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentToken.tagName += Q.REPLACEMENT_CHARACTER) : e === T.EOF ? (this._err(I.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += oe(e);
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  [xo](e) {
    e === T.SOLIDUS ? (this.tempBuff = [], this.state = Ro) : (this._emitChars("<"), this._reconsumeInState(nt));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  [Ro](e) {
    N1(e) ? (this._createEndTagToken(), this._reconsumeInState(bo)) : (this._emitChars("</"), this._reconsumeInState(nt));
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  [bo](e) {
    if (Ge(e))
      this.currentToken.tagName += _1(e), this.tempBuff.push(e);
    else if ($1(e))
      this.currentToken.tagName += oe(e), this.tempBuff.push(e);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (ne(e)) {
          this.state = Je;
          return;
        }
        if (e === T.SOLIDUS) {
          this.state = g1;
          return;
        }
        if (e === T.GREATER_THAN_SIGN) {
          this.state = U, this._emitCurrentToken();
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(nt);
    }
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  [Lo](e) {
    e === T.SOLIDUS ? (this.tempBuff = [], this.state = Po) : (this._emitChars("<"), this._reconsumeInState(Rt));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  [Po](e) {
    N1(e) ? (this._createEndTagToken(), this._reconsumeInState(Mo)) : (this._emitChars("</"), this._reconsumeInState(Rt));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  [Mo](e) {
    if (Ge(e))
      this.currentToken.tagName += _1(e), this.tempBuff.push(e);
    else if ($1(e))
      this.currentToken.tagName += oe(e), this.tempBuff.push(e);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (ne(e)) {
          this.state = Je;
          return;
        }
        if (e === T.SOLIDUS) {
          this.state = g1;
          return;
        }
        if (e === T.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = U;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Rt);
    }
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  [Do](e) {
    e === T.SOLIDUS ? (this.tempBuff = [], this.state = ko) : e === T.EXCLAMATION_MARK ? (this.state = Ho, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState(h1));
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  [ko](e) {
    N1(e) ? (this._createEndTagToken(), this._reconsumeInState(wo)) : (this._emitChars("</"), this._reconsumeInState(h1));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  [wo](e) {
    if (Ge(e))
      this.currentToken.tagName += _1(e), this.tempBuff.push(e);
    else if ($1(e))
      this.currentToken.tagName += oe(e), this.tempBuff.push(e);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (ne(e)) {
          this.state = Je;
          return;
        } else if (e === T.SOLIDUS) {
          this.state = g1;
          return;
        } else if (e === T.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = U;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(h1);
    }
  }
  // Script data escape start state
  //------------------------------------------------------------------
  [Ho](e) {
    e === T.HYPHEN_MINUS ? (this.state = $o, this._emitChars("-")) : this._reconsumeInState(h1);
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  [$o](e) {
    e === T.HYPHEN_MINUS ? (this.state = pr, this._emitChars("-")) : this._reconsumeInState(h1);
  }
  // Script data escaped state
  //------------------------------------------------------------------
  [Ue](e) {
    e === T.HYPHEN_MINUS ? (this.state = Fo, this._emitChars("-")) : e === T.LESS_THAN_SIGN ? this.state = on : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? (this._err(I.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(e);
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  [Fo](e) {
    e === T.HYPHEN_MINUS ? (this.state = pr, this._emitChars("-")) : e === T.LESS_THAN_SIGN ? this.state = on : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.state = Ue, this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? (this._err(I.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = Ue, this._emitCodePoint(e));
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  [pr](e) {
    e === T.HYPHEN_MINUS ? this._emitChars("-") : e === T.LESS_THAN_SIGN ? this.state = on : e === T.GREATER_THAN_SIGN ? (this.state = h1, this._emitChars(">")) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.state = Ue, this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? (this._err(I.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = Ue, this._emitCodePoint(e));
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  [on](e) {
    e === T.SOLIDUS ? (this.tempBuff = [], this.state = Bo) : N1(e) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(Go)) : (this._emitChars("<"), this._reconsumeInState(Ue));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  [Bo](e) {
    N1(e) ? (this._createEndTagToken(), this._reconsumeInState(Uo)) : (this._emitChars("</"), this._reconsumeInState(Ue));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  [Uo](e) {
    if (Ge(e))
      this.currentToken.tagName += _1(e), this.tempBuff.push(e);
    else if ($1(e))
      this.currentToken.tagName += oe(e), this.tempBuff.push(e);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (ne(e)) {
          this.state = Je;
          return;
        }
        if (e === T.SOLIDUS) {
          this.state = g1;
          return;
        }
        if (e === T.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = U;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Ue);
    }
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  [Go](e) {
    ne(e) || e === T.SOLIDUS || e === T.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? a1 : Ue, this._emitCodePoint(e)) : Ge(e) ? (this.tempBuff.push(In(e)), this._emitCodePoint(e)) : $1(e) ? (this.tempBuff.push(e), this._emitCodePoint(e)) : this._reconsumeInState(Ue);
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  [a1](e) {
    e === T.HYPHEN_MINUS ? (this.state = Ko, this._emitChars("-")) : e === T.LESS_THAN_SIGN ? (this.state = sn, this._emitChars("<")) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? (this._err(I.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(e);
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  [Ko](e) {
    e === T.HYPHEN_MINUS ? (this.state = zo, this._emitChars("-")) : e === T.LESS_THAN_SIGN ? (this.state = sn, this._emitChars("<")) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.state = a1, this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? (this._err(I.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = a1, this._emitCodePoint(e));
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  [zo](e) {
    e === T.HYPHEN_MINUS ? this._emitChars("-") : e === T.LESS_THAN_SIGN ? (this.state = sn, this._emitChars("<")) : e === T.GREATER_THAN_SIGN ? (this.state = h1, this._emitChars(">")) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.state = a1, this._emitChars(Q.REPLACEMENT_CHARACTER)) : e === T.EOF ? (this._err(I.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = a1, this._emitCodePoint(e));
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  [sn](e) {
    e === T.SOLIDUS ? (this.tempBuff = [], this.state = Yo, this._emitChars("/")) : this._reconsumeInState(a1);
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  [Yo](e) {
    ne(e) || e === T.SOLIDUS || e === T.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? Ue : a1, this._emitCodePoint(e)) : Ge(e) ? (this.tempBuff.push(In(e)), this._emitCodePoint(e)) : $1(e) ? (this.tempBuff.push(e), this._emitCodePoint(e)) : this._reconsumeInState(a1);
  }
  // Before attribute name state
  //------------------------------------------------------------------
  [Je](e) {
    ne(e) || (e === T.SOLIDUS || e === T.GREATER_THAN_SIGN || e === T.EOF ? this._reconsumeInState(Er) : e === T.EQUALS_SIGN ? (this._err(I.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = an) : (this._createAttr(""), this._reconsumeInState(an)));
  }
  // Attribute name state
  //------------------------------------------------------------------
  [an](e) {
    ne(e) || e === T.SOLIDUS || e === T.GREATER_THAN_SIGN || e === T.EOF ? (this._leaveAttrName(Er), this._unconsume()) : e === T.EQUALS_SIGN ? this._leaveAttrName(gr) : Ge(e) ? this.currentAttr.name += _1(e) : e === T.QUOTATION_MARK || e === T.APOSTROPHE || e === T.LESS_THAN_SIGN ? (this._err(I.unexpectedCharacterInAttributeName), this.currentAttr.name += oe(e)) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentAttr.name += Q.REPLACEMENT_CHARACTER) : this.currentAttr.name += oe(e);
  }
  // After attribute name state
  //------------------------------------------------------------------
  [Er](e) {
    ne(e) || (e === T.SOLIDUS ? this.state = g1 : e === T.EQUALS_SIGN ? this.state = gr : e === T.GREATER_THAN_SIGN ? (this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(an)));
  }
  // Before attribute value state
  //------------------------------------------------------------------
  [gr](e) {
    ne(e) || (e === T.QUOTATION_MARK ? this.state = ln : e === T.APOSTROPHE ? this.state = cn : e === T.GREATER_THAN_SIGN ? (this._err(I.missingAttributeValue), this.state = U, this._emitCurrentToken()) : this._reconsumeInState(un));
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  [ln](e) {
    e === T.QUOTATION_MARK ? this.state = Ar : e === T.AMPERSAND ? (this.returnState = ln, this.state = Z1) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentAttr.value += Q.REPLACEMENT_CHARACTER) : e === T.EOF ? (this._err(I.eofInTag), this._emitEOFToken()) : this.currentAttr.value += oe(e);
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  [cn](e) {
    e === T.APOSTROPHE ? this.state = Ar : e === T.AMPERSAND ? (this.returnState = cn, this.state = Z1) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentAttr.value += Q.REPLACEMENT_CHARACTER) : e === T.EOF ? (this._err(I.eofInTag), this._emitEOFToken()) : this.currentAttr.value += oe(e);
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  [un](e) {
    ne(e) ? this._leaveAttrValue(Je) : e === T.AMPERSAND ? (this.returnState = un, this.state = Z1) : e === T.GREATER_THAN_SIGN ? (this._leaveAttrValue(U), this._emitCurrentToken()) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentAttr.value += Q.REPLACEMENT_CHARACTER) : e === T.QUOTATION_MARK || e === T.APOSTROPHE || e === T.LESS_THAN_SIGN || e === T.EQUALS_SIGN || e === T.GRAVE_ACCENT ? (this._err(I.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += oe(e)) : e === T.EOF ? (this._err(I.eofInTag), this._emitEOFToken()) : this.currentAttr.value += oe(e);
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  [Ar](e) {
    ne(e) ? this._leaveAttrValue(Je) : e === T.SOLIDUS ? this._leaveAttrValue(g1) : e === T.GREATER_THAN_SIGN ? (this._leaveAttrValue(U), this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInTag), this._emitEOFToken()) : (this._err(I.missingWhitespaceBetweenAttributes), this._reconsumeInState(Je));
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  [g1](e) {
    e === T.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInTag), this._emitEOFToken()) : (this._err(I.unexpectedSolidusInTag), this._reconsumeInState(Je));
  }
  // Bogus comment state
  //------------------------------------------------------------------
  [_t](e) {
    e === T.GREATER_THAN_SIGN ? (this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentToken.data += Q.REPLACEMENT_CHARACTER) : this.currentToken.data += oe(e);
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  [Wo](e) {
    this._consumeSequenceIfMatch(k1.DASH_DASH_STRING, e, !0) ? (this._createCommentToken(), this.state = Vo) : this._consumeSequenceIfMatch(k1.DOCTYPE_STRING, e, !1) ? this.state = es : this._consumeSequenceIfMatch(k1.CDATA_START_STRING, e, !0) ? this.allowCDATA ? this.state = Tn : (this._err(I.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = _t) : this._ensureHibernation() || (this._err(I.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState(_t));
  }
  // Comment start state
  //------------------------------------------------------------------
  [Vo](e) {
    e === T.HYPHEN_MINUS ? this.state = jo : e === T.GREATER_THAN_SIGN ? (this._err(I.abruptClosingOfEmptyComment), this.state = U, this._emitCurrentToken()) : this._reconsumeInState(A1);
  }
  // Comment start dash state
  //------------------------------------------------------------------
  [jo](e) {
    e === T.HYPHEN_MINUS ? this.state = hn : e === T.GREATER_THAN_SIGN ? (this._err(I.abruptClosingOfEmptyComment), this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(A1));
  }
  // Comment state
  //------------------------------------------------------------------
  [A1](e) {
    e === T.HYPHEN_MINUS ? this.state = dn : e === T.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = Xo) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentToken.data += Q.REPLACEMENT_CHARACTER) : e === T.EOF ? (this._err(I.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += oe(e);
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  [Xo](e) {
    e === T.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = Qo) : e === T.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(A1);
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  [Qo](e) {
    e === T.HYPHEN_MINUS ? this.state = qo : this._reconsumeInState(A1);
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  [qo](e) {
    e === T.HYPHEN_MINUS ? this.state = Zo : this._reconsumeInState(dn);
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  [Zo](e) {
    e !== T.GREATER_THAN_SIGN && e !== T.EOF && this._err(I.nestedComment), this._reconsumeInState(hn);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  [dn](e) {
    e === T.HYPHEN_MINUS ? this.state = hn : e === T.EOF ? (this._err(I.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(A1));
  }
  // Comment end state
  //------------------------------------------------------------------
  [hn](e) {
    e === T.GREATER_THAN_SIGN ? (this.state = U, this._emitCurrentToken()) : e === T.EXCLAMATION_MARK ? this.state = Jo : e === T.HYPHEN_MINUS ? this.currentToken.data += "-" : e === T.EOF ? (this._err(I.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(A1));
  }
  // Comment end bang state
  //------------------------------------------------------------------
  [Jo](e) {
    e === T.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = dn) : e === T.GREATER_THAN_SIGN ? (this._err(I.incorrectlyClosedComment), this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(A1));
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  [es](e) {
    ne(e) ? this.state = fn : e === T.GREATER_THAN_SIGN ? this._reconsumeInState(fn) : e === T.EOF ? (this._err(I.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(I.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(fn));
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  [fn](e) {
    ne(e) || (Ge(e) ? (this._createDoctypeToken(_1(e)), this.state = mn) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this._createDoctypeToken(Q.REPLACEMENT_CHARACTER), this.state = mn) : e === T.GREATER_THAN_SIGN ? (this._err(I.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = U) : e === T.EOF ? (this._err(I.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(oe(e)), this.state = mn));
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  [mn](e) {
    ne(e) ? this.state = ts : e === T.GREATER_THAN_SIGN ? (this.state = U, this._emitCurrentToken()) : Ge(e) ? this.currentToken.name += _1(e) : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentToken.name += Q.REPLACEMENT_CHARACTER) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += oe(e);
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  [ts](e) {
    ne(e) || (e === T.GREATER_THAN_SIGN ? (this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(k1.PUBLIC_STRING, e, !1) ? this.state = ns : this._consumeSequenceIfMatch(k1.SYSTEM_STRING, e, !1) ? this.state = os : this._ensureHibernation() || (this._err(I.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(l1)));
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  [ns](e) {
    ne(e) ? this.state = rs : e === T.QUOTATION_MARK ? (this._err(I.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = _r) : e === T.APOSTROPHE ? (this._err(I.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Cr) : e === T.GREATER_THAN_SIGN ? (this._err(I.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(I.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(l1));
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  [rs](e) {
    ne(e) || (e === T.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = _r) : e === T.APOSTROPHE ? (this.currentToken.publicId = "", this.state = Cr) : e === T.GREATER_THAN_SIGN ? (this._err(I.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(I.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(l1)));
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  [_r](e) {
    e === T.QUOTATION_MARK ? this.state = Nr : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentToken.publicId += Q.REPLACEMENT_CHARACTER) : e === T.GREATER_THAN_SIGN ? (this._err(I.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = U) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += oe(e);
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  [Cr](e) {
    e === T.APOSTROPHE ? this.state = Nr : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentToken.publicId += Q.REPLACEMENT_CHARACTER) : e === T.GREATER_THAN_SIGN ? (this._err(I.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = U) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += oe(e);
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  [Nr](e) {
    ne(e) ? this.state = is : e === T.GREATER_THAN_SIGN ? (this.state = U, this._emitCurrentToken()) : e === T.QUOTATION_MARK ? (this._err(I.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = Ct) : e === T.APOSTROPHE ? (this._err(I.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = Nt) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(I.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(l1));
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  [is](e) {
    ne(e) || (e === T.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = U) : e === T.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = Ct) : e === T.APOSTROPHE ? (this.currentToken.systemId = "", this.state = Nt) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(I.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(l1)));
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  [os](e) {
    ne(e) ? this.state = ss : e === T.QUOTATION_MARK ? (this._err(I.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = Ct) : e === T.APOSTROPHE ? (this._err(I.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = Nt) : e === T.GREATER_THAN_SIGN ? (this._err(I.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(I.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(l1));
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  [ss](e) {
    ne(e) || (e === T.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = Ct) : e === T.APOSTROPHE ? (this.currentToken.systemId = "", this.state = Nt) : e === T.GREATER_THAN_SIGN ? (this._err(I.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = U, this._emitCurrentToken()) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(I.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(l1)));
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  [Ct](e) {
    e === T.QUOTATION_MARK ? this.state = Sr : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentToken.systemId += Q.REPLACEMENT_CHARACTER) : e === T.GREATER_THAN_SIGN ? (this._err(I.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = U) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += oe(e);
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  [Nt](e) {
    e === T.APOSTROPHE ? this.state = Sr : e === T.NULL ? (this._err(I.unexpectedNullCharacter), this.currentToken.systemId += Q.REPLACEMENT_CHARACTER) : e === T.GREATER_THAN_SIGN ? (this._err(I.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = U) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += oe(e);
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  [Sr](e) {
    ne(e) || (e === T.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = U) : e === T.EOF ? (this._err(I.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(I.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(l1)));
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  [l1](e) {
    e === T.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = U) : e === T.NULL ? this._err(I.unexpectedNullCharacter) : e === T.EOF && (this._emitCurrentToken(), this._emitEOFToken());
  }
  // CDATA section state
  //------------------------------------------------------------------
  [Tn](e) {
    e === T.RIGHT_SQUARE_BRACKET ? this.state = as : e === T.EOF ? (this._err(I.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(e);
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  [as](e) {
    e === T.RIGHT_SQUARE_BRACKET ? this.state = ls : (this._emitChars("]"), this._reconsumeInState(Tn));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  [ls](e) {
    e === T.GREATER_THAN_SIGN ? this.state = U : e === T.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(Tn));
  }
  // Character reference state
  //------------------------------------------------------------------
  [Z1](e) {
    this.tempBuff = [T.AMPERSAND], e === T.NUMBER_SIGN ? (this.tempBuff.push(e), this.state = ds) : Ir(e) ? this._reconsumeInState(cs) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Named character reference state
  //------------------------------------------------------------------
  [cs](e) {
    const n = this._matchNamedCharacterReference(e);
    if (this._ensureHibernation())
      this.tempBuff = [T.AMPERSAND];
    else if (n) {
      const r = this.tempBuff[this.tempBuff.length - 1] === T.SEMICOLON;
      this._isCharacterReferenceAttributeQuirk(r) || (r || this._errOnNextCodePoint(I.missingSemicolonAfterCharacterReference), this.tempBuff = n), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
    } else
      this._flushCodePointsConsumedAsCharacterReference(), this.state = us;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  [us](e) {
    Ir(e) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += oe(e) : this._emitCodePoint(e) : (e === T.SEMICOLON && this._err(I.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  [ds](e) {
    this.charRefCode = 0, e === T.LATIN_SMALL_X || e === T.LATIN_CAPITAL_X ? (this.tempBuff.push(e), this.state = hs) : this._reconsumeInState(fs);
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  [hs](e) {
    e4(e) ? this._reconsumeInState(ms) : (this._err(I.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Decimal character reference start state
  //------------------------------------------------------------------
  [fs](e) {
    Pt(e) ? this._reconsumeInState(Ts) : (this._err(I.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  [ms](e) {
    Cl(e) ? this.charRefCode = this.charRefCode * 16 + e - 55 : Nl(e) ? this.charRefCode = this.charRefCode * 16 + e - 87 : Pt(e) ? this.charRefCode = this.charRefCode * 16 + e - 48 : e === T.SEMICOLON ? this.state = St : (this._err(I.missingSemicolonAfterCharacterReference), this._reconsumeInState(St));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  [Ts](e) {
    Pt(e) ? this.charRefCode = this.charRefCode * 10 + e - 48 : e === T.SEMICOLON ? this.state = St : (this._err(I.missingSemicolonAfterCharacterReference), this._reconsumeInState(St));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  [St]() {
    if (this.charRefCode === T.NULL)
      this._err(I.nullCharacterReference), this.charRefCode = T.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(I.characterReferenceOutsideUnicodeRange), this.charRefCode = T.REPLACEMENT_CHARACTER;
    else if (Q.isSurrogate(this.charRefCode))
      this._err(I.surrogateCharacterReference), this.charRefCode = T.REPLACEMENT_CHARACTER;
    else if (Q.isUndefinedCodePoint(this.charRefCode))
      this._err(I.noncharacterCharacterReference);
    else if (Q.isControlCodePoint(this.charRefCode) || this.charRefCode === T.CARRIAGE_RETURN) {
      this._err(I.controlCharacterReference);
      const e = Zf[this.charRefCode];
      e && (this.charRefCode = e);
    }
    this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
  }
};
$e.CHARACTER_TOKEN = "CHARACTER_TOKEN";
$e.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
$e.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
$e.START_TAG_TOKEN = "START_TAG_TOKEN";
$e.END_TAG_TOKEN = "END_TAG_TOKEN";
$e.COMMENT_TOKEN = "COMMENT_TOKEN";
$e.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
$e.EOF_TOKEN = "EOF_TOKEN";
$e.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
$e.MODE = {
  DATA: U,
  RCDATA: nt,
  RAWTEXT: Rt,
  SCRIPT_DATA: h1,
  PLAINTEXT: _l
};
$e.getTokenAttr = function(t, e) {
  for (let n = t.attrs.length - 1; n >= 0; n--)
    if (t.attrs[n].name === e)
      return t.attrs[n].value;
  return null;
};
var Un = $e, je = {};
const yr = je.NAMESPACES = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATHML: "http://www.w3.org/1998/Math/MathML",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
};
je.ATTRS = {
  TYPE: "type",
  ACTION: "action",
  ENCODING: "encoding",
  PROMPT: "prompt",
  NAME: "name",
  COLOR: "color",
  FACE: "face",
  SIZE: "size"
};
je.DOCUMENT_MODE = {
  NO_QUIRKS: "no-quirks",
  QUIRKS: "quirks",
  LIMITED_QUIRKS: "limited-quirks"
};
const R = je.TAG_NAMES = {
  A: "a",
  ADDRESS: "address",
  ANNOTATION_XML: "annotation-xml",
  APPLET: "applet",
  AREA: "area",
  ARTICLE: "article",
  ASIDE: "aside",
  B: "b",
  BASE: "base",
  BASEFONT: "basefont",
  BGSOUND: "bgsound",
  BIG: "big",
  BLOCKQUOTE: "blockquote",
  BODY: "body",
  BR: "br",
  BUTTON: "button",
  CAPTION: "caption",
  CENTER: "center",
  CODE: "code",
  COL: "col",
  COLGROUP: "colgroup",
  DD: "dd",
  DESC: "desc",
  DETAILS: "details",
  DIALOG: "dialog",
  DIR: "dir",
  DIV: "div",
  DL: "dl",
  DT: "dt",
  EM: "em",
  EMBED: "embed",
  FIELDSET: "fieldset",
  FIGCAPTION: "figcaption",
  FIGURE: "figure",
  FONT: "font",
  FOOTER: "footer",
  FOREIGN_OBJECT: "foreignObject",
  FORM: "form",
  FRAME: "frame",
  FRAMESET: "frameset",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  HEAD: "head",
  HEADER: "header",
  HGROUP: "hgroup",
  HR: "hr",
  HTML: "html",
  I: "i",
  IMG: "img",
  IMAGE: "image",
  INPUT: "input",
  IFRAME: "iframe",
  KEYGEN: "keygen",
  LABEL: "label",
  LI: "li",
  LINK: "link",
  LISTING: "listing",
  MAIN: "main",
  MALIGNMARK: "malignmark",
  MARQUEE: "marquee",
  MATH: "math",
  MENU: "menu",
  META: "meta",
  MGLYPH: "mglyph",
  MI: "mi",
  MO: "mo",
  MN: "mn",
  MS: "ms",
  MTEXT: "mtext",
  NAV: "nav",
  NOBR: "nobr",
  NOFRAMES: "noframes",
  NOEMBED: "noembed",
  NOSCRIPT: "noscript",
  OBJECT: "object",
  OL: "ol",
  OPTGROUP: "optgroup",
  OPTION: "option",
  P: "p",
  PARAM: "param",
  PLAINTEXT: "plaintext",
  PRE: "pre",
  RB: "rb",
  RP: "rp",
  RT: "rt",
  RTC: "rtc",
  RUBY: "ruby",
  S: "s",
  SCRIPT: "script",
  SECTION: "section",
  SELECT: "select",
  SOURCE: "source",
  SMALL: "small",
  SPAN: "span",
  STRIKE: "strike",
  STRONG: "strong",
  STYLE: "style",
  SUB: "sub",
  SUMMARY: "summary",
  SUP: "sup",
  TABLE: "table",
  TBODY: "tbody",
  TEMPLATE: "template",
  TEXTAREA: "textarea",
  TFOOT: "tfoot",
  TD: "td",
  TH: "th",
  THEAD: "thead",
  TITLE: "title",
  TR: "tr",
  TRACK: "track",
  TT: "tt",
  U: "u",
  UL: "ul",
  SVG: "svg",
  VAR: "var",
  WBR: "wbr",
  XMP: "xmp"
};
je.SPECIAL_ELEMENTS = {
  [yr.HTML]: {
    [R.ADDRESS]: !0,
    [R.APPLET]: !0,
    [R.AREA]: !0,
    [R.ARTICLE]: !0,
    [R.ASIDE]: !0,
    [R.BASE]: !0,
    [R.BASEFONT]: !0,
    [R.BGSOUND]: !0,
    [R.BLOCKQUOTE]: !0,
    [R.BODY]: !0,
    [R.BR]: !0,
    [R.BUTTON]: !0,
    [R.CAPTION]: !0,
    [R.CENTER]: !0,
    [R.COL]: !0,
    [R.COLGROUP]: !0,
    [R.DD]: !0,
    [R.DETAILS]: !0,
    [R.DIR]: !0,
    [R.DIV]: !0,
    [R.DL]: !0,
    [R.DT]: !0,
    [R.EMBED]: !0,
    [R.FIELDSET]: !0,
    [R.FIGCAPTION]: !0,
    [R.FIGURE]: !0,
    [R.FOOTER]: !0,
    [R.FORM]: !0,
    [R.FRAME]: !0,
    [R.FRAMESET]: !0,
    [R.H1]: !0,
    [R.H2]: !0,
    [R.H3]: !0,
    [R.H4]: !0,
    [R.H5]: !0,
    [R.H6]: !0,
    [R.HEAD]: !0,
    [R.HEADER]: !0,
    [R.HGROUP]: !0,
    [R.HR]: !0,
    [R.HTML]: !0,
    [R.IFRAME]: !0,
    [R.IMG]: !0,
    [R.INPUT]: !0,
    [R.LI]: !0,
    [R.LINK]: !0,
    [R.LISTING]: !0,
    [R.MAIN]: !0,
    [R.MARQUEE]: !0,
    [R.MENU]: !0,
    [R.META]: !0,
    [R.NAV]: !0,
    [R.NOEMBED]: !0,
    [R.NOFRAMES]: !0,
    [R.NOSCRIPT]: !0,
    [R.OBJECT]: !0,
    [R.OL]: !0,
    [R.P]: !0,
    [R.PARAM]: !0,
    [R.PLAINTEXT]: !0,
    [R.PRE]: !0,
    [R.SCRIPT]: !0,
    [R.SECTION]: !0,
    [R.SELECT]: !0,
    [R.SOURCE]: !0,
    [R.STYLE]: !0,
    [R.SUMMARY]: !0,
    [R.TABLE]: !0,
    [R.TBODY]: !0,
    [R.TD]: !0,
    [R.TEMPLATE]: !0,
    [R.TEXTAREA]: !0,
    [R.TFOOT]: !0,
    [R.TH]: !0,
    [R.THEAD]: !0,
    [R.TITLE]: !0,
    [R.TR]: !0,
    [R.TRACK]: !0,
    [R.UL]: !0,
    [R.WBR]: !0,
    [R.XMP]: !0
  },
  [yr.MATHML]: {
    [R.MI]: !0,
    [R.MO]: !0,
    [R.MN]: !0,
    [R.MS]: !0,
    [R.MTEXT]: !0,
    [R.ANNOTATION_XML]: !0
  },
  [yr.SVG]: {
    [R.TITLE]: !0,
    [R.FOREIGN_OBJECT]: !0,
    [R.DESC]: !0
  }
};
const Sl = je, b = Sl.TAG_NAMES, q = Sl.NAMESPACES;
function Es(t) {
  switch (t.length) {
    case 1:
      return t === b.P;
    case 2:
      return t === b.RB || t === b.RP || t === b.RT || t === b.DD || t === b.DT || t === b.LI;
    case 3:
      return t === b.RTC;
    case 6:
      return t === b.OPTION;
    case 8:
      return t === b.OPTGROUP;
  }
  return !1;
}
function t4(t) {
  switch (t.length) {
    case 1:
      return t === b.P;
    case 2:
      return t === b.RB || t === b.RP || t === b.RT || t === b.DD || t === b.DT || t === b.LI || t === b.TD || t === b.TH || t === b.TR;
    case 3:
      return t === b.RTC;
    case 5:
      return t === b.TBODY || t === b.TFOOT || t === b.THEAD;
    case 6:
      return t === b.OPTION;
    case 7:
      return t === b.CAPTION;
    case 8:
      return t === b.OPTGROUP || t === b.COLGROUP;
  }
  return !1;
}
function pn(t, e) {
  switch (t.length) {
    case 2:
      if (t === b.TD || t === b.TH)
        return e === q.HTML;
      if (t === b.MI || t === b.MO || t === b.MN || t === b.MS)
        return e === q.MATHML;
      break;
    case 4:
      if (t === b.HTML)
        return e === q.HTML;
      if (t === b.DESC)
        return e === q.SVG;
      break;
    case 5:
      if (t === b.TABLE)
        return e === q.HTML;
      if (t === b.MTEXT)
        return e === q.MATHML;
      if (t === b.TITLE)
        return e === q.SVG;
      break;
    case 6:
      return (t === b.APPLET || t === b.OBJECT) && e === q.HTML;
    case 7:
      return (t === b.CAPTION || t === b.MARQUEE) && e === q.HTML;
    case 8:
      return t === b.TEMPLATE && e === q.HTML;
    case 13:
      return t === b.FOREIGN_OBJECT && e === q.SVG;
    case 14:
      return t === b.ANNOTATION_XML && e === q.MATHML;
  }
  return !1;
}
let n4 = class {
  constructor(e, n) {
    this.stackTop = -1, this.items = [], this.current = e, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = n;
  }
  //Index of element
  _indexOf(e) {
    let n = -1;
    for (let r = this.stackTop; r >= 0; r--)
      if (this.items[r] === e) {
        n = r;
        break;
      }
    return n;
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagName === b.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === q.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
  }
  //Mutations
  push(e) {
    this.items[++this.stackTop] = e, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
  }
  pop() {
    this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
  }
  replace(e, n) {
    const r = this._indexOf(e);
    this.items[r] = n, r === this.stackTop && this._updateCurrentElement();
  }
  insertAfter(e, n) {
    const r = this._indexOf(e) + 1;
    this.items.splice(r, 0, n), r === ++this.stackTop && this._updateCurrentElement();
  }
  popUntilTagNamePopped(e) {
    for (; this.stackTop > -1; ) {
      const n = this.currentTagName, r = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), n === e && r === q.HTML)
        break;
    }
  }
  popUntilElementPopped(e) {
    for (; this.stackTop > -1; ) {
      const n = this.current;
      if (this.pop(), n === e)
        break;
    }
  }
  popUntilNumberedHeaderPopped() {
    for (; this.stackTop > -1; ) {
      const e = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), e === b.H1 || e === b.H2 || e === b.H3 || e === b.H4 || e === b.H5 || e === b.H6 && n === q.HTML)
        break;
    }
  }
  popUntilTableCellPopped() {
    for (; this.stackTop > -1; ) {
      const e = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), e === b.TD || e === b.TH && n === q.HTML)
        break;
    }
  }
  popAllUpToHtmlElement() {
    this.stackTop = 0, this._updateCurrentElement();
  }
  clearBackToTableContext() {
    for (; this.currentTagName !== b.TABLE && this.currentTagName !== b.TEMPLATE && this.currentTagName !== b.HTML || this.treeAdapter.getNamespaceURI(this.current) !== q.HTML; )
      this.pop();
  }
  clearBackToTableBodyContext() {
    for (; this.currentTagName !== b.TBODY && this.currentTagName !== b.TFOOT && this.currentTagName !== b.THEAD && this.currentTagName !== b.TEMPLATE && this.currentTagName !== b.HTML || this.treeAdapter.getNamespaceURI(this.current) !== q.HTML; )
      this.pop();
  }
  clearBackToTableRowContext() {
    for (; this.currentTagName !== b.TR && this.currentTagName !== b.TEMPLATE && this.currentTagName !== b.HTML || this.treeAdapter.getNamespaceURI(this.current) !== q.HTML; )
      this.pop();
  }
  remove(e) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.items[n] === e) {
        this.items.splice(n, 1), this.stackTop--, this._updateCurrentElement();
        break;
      }
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    const e = this.items[1];
    return e && this.treeAdapter.getTagName(e) === b.BODY ? e : null;
  }
  contains(e) {
    return this._indexOf(e) > -1;
  }
  getCommonAncestor(e) {
    let n = this._indexOf(e);
    return --n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.currentTagName === b.HTML;
  }
  //Element in scope
  hasInScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === e && i === q.HTML)
        return !0;
      if (pn(r, i))
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const n = this.treeAdapter.getTagName(this.items[e]), r = this.treeAdapter.getNamespaceURI(this.items[e]);
      if ((n === b.H1 || n === b.H2 || n === b.H3 || n === b.H4 || n === b.H5 || n === b.H6) && r === q.HTML)
        return !0;
      if (pn(n, r))
        return !1;
    }
    return !0;
  }
  hasInListItemScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === e && i === q.HTML)
        return !0;
      if ((r === b.UL || r === b.OL) && i === q.HTML || pn(r, i))
        return !1;
    }
    return !0;
  }
  hasInButtonScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === e && i === q.HTML)
        return !0;
      if (r === b.BUTTON && i === q.HTML || pn(r, i))
        return !1;
    }
    return !0;
  }
  hasInTableScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]);
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === q.HTML) {
        if (r === e)
          return !0;
        if (r === b.TABLE || r === b.TEMPLATE || r === b.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const n = this.treeAdapter.getTagName(this.items[e]);
      if (this.treeAdapter.getNamespaceURI(this.items[e]) === q.HTML) {
        if (n === b.TBODY || n === b.THEAD || n === b.TFOOT)
          return !0;
        if (n === b.TABLE || n === b.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(e) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]);
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === q.HTML) {
        if (r === e)
          return !0;
        if (r !== b.OPTION && r !== b.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; Es(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; t4(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(e) {
    for (; Es(this.currentTagName) && this.currentTagName !== e; )
      this.pop();
  }
};
var r4 = n4;
const En = 3;
let mi = class S1 {
  constructor(e) {
    this.length = 0, this.entries = [], this.treeAdapter = e, this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(e) {
    const n = [];
    if (this.length >= En) {
      const r = this.treeAdapter.getAttrList(e).length, i = this.treeAdapter.getTagName(e), s = this.treeAdapter.getNamespaceURI(e);
      for (let a = this.length - 1; a >= 0; a--) {
        const c = this.entries[a];
        if (c.type === S1.MARKER_ENTRY)
          break;
        const l = c.element, u = this.treeAdapter.getAttrList(l);
        this.treeAdapter.getTagName(l) === i && this.treeAdapter.getNamespaceURI(l) === s && u.length === r && n.push({ idx: a, attrs: u });
      }
    }
    return n.length < En ? [] : n;
  }
  _ensureNoahArkCondition(e) {
    const n = this._getNoahArkConditionCandidates(e);
    let r = n.length;
    if (r) {
      const i = this.treeAdapter.getAttrList(e), s = i.length, a = /* @__PURE__ */ Object.create(null);
      for (let c = 0; c < s; c++) {
        const l = i[c];
        a[l.name] = l.value;
      }
      for (let c = 0; c < s; c++)
        for (let l = 0; l < r; l++) {
          const u = n[l].attrs[c];
          if (a[u.name] !== u.value && (n.splice(l, 1), r--), n.length < En)
            return;
        }
      for (let c = r - 1; c >= En - 1; c--)
        this.entries.splice(n[c].idx, 1), this.length--;
    }
  }
  //Mutations
  insertMarker() {
    this.entries.push({ type: S1.MARKER_ENTRY }), this.length++;
  }
  pushElement(e, n) {
    this._ensureNoahArkCondition(e), this.entries.push({
      type: S1.ELEMENT_ENTRY,
      element: e,
      token: n
    }), this.length++;
  }
  insertElementAfterBookmark(e, n) {
    let r = this.length - 1;
    for (; r >= 0 && this.entries[r] !== this.bookmark; r--)
      ;
    this.entries.splice(r + 1, 0, {
      type: S1.ELEMENT_ENTRY,
      element: e,
      token: n
    }), this.length++;
  }
  removeEntry(e) {
    for (let n = this.length - 1; n >= 0; n--)
      if (this.entries[n] === e) {
        this.entries.splice(n, 1), this.length--;
        break;
      }
  }
  clearToLastMarker() {
    for (; this.length; ) {
      const e = this.entries.pop();
      if (this.length--, e.type === S1.MARKER_ENTRY)
        break;
    }
  }
  //Search
  getElementEntryInScopeWithTagName(e) {
    for (let n = this.length - 1; n >= 0; n--) {
      const r = this.entries[n];
      if (r.type === S1.MARKER_ENTRY)
        return null;
      if (this.treeAdapter.getTagName(r.element) === e)
        return r;
    }
    return null;
  }
  getElementEntry(e) {
    for (let n = this.length - 1; n >= 0; n--) {
      const r = this.entries[n];
      if (r.type === S1.ELEMENT_ENTRY && r.element === e)
        return r;
    }
    return null;
  }
};
mi.MARKER_ENTRY = "MARKER_ENTRY";
mi.ELEMENT_ENTRY = "ELEMENT_ENTRY";
var i4 = mi;
let Il = class {
  constructor(e) {
    const n = {}, r = this._getOverriddenMethods(this, n);
    for (const i of Object.keys(r))
      typeof r[i] == "function" && (n[i] = e[i], e[i] = r[i]);
  }
  _getOverriddenMethods() {
    throw new Error("Not implemented");
  }
};
Il.install = function(t, e, n) {
  t.__mixins || (t.__mixins = []);
  for (let i = 0; i < t.__mixins.length; i++)
    if (t.__mixins[i].constructor === e)
      return t.__mixins[i];
  const r = new e(t, n);
  return t.__mixins.push(r), r;
};
var T1 = Il;
const o4 = T1;
let s4 = class extends o4 {
  constructor(e) {
    super(e), this.preprocessor = e, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
  }
  _getOverriddenMethods(e, n) {
    return {
      advance() {
        const r = this.pos + 1, i = this.html[r];
        return e.isEol && (e.isEol = !1, e.line++, e.lineStartPos = r), (i === `
` || i === "\r" && this.html[r + 1] !== `
`) && (e.isEol = !0), e.col = r - e.lineStartPos + 1, e.offset = e.droppedBufferSize + r, n.advance.call(this);
      },
      retreat() {
        n.retreat.call(this), e.isEol = !1, e.col = this.pos - e.lineStartPos + 1;
      },
      dropParsedChunk() {
        const r = this.pos;
        n.dropParsedChunk.call(this);
        const i = r - this.pos;
        e.lineStartPos -= i, e.droppedBufferSize += i, e.offset = e.droppedBufferSize + this.pos;
      }
    };
  }
};
var yl = s4;
const gs = T1, Or = Un, a4 = yl;
let l4 = class extends gs {
  constructor(e) {
    super(e), this.tokenizer = e, this.posTracker = gs.install(e.preprocessor, a4), this.currentAttrLocation = null, this.ctLoc = null;
  }
  _getCurrentLocation() {
    return {
      startLine: this.posTracker.line,
      startCol: this.posTracker.col,
      startOffset: this.posTracker.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
  }
  _attachCurrentAttrLocationInfo() {
    this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
    const e = this.tokenizer.currentToken, n = this.tokenizer.currentAttr;
    e.location.attrs || (e.location.attrs = /* @__PURE__ */ Object.create(null)), e.location.attrs[n.name] = this.currentAttrLocation;
  }
  _getOverriddenMethods(e, n) {
    const r = {
      _createStartTagToken() {
        n._createStartTagToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createEndTagToken() {
        n._createEndTagToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createCommentToken() {
        n._createCommentToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createDoctypeToken(i) {
        n._createDoctypeToken.call(this, i), this.currentToken.location = e.ctLoc;
      },
      _createCharacterToken(i, s) {
        n._createCharacterToken.call(this, i, s), this.currentCharacterToken.location = e.ctLoc;
      },
      _createEOFToken() {
        n._createEOFToken.call(this), this.currentToken.location = e._getCurrentLocation();
      },
      _createAttr(i) {
        n._createAttr.call(this, i), e.currentAttrLocation = e._getCurrentLocation();
      },
      _leaveAttrName(i) {
        n._leaveAttrName.call(this, i), e._attachCurrentAttrLocationInfo();
      },
      _leaveAttrValue(i) {
        n._leaveAttrValue.call(this, i), e._attachCurrentAttrLocationInfo();
      },
      _emitCurrentToken() {
        const i = this.currentToken.location;
        this.currentCharacterToken && (this.currentCharacterToken.location.endLine = i.startLine, this.currentCharacterToken.location.endCol = i.startCol, this.currentCharacterToken.location.endOffset = i.startOffset), this.currentToken.type === Or.EOF_TOKEN ? (i.endLine = i.startLine, i.endCol = i.startCol, i.endOffset = i.startOffset) : (i.endLine = e.posTracker.line, i.endCol = e.posTracker.col + 1, i.endOffset = e.posTracker.offset + 1), n._emitCurrentToken.call(this);
      },
      _emitCurrentCharacterToken() {
        const i = this.currentCharacterToken && this.currentCharacterToken.location;
        i && i.endOffset === -1 && (i.endLine = e.posTracker.line, i.endCol = e.posTracker.col, i.endOffset = e.posTracker.offset), n._emitCurrentCharacterToken.call(this);
      }
    };
    return Object.keys(Or.MODE).forEach((i) => {
      const s = Or.MODE[i];
      r[s] = function(a) {
        e.ctLoc = e._getCurrentLocation(), n[s].call(this, a);
      };
    }), r;
  }
};
var Ol = l4;
const c4 = T1;
let u4 = class extends c4 {
  constructor(e, n) {
    super(e), this.onItemPop = n.onItemPop;
  }
  _getOverriddenMethods(e, n) {
    return {
      pop() {
        e.onItemPop(this.current), n.pop.call(this);
      },
      popAllUpToHtmlElement() {
        for (let r = this.stackTop; r > 0; r--)
          e.onItemPop(this.items[r]);
        n.popAllUpToHtmlElement.call(this);
      },
      remove(r) {
        e.onItemPop(this.current), n.remove.call(this, r);
      }
    };
  }
};
var d4 = u4;
const vr = T1, As = Un, h4 = Ol, f4 = d4, m4 = je, xr = m4.TAG_NAMES;
let T4 = class extends vr {
  constructor(e) {
    super(e), this.parser = e, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
  }
  _setStartLocation(e) {
    let n = null;
    this.lastStartTagToken && (n = Object.assign({}, this.lastStartTagToken.location), n.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(e, n);
  }
  _setEndLocation(e, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(e) && n.location) {
      const i = n.location, s = this.treeAdapter.getTagName(e), a = n.type === As.END_TAG_TOKEN && s === n.tagName, c = {};
      a ? (c.endTag = Object.assign({}, i), c.endLine = i.endLine, c.endCol = i.endCol, c.endOffset = i.endOffset) : (c.endLine = i.startLine, c.endCol = i.startCol, c.endOffset = i.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(e, c);
    }
  }
  _getOverriddenMethods(e, n) {
    return {
      _bootstrap(r, i) {
        n._bootstrap.call(this, r, i), e.lastStartTagToken = null, e.lastFosterParentingLocation = null, e.currentToken = null;
        const s = vr.install(this.tokenizer, h4);
        e.posTracker = s.posTracker, vr.install(this.openElements, f4, {
          onItemPop: function(a) {
            e._setEndLocation(a, e.currentToken);
          }
        });
      },
      _runParsingLoop(r) {
        n._runParsingLoop.call(this, r);
        for (let i = this.openElements.stackTop; i >= 0; i--)
          e._setEndLocation(this.openElements.items[i], e.currentToken);
      },
      //Token processing
      _processTokenInForeignContent(r) {
        e.currentToken = r, n._processTokenInForeignContent.call(this, r);
      },
      _processToken(r) {
        if (e.currentToken = r, n._processToken.call(this, r), r.type === As.END_TAG_TOKEN && (r.tagName === xr.HTML || r.tagName === xr.BODY && this.openElements.hasInScope(xr.BODY)))
          for (let s = this.openElements.stackTop; s >= 0; s--) {
            const a = this.openElements.items[s];
            if (this.treeAdapter.getTagName(a) === r.tagName) {
              e._setEndLocation(a, r);
              break;
            }
          }
      },
      //Doctype
      _setDocumentType(r) {
        n._setDocumentType.call(this, r);
        const i = this.treeAdapter.getChildNodes(this.document), s = i.length;
        for (let a = 0; a < s; a++) {
          const c = i[a];
          if (this.treeAdapter.isDocumentTypeNode(c)) {
            this.treeAdapter.setNodeSourceCodeLocation(c, r.location);
            break;
          }
        }
      },
      //Elements
      _attachElementToTree(r) {
        e._setStartLocation(r), e.lastStartTagToken = null, n._attachElementToTree.call(this, r);
      },
      _appendElement(r, i) {
        e.lastStartTagToken = r, n._appendElement.call(this, r, i);
      },
      _insertElement(r, i) {
        e.lastStartTagToken = r, n._insertElement.call(this, r, i);
      },
      _insertTemplate(r) {
        e.lastStartTagToken = r, n._insertTemplate.call(this, r);
        const i = this.treeAdapter.getTemplateContent(this.openElements.current);
        this.treeAdapter.setNodeSourceCodeLocation(i, null);
      },
      _insertFakeRootElement() {
        n._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
      },
      //Comments
      _appendCommentNode(r, i) {
        n._appendCommentNode.call(this, r, i);
        const s = this.treeAdapter.getChildNodes(i), a = s[s.length - 1];
        this.treeAdapter.setNodeSourceCodeLocation(a, r.location);
      },
      //Text
      _findFosterParentingLocation() {
        return e.lastFosterParentingLocation = n._findFosterParentingLocation.call(this), e.lastFosterParentingLocation;
      },
      _insertCharacters(r) {
        n._insertCharacters.call(this, r);
        const i = this._shouldFosterParentOnInsertion(), s = i && e.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, a = this.treeAdapter.getChildNodes(s), c = i && e.lastFosterParentingLocation.beforeElement ? a.indexOf(e.lastFosterParentingLocation.beforeElement) - 1 : a.length - 1, l = a[c];
        if (this.treeAdapter.getNodeSourceCodeLocation(l)) {
          const { endLine: g, endCol: A, endOffset: S } = r.location;
          this.treeAdapter.updateNodeSourceCodeLocation(l, { endLine: g, endCol: A, endOffset: S });
        } else
          this.treeAdapter.setNodeSourceCodeLocation(l, r.location);
      }
    };
  }
};
var p4 = T4;
const E4 = T1;
let g4 = class extends E4 {
  constructor(e, n) {
    super(e), this.posTracker = null, this.onParseError = n.onParseError;
  }
  _setErrorLocation(e) {
    e.startLine = e.endLine = this.posTracker.line, e.startCol = e.endCol = this.posTracker.col, e.startOffset = e.endOffset = this.posTracker.offset;
  }
  _reportError(e) {
    const n = {
      code: e,
      startLine: -1,
      startCol: -1,
      startOffset: -1,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    this._setErrorLocation(n), this.onParseError(n);
  }
  _getOverriddenMethods(e) {
    return {
      _err(n) {
        e._reportError(n);
      }
    };
  }
};
var Ti = g4;
const A4 = Ti, _4 = yl, C4 = T1;
let N4 = class extends A4 {
  constructor(e, n) {
    super(e, n), this.posTracker = C4.install(e, _4), this.lastErrOffset = -1;
  }
  _reportError(e) {
    this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(e));
  }
};
var S4 = N4;
const I4 = Ti, y4 = S4, O4 = T1;
let v4 = class extends I4 {
  constructor(e, n) {
    super(e, n);
    const r = O4.install(e.preprocessor, y4, n);
    this.posTracker = r.posTracker;
  }
};
var x4 = v4;
const R4 = Ti, b4 = x4, L4 = Ol, _s = T1;
let P4 = class extends R4 {
  constructor(e, n) {
    super(e, n), this.opts = n, this.ctLoc = null, this.locBeforeToken = !1;
  }
  _setErrorLocation(e) {
    this.ctLoc && (e.startLine = this.ctLoc.startLine, e.startCol = this.ctLoc.startCol, e.startOffset = this.ctLoc.startOffset, e.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, e.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, e.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
  }
  _getOverriddenMethods(e, n) {
    return {
      _bootstrap(r, i) {
        n._bootstrap.call(this, r, i), _s.install(this.tokenizer, b4, e.opts), _s.install(this.tokenizer, L4);
      },
      _processInputToken(r) {
        e.ctLoc = r.location, n._processInputToken.call(this, r);
      },
      _err(r, i) {
        e.locBeforeToken = i && i.beforeToken, e._reportError(r);
      }
    };
  }
};
var M4 = P4, Y = {};
const { DOCUMENT_MODE: D4 } = je;
Y.createDocument = function() {
  return {
    nodeName: "#document",
    mode: D4.NO_QUIRKS,
    childNodes: []
  };
};
Y.createDocumentFragment = function() {
  return {
    nodeName: "#document-fragment",
    childNodes: []
  };
};
Y.createElement = function(t, e, n) {
  return {
    nodeName: t,
    tagName: t,
    attrs: n,
    namespaceURI: e,
    childNodes: [],
    parentNode: null
  };
};
Y.createCommentNode = function(t) {
  return {
    nodeName: "#comment",
    data: t,
    parentNode: null
  };
};
const vl = function(t) {
  return {
    nodeName: "#text",
    value: t,
    parentNode: null
  };
}, xl = Y.appendChild = function(t, e) {
  t.childNodes.push(e), e.parentNode = t;
}, k4 = Y.insertBefore = function(t, e, n) {
  const r = t.childNodes.indexOf(n);
  t.childNodes.splice(r, 0, e), e.parentNode = t;
};
Y.setTemplateContent = function(t, e) {
  t.content = e;
};
Y.getTemplateContent = function(t) {
  return t.content;
};
Y.setDocumentType = function(t, e, n, r) {
  let i = null;
  for (let s = 0; s < t.childNodes.length; s++)
    if (t.childNodes[s].nodeName === "#documentType") {
      i = t.childNodes[s];
      break;
    }
  i ? (i.name = e, i.publicId = n, i.systemId = r) : xl(t, {
    nodeName: "#documentType",
    name: e,
    publicId: n,
    systemId: r
  });
};
Y.setDocumentMode = function(t, e) {
  t.mode = e;
};
Y.getDocumentMode = function(t) {
  return t.mode;
};
Y.detachNode = function(t) {
  if (t.parentNode) {
    const e = t.parentNode.childNodes.indexOf(t);
    t.parentNode.childNodes.splice(e, 1), t.parentNode = null;
  }
};
Y.insertText = function(t, e) {
  if (t.childNodes.length) {
    const n = t.childNodes[t.childNodes.length - 1];
    if (n.nodeName === "#text") {
      n.value += e;
      return;
    }
  }
  xl(t, vl(e));
};
Y.insertTextBefore = function(t, e, n) {
  const r = t.childNodes[t.childNodes.indexOf(n) - 1];
  r && r.nodeName === "#text" ? r.value += e : k4(t, vl(e), n);
};
Y.adoptAttributes = function(t, e) {
  const n = [];
  for (let r = 0; r < t.attrs.length; r++)
    n.push(t.attrs[r].name);
  for (let r = 0; r < e.length; r++)
    n.indexOf(e[r].name) === -1 && t.attrs.push(e[r]);
};
Y.getFirstChild = function(t) {
  return t.childNodes[0];
};
Y.getChildNodes = function(t) {
  return t.childNodes;
};
Y.getParentNode = function(t) {
  return t.parentNode;
};
Y.getAttrList = function(t) {
  return t.attrs;
};
Y.getTagName = function(t) {
  return t.tagName;
};
Y.getNamespaceURI = function(t) {
  return t.namespaceURI;
};
Y.getTextNodeContent = function(t) {
  return t.value;
};
Y.getCommentNodeContent = function(t) {
  return t.data;
};
Y.getDocumentTypeNodeName = function(t) {
  return t.name;
};
Y.getDocumentTypeNodePublicId = function(t) {
  return t.publicId;
};
Y.getDocumentTypeNodeSystemId = function(t) {
  return t.systemId;
};
Y.isTextNode = function(t) {
  return t.nodeName === "#text";
};
Y.isCommentNode = function(t) {
  return t.nodeName === "#comment";
};
Y.isDocumentTypeNode = function(t) {
  return t.nodeName === "#documentType";
};
Y.isElementNode = function(t) {
  return !!t.tagName;
};
Y.setNodeSourceCodeLocation = function(t, e) {
  t.sourceCodeLocation = e;
};
Y.getNodeSourceCodeLocation = function(t) {
  return t.sourceCodeLocation;
};
Y.updateNodeSourceCodeLocation = function(t, e) {
  t.sourceCodeLocation = Object.assign(t.sourceCodeLocation, e);
};
var w4 = function(e, n) {
  return n = n || /* @__PURE__ */ Object.create(null), [e, n].reduce((r, i) => (Object.keys(i).forEach((s) => {
    r[s] = i[s];
  }), r), /* @__PURE__ */ Object.create(null));
}, Gn = {};
const { DOCUMENT_MODE: J1 } = je, Rl = "html", H4 = "about:legacy-compat", $4 = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", bl = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], F4 = bl.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]), B4 = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], Ll = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], U4 = Ll.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]);
function Cs(t) {
  const e = t.indexOf('"') !== -1 ? "'" : '"';
  return e + t + e;
}
function Ns(t, e) {
  for (let n = 0; n < e.length; n++)
    if (t.indexOf(e[n]) === 0)
      return !0;
  return !1;
}
Gn.isConforming = function(t) {
  return t.name === Rl && t.publicId === null && (t.systemId === null || t.systemId === H4);
};
Gn.getDocumentMode = function(t) {
  if (t.name !== Rl)
    return J1.QUIRKS;
  const e = t.systemId;
  if (e && e.toLowerCase() === $4)
    return J1.QUIRKS;
  let n = t.publicId;
  if (n !== null) {
    if (n = n.toLowerCase(), B4.indexOf(n) > -1)
      return J1.QUIRKS;
    let r = e === null ? F4 : bl;
    if (Ns(n, r))
      return J1.QUIRKS;
    if (r = e === null ? Ll : U4, Ns(n, r))
      return J1.LIMITED_QUIRKS;
  }
  return J1.NO_QUIRKS;
};
Gn.serializeContent = function(t, e, n) {
  let r = "!DOCTYPE ";
  return t && (r += t), e ? r += " PUBLIC " + Cs(e) : n && (r += " SYSTEM"), n !== null && (r += " " + Cs(n)), r;
};
var b1 = {};
const Rr = Un, pi = je, k = pi.TAG_NAMES, me = pi.NAMESPACES, yn = pi.ATTRS, Ss = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, G4 = "definitionurl", K4 = "definitionURL", z4 = {
  attributename: "attributeName",
  attributetype: "attributeType",
  basefrequency: "baseFrequency",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  clippathunits: "clipPathUnits",
  diffuseconstant: "diffuseConstant",
  edgemode: "edgeMode",
  filterunits: "filterUnits",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  limitingconeangle: "limitingConeAngle",
  markerheight: "markerHeight",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textlength: "textLength",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  xchannelselector: "xChannelSelector",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan"
}, Y4 = {
  "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: me.XLINK },
  "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: me.XLINK },
  "xlink:href": { prefix: "xlink", name: "href", namespace: me.XLINK },
  "xlink:role": { prefix: "xlink", name: "role", namespace: me.XLINK },
  "xlink:show": { prefix: "xlink", name: "show", namespace: me.XLINK },
  "xlink:title": { prefix: "xlink", name: "title", namespace: me.XLINK },
  "xlink:type": { prefix: "xlink", name: "type", namespace: me.XLINK },
  "xml:base": { prefix: "xml", name: "base", namespace: me.XML },
  "xml:lang": { prefix: "xml", name: "lang", namespace: me.XML },
  "xml:space": { prefix: "xml", name: "space", namespace: me.XML },
  xmlns: { prefix: "", name: "xmlns", namespace: me.XMLNS },
  "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: me.XMLNS }
}, W4 = b1.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient",
  textpath: "textPath"
}, V4 = {
  [k.B]: !0,
  [k.BIG]: !0,
  [k.BLOCKQUOTE]: !0,
  [k.BODY]: !0,
  [k.BR]: !0,
  [k.CENTER]: !0,
  [k.CODE]: !0,
  [k.DD]: !0,
  [k.DIV]: !0,
  [k.DL]: !0,
  [k.DT]: !0,
  [k.EM]: !0,
  [k.EMBED]: !0,
  [k.H1]: !0,
  [k.H2]: !0,
  [k.H3]: !0,
  [k.H4]: !0,
  [k.H5]: !0,
  [k.H6]: !0,
  [k.HEAD]: !0,
  [k.HR]: !0,
  [k.I]: !0,
  [k.IMG]: !0,
  [k.LI]: !0,
  [k.LISTING]: !0,
  [k.MENU]: !0,
  [k.META]: !0,
  [k.NOBR]: !0,
  [k.OL]: !0,
  [k.P]: !0,
  [k.PRE]: !0,
  [k.RUBY]: !0,
  [k.S]: !0,
  [k.SMALL]: !0,
  [k.SPAN]: !0,
  [k.STRONG]: !0,
  [k.STRIKE]: !0,
  [k.SUB]: !0,
  [k.SUP]: !0,
  [k.TABLE]: !0,
  [k.TT]: !0,
  [k.U]: !0,
  [k.UL]: !0,
  [k.VAR]: !0
};
b1.causesExit = function(t) {
  const e = t.tagName;
  return e === k.FONT && (Rr.getTokenAttr(t, yn.COLOR) !== null || Rr.getTokenAttr(t, yn.SIZE) !== null || Rr.getTokenAttr(t, yn.FACE) !== null) ? !0 : V4[e];
};
b1.adjustTokenMathMLAttrs = function(t) {
  for (let e = 0; e < t.attrs.length; e++)
    if (t.attrs[e].name === G4) {
      t.attrs[e].name = K4;
      break;
    }
};
b1.adjustTokenSVGAttrs = function(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = z4[t.attrs[e].name];
    n && (t.attrs[e].name = n);
  }
};
b1.adjustTokenXMLAttrs = function(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = Y4[t.attrs[e].name];
    n && (t.attrs[e].prefix = n.prefix, t.attrs[e].name = n.name, t.attrs[e].namespace = n.namespace);
  }
};
b1.adjustTokenSVGTagName = function(t) {
  const e = W4[t.tagName];
  e && (t.tagName = e);
};
function j4(t, e) {
  return e === me.MATHML && (t === k.MI || t === k.MO || t === k.MN || t === k.MS || t === k.MTEXT);
}
function X4(t, e, n) {
  if (e === me.MATHML && t === k.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === yn.ENCODING) {
        const i = n[r].value.toLowerCase();
        return i === Ss.TEXT_HTML || i === Ss.APPLICATION_XML;
      }
  }
  return e === me.SVG && (t === k.FOREIGN_OBJECT || t === k.DESC || t === k.TITLE);
}
b1.isIntegrationPoint = function(t, e, n, r) {
  return !!((!r || r === me.HTML) && X4(t, e, n) || (!r || r === me.MATHML) && j4(t, e));
};
const p = Un, Q4 = r4, Is = i4, q4 = p4, Z4 = M4, ys = T1, J4 = Y, em = w4, Os = Gn, e1 = b1, Te = fi, tm = Ve, z1 = je, o = z1.TAG_NAMES, P = z1.NAMESPACES, Pl = z1.ATTRS, nm = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  onParseError: null,
  treeAdapter: J4
}, Ml = "hidden", rm = 8, im = 3, Dl = "INITIAL_MODE", Ei = "BEFORE_HTML_MODE", Kn = "BEFORE_HEAD_MODE", mt = "IN_HEAD_MODE", kl = "IN_HEAD_NO_SCRIPT_MODE", zn = "AFTER_HEAD_MODE", r1 = "IN_BODY_MODE", Pn = "TEXT_MODE", Ee = "IN_TABLE_MODE", wl = "IN_TABLE_TEXT_MODE", Yn = "IN_CAPTION_MODE", Qt = "IN_COLUMN_GROUP_MODE", we = "IN_TABLE_BODY_MODE", m1 = "IN_ROW_MODE", Wn = "IN_CELL_MODE", gi = "IN_SELECT_MODE", Ai = "IN_SELECT_IN_TABLE_MODE", Mn = "IN_TEMPLATE_MODE", _i = "AFTER_BODY_MODE", Vn = "IN_FRAMESET_MODE", Hl = "AFTER_FRAMESET_MODE", $l = "AFTER_AFTER_BODY_MODE", Fl = "AFTER_AFTER_FRAMESET_MODE", om = {
  [o.TR]: m1,
  [o.TBODY]: we,
  [o.THEAD]: we,
  [o.TFOOT]: we,
  [o.CAPTION]: Yn,
  [o.COLGROUP]: Qt,
  [o.TABLE]: Ee,
  [o.BODY]: r1,
  [o.FRAMESET]: Vn
}, sm = {
  [o.CAPTION]: Ee,
  [o.COLGROUP]: Ee,
  [o.TBODY]: Ee,
  [o.TFOOT]: Ee,
  [o.THEAD]: Ee,
  [o.COL]: Qt,
  [o.TR]: we,
  [o.TD]: m1,
  [o.TH]: m1
}, vs = {
  [Dl]: {
    [p.CHARACTER_TOKEN]: yt,
    [p.NULL_CHARACTER_TOKEN]: yt,
    [p.WHITESPACE_CHARACTER_TOKEN]: G,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: pm,
    [p.START_TAG_TOKEN]: yt,
    [p.END_TAG_TOKEN]: yt,
    [p.EOF_TOKEN]: yt
  },
  [Ei]: {
    [p.CHARACTER_TOKEN]: Mt,
    [p.NULL_CHARACTER_TOKEN]: Mt,
    [p.WHITESPACE_CHARACTER_TOKEN]: G,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: Em,
    [p.END_TAG_TOKEN]: gm,
    [p.EOF_TOKEN]: Mt
  },
  [Kn]: {
    [p.CHARACTER_TOKEN]: Dt,
    [p.NULL_CHARACTER_TOKEN]: Dt,
    [p.WHITESPACE_CHARACTER_TOKEN]: G,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: gn,
    [p.START_TAG_TOKEN]: Am,
    [p.END_TAG_TOKEN]: _m,
    [p.EOF_TOKEN]: Dt
  },
  [mt]: {
    [p.CHARACTER_TOKEN]: kt,
    [p.NULL_CHARACTER_TOKEN]: kt,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: gn,
    [p.START_TAG_TOKEN]: de,
    [p.END_TAG_TOKEN]: Y1,
    [p.EOF_TOKEN]: kt
  },
  [kl]: {
    [p.CHARACTER_TOKEN]: wt,
    [p.NULL_CHARACTER_TOKEN]: wt,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: gn,
    [p.START_TAG_TOKEN]: Cm,
    [p.END_TAG_TOKEN]: Nm,
    [p.EOF_TOKEN]: wt
  },
  [zn]: {
    [p.CHARACTER_TOKEN]: Ht,
    [p.NULL_CHARACTER_TOKEN]: Ht,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: gn,
    [p.START_TAG_TOKEN]: Sm,
    [p.END_TAG_TOKEN]: Im,
    [p.EOF_TOKEN]: Ht
  },
  [r1]: {
    [p.CHARACTER_TOKEN]: An,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: w1,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: ve,
    [p.END_TAG_TOKEN]: Ci,
    [p.EOF_TOKEN]: u1
  },
  [Pn]: {
    [p.CHARACTER_TOKEN]: Oe,
    [p.NULL_CHARACTER_TOKEN]: Oe,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: G,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: G,
    [p.END_TAG_TOKEN]: t8,
    [p.EOF_TOKEN]: n8
  },
  [Ee]: {
    [p.CHARACTER_TOKEN]: d1,
    [p.NULL_CHARACTER_TOKEN]: d1,
    [p.WHITESPACE_CHARACTER_TOKEN]: d1,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: Ni,
    [p.END_TAG_TOKEN]: Si,
    [p.EOF_TOKEN]: u1
  },
  [wl]: {
    [p.CHARACTER_TOKEN]: h8,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: d8,
    [p.COMMENT_TOKEN]: Ot,
    [p.DOCTYPE_TOKEN]: Ot,
    [p.START_TAG_TOKEN]: Ot,
    [p.END_TAG_TOKEN]: Ot,
    [p.EOF_TOKEN]: Ot
  },
  [Yn]: {
    [p.CHARACTER_TOKEN]: An,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: w1,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: f8,
    [p.END_TAG_TOKEN]: m8,
    [p.EOF_TOKEN]: u1
  },
  [Qt]: {
    [p.CHARACTER_TOKEN]: Dn,
    [p.NULL_CHARACTER_TOKEN]: Dn,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: T8,
    [p.END_TAG_TOKEN]: p8,
    [p.EOF_TOKEN]: u1
  },
  [we]: {
    [p.CHARACTER_TOKEN]: d1,
    [p.NULL_CHARACTER_TOKEN]: d1,
    [p.WHITESPACE_CHARACTER_TOKEN]: d1,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: E8,
    [p.END_TAG_TOKEN]: g8,
    [p.EOF_TOKEN]: u1
  },
  [m1]: {
    [p.CHARACTER_TOKEN]: d1,
    [p.NULL_CHARACTER_TOKEN]: d1,
    [p.WHITESPACE_CHARACTER_TOKEN]: d1,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: A8,
    [p.END_TAG_TOKEN]: _8,
    [p.EOF_TOKEN]: u1
  },
  [Wn]: {
    [p.CHARACTER_TOKEN]: An,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: w1,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: C8,
    [p.END_TAG_TOKEN]: N8,
    [p.EOF_TOKEN]: u1
  },
  [gi]: {
    [p.CHARACTER_TOKEN]: Oe,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: Bl,
    [p.END_TAG_TOKEN]: Ul,
    [p.EOF_TOKEN]: u1
  },
  [Ai]: {
    [p.CHARACTER_TOKEN]: Oe,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: S8,
    [p.END_TAG_TOKEN]: I8,
    [p.EOF_TOKEN]: u1
  },
  [Mn]: {
    [p.CHARACTER_TOKEN]: An,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: w1,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: y8,
    [p.END_TAG_TOKEN]: O8,
    [p.EOF_TOKEN]: Gl
  },
  [_i]: {
    [p.CHARACTER_TOKEN]: kn,
    [p.NULL_CHARACTER_TOKEN]: kn,
    [p.WHITESPACE_CHARACTER_TOKEN]: w1,
    [p.COMMENT_TOKEN]: Tm,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: v8,
    [p.END_TAG_TOKEN]: x8,
    [p.EOF_TOKEN]: It
  },
  [Vn]: {
    [p.CHARACTER_TOKEN]: G,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: R8,
    [p.END_TAG_TOKEN]: b8,
    [p.EOF_TOKEN]: It
  },
  [Hl]: {
    [p.CHARACTER_TOKEN]: G,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: Oe,
    [p.COMMENT_TOKEN]: le,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: L8,
    [p.END_TAG_TOKEN]: P8,
    [p.EOF_TOKEN]: It
  },
  [$l]: {
    [p.CHARACTER_TOKEN]: On,
    [p.NULL_CHARACTER_TOKEN]: On,
    [p.WHITESPACE_CHARACTER_TOKEN]: w1,
    [p.COMMENT_TOKEN]: xs,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: M8,
    [p.END_TAG_TOKEN]: On,
    [p.EOF_TOKEN]: It
  },
  [Fl]: {
    [p.CHARACTER_TOKEN]: G,
    [p.NULL_CHARACTER_TOKEN]: G,
    [p.WHITESPACE_CHARACTER_TOKEN]: w1,
    [p.COMMENT_TOKEN]: xs,
    [p.DOCTYPE_TOKEN]: G,
    [p.START_TAG_TOKEN]: D8,
    [p.END_TAG_TOKEN]: G,
    [p.EOF_TOKEN]: It
  }
};
let am = class {
  constructor(e) {
    this.options = em(nm, e), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && ys.install(this, q4), this.options.onParseError && ys.install(this, Z4, { onParseError: this.options.onParseError });
  }
  // API
  parse(e) {
    const n = this.treeAdapter.createDocument();
    return this._bootstrap(n, null), this.tokenizer.write(e, !0), this._runParsingLoop(null), n;
  }
  parseFragment(e, n) {
    n || (n = this.treeAdapter.createElement(o.TEMPLATE, P.HTML, []));
    const r = this.treeAdapter.createElement("documentmock", P.HTML, []);
    this._bootstrap(r, n), this.treeAdapter.getTagName(n) === o.TEMPLATE && this._pushTmplInsertionMode(Mn), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(e, !0), this._runParsingLoop(null);
    const i = this.treeAdapter.getFirstChild(r), s = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(i, s), s;
  }
  //Bootstrap parser
  _bootstrap(e, n) {
    this.tokenizer = new p(this.options), this.stopped = !1, this.insertionMode = Dl, this.originalInsertionMode = "", this.document = e, this.fragmentContext = n, this.headElement = null, this.formElement = null, this.openElements = new Q4(this.document, this.treeAdapter), this.activeFormattingElements = new Is(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
  }
  //Errors
  _err() {
  }
  //Parsing loop
  _runParsingLoop(e) {
    for (; !this.stopped; ) {
      this._setupTokenizerCDATAMode();
      const n = this.tokenizer.getNextToken();
      if (n.type === p.HIBERNATION_TOKEN)
        break;
      if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.type === p.WHITESPACE_CHARACTER_TOKEN && n.chars[0] === `
`)) {
        if (n.chars.length === 1)
          continue;
        n.chars = n.chars.substr(1);
      }
      if (this._processInputToken(n), e && this.pendingScript)
        break;
    }
  }
  runParsingLoopForCurrentChunk(e, n) {
    if (this._runParsingLoop(n), n && this.pendingScript) {
      const r = this.pendingScript;
      this.pendingScript = null, n(r);
      return;
    }
    e && e();
  }
  //Text parsing
  _setupTokenizerCDATAMode() {
    const e = this._getAdjustedCurrentElement();
    this.tokenizer.allowCDATA = e && e !== this.document && this.treeAdapter.getNamespaceURI(e) !== P.HTML && !this._isIntegrationPoint(e);
  }
  _switchToTextParsing(e, n) {
    this._insertElement(e, P.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = Pn;
  }
  switchToPlaintextParsing() {
    this.insertionMode = Pn, this.originalInsertionMode = r1, this.tokenizer.state = p.MODE.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let e = this.fragmentContext;
    do {
      if (this.treeAdapter.getTagName(e) === o.FORM) {
        this.formElement = e;
        break;
      }
      e = this.treeAdapter.getParentNode(e);
    } while (e);
  }
  _initTokenizerForFragmentParsing() {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === P.HTML) {
      const e = this.treeAdapter.getTagName(this.fragmentContext);
      e === o.TITLE || e === o.TEXTAREA ? this.tokenizer.state = p.MODE.RCDATA : e === o.STYLE || e === o.XMP || e === o.IFRAME || e === o.NOEMBED || e === o.NOFRAMES || e === o.NOSCRIPT ? this.tokenizer.state = p.MODE.RAWTEXT : e === o.SCRIPT ? this.tokenizer.state = p.MODE.SCRIPT_DATA : e === o.PLAINTEXT && (this.tokenizer.state = p.MODE.PLAINTEXT);
    }
  }
  //Tree mutation
  _setDocumentType(e) {
    const n = e.name || "", r = e.publicId || "", i = e.systemId || "";
    this.treeAdapter.setDocumentType(this.document, n, r, i);
  }
  _attachElementToTree(e) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(e);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.appendChild(n, e);
    }
  }
  _appendElement(e, n) {
    const r = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(r);
  }
  _insertElement(e, n) {
    const r = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(r), this.openElements.push(r);
  }
  _insertFakeElement(e) {
    const n = this.treeAdapter.createElement(e, P.HTML, []);
    this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertTemplate(e) {
    const n = this.treeAdapter.createElement(e.tagName, P.HTML, e.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertFakeRootElement() {
    const e = this.treeAdapter.createElement(o.HTML, P.HTML, []);
    this.treeAdapter.appendChild(this.openElements.current, e), this.openElements.push(e);
  }
  _appendCommentNode(e, n) {
    const r = this.treeAdapter.createCommentNode(e.data);
    this.treeAdapter.appendChild(n, r);
  }
  _insertCharacters(e) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentText(e.chars);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.insertText(n, e.chars);
    }
  }
  _adoptNodes(e, n) {
    for (let r = this.treeAdapter.getFirstChild(e); r; r = this.treeAdapter.getFirstChild(e))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  //Token processing
  _shouldProcessTokenInForeignContent(e) {
    const n = this._getAdjustedCurrentElement();
    if (!n || n === this.document)
      return !1;
    const r = this.treeAdapter.getNamespaceURI(n);
    if (r === P.HTML || this.treeAdapter.getTagName(n) === o.ANNOTATION_XML && r === P.MATHML && e.type === p.START_TAG_TOKEN && e.tagName === o.SVG)
      return !1;
    const i = e.type === p.CHARACTER_TOKEN || e.type === p.NULL_CHARACTER_TOKEN || e.type === p.WHITESPACE_CHARACTER_TOKEN;
    return (e.type === p.START_TAG_TOKEN && e.tagName !== o.MGLYPH && e.tagName !== o.MALIGNMARK || i) && this._isIntegrationPoint(n, P.MATHML) || (e.type === p.START_TAG_TOKEN || i) && this._isIntegrationPoint(n, P.HTML) ? !1 : e.type !== p.EOF_TOKEN;
  }
  _processToken(e) {
    vs[this.insertionMode][e.type](this, e);
  }
  _processTokenInBodyMode(e) {
    vs[r1][e.type](this, e);
  }
  _processTokenInForeignContent(e) {
    e.type === p.CHARACTER_TOKEN ? w8(this, e) : e.type === p.NULL_CHARACTER_TOKEN ? k8(this, e) : e.type === p.WHITESPACE_CHARACTER_TOKEN ? Oe(this, e) : e.type === p.COMMENT_TOKEN ? le(this, e) : e.type === p.START_TAG_TOKEN ? H8(this, e) : e.type === p.END_TAG_TOKEN && $8(this, e);
  }
  _processInputToken(e) {
    this._shouldProcessTokenInForeignContent(e) ? this._processTokenInForeignContent(e) : this._processToken(e), e.type === p.START_TAG_TOKEN && e.selfClosing && !e.ackSelfClosing && this._err(Te.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  //Integration points
  _isIntegrationPoint(e, n) {
    const r = this.treeAdapter.getTagName(e), i = this.treeAdapter.getNamespaceURI(e), s = this.treeAdapter.getAttrList(e);
    return e1.isIntegrationPoint(r, i, s, n);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const e = this.activeFormattingElements.length;
    if (e) {
      let n = e, r = null;
      do
        if (n--, r = this.activeFormattingElements.entries[n], r.type === Is.MARKER_ENTRY || this.openElements.contains(r.element)) {
          n++;
          break;
        }
      while (n > 0);
      for (let i = n; i < e; i++)
        r = this.activeFormattingElements.entries[i], this._insertElement(r.token, this.treeAdapter.getNamespaceURI(r.element)), r.element = this.openElements.current;
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = m1;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(o.P), this.openElements.popUntilTagNamePopped(o.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let e = this.openElements.stackTop, n = !1; e >= 0; e--) {
      let r = this.openElements.items[e];
      e === 0 && (n = !0, this.fragmentContext && (r = this.fragmentContext));
      const i = this.treeAdapter.getTagName(r), s = om[i];
      if (s) {
        this.insertionMode = s;
        break;
      } else if (!n && (i === o.TD || i === o.TH)) {
        this.insertionMode = Wn;
        break;
      } else if (!n && i === o.HEAD) {
        this.insertionMode = mt;
        break;
      } else if (i === o.SELECT) {
        this._resetInsertionModeForSelect(e);
        break;
      } else if (i === o.TEMPLATE) {
        this.insertionMode = this.currentTmplInsertionMode;
        break;
      } else if (i === o.HTML) {
        this.insertionMode = this.headElement ? zn : Kn;
        break;
      } else if (n) {
        this.insertionMode = r1;
        break;
      }
    }
  }
  _resetInsertionModeForSelect(e) {
    if (e > 0)
      for (let n = e - 1; n > 0; n--) {
        const r = this.openElements.items[n], i = this.treeAdapter.getTagName(r);
        if (i === o.TEMPLATE)
          break;
        if (i === o.TABLE) {
          this.insertionMode = Ai;
          return;
        }
      }
    this.insertionMode = gi;
  }
  _pushTmplInsertionMode(e) {
    this.tmplInsertionModeStack.push(e), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = e;
  }
  _popTmplInsertionMode() {
    this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
  }
  //Foster parenting
  _isElementCausesFosterParenting(e) {
    const n = this.treeAdapter.getTagName(e);
    return n === o.TABLE || n === o.TBODY || n === o.TFOOT || n === o.THEAD || n === o.TR;
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
  }
  _findFosterParentingLocation() {
    const e = {
      parent: null,
      beforeElement: null
    };
    for (let n = this.openElements.stackTop; n >= 0; n--) {
      const r = this.openElements.items[n], i = this.treeAdapter.getTagName(r), s = this.treeAdapter.getNamespaceURI(r);
      if (i === o.TEMPLATE && s === P.HTML) {
        e.parent = this.treeAdapter.getTemplateContent(r);
        break;
      } else if (i === o.TABLE) {
        e.parent = this.treeAdapter.getParentNode(r), e.parent ? e.beforeElement = r : e.parent = this.openElements.items[n - 1];
        break;
      }
    }
    return e.parent || (e.parent = this.openElements.items[0]), e;
  }
  _fosterParentElement(e) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, e, n.beforeElement) : this.treeAdapter.appendChild(n.parent, e);
  }
  _fosterParentText(e) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertTextBefore(n.parent, e, n.beforeElement) : this.treeAdapter.insertText(n.parent, e);
  }
  //Special elements
  _isSpecialElement(e) {
    const n = this.treeAdapter.getTagName(e), r = this.treeAdapter.getNamespaceURI(e);
    return z1.SPECIAL_ELEMENTS[r][n];
  }
};
var lm = am;
function cm(t, e) {
  let n = t.activeFormattingElements.getElementEntryInScopeWithTagName(e.tagName);
  return n ? t.openElements.contains(n.element) ? t.openElements.hasInScope(e.tagName) || (n = null) : (t.activeFormattingElements.removeEntry(n), n = null) : Ke(t, e), n;
}
function um(t, e) {
  let n = null;
  for (let r = t.openElements.stackTop; r >= 0; r--) {
    const i = t.openElements.items[r];
    if (i === e.element)
      break;
    t._isSpecialElement(i) && (n = i);
  }
  return n || (t.openElements.popUntilElementPopped(e.element), t.activeFormattingElements.removeEntry(e)), n;
}
function dm(t, e, n) {
  let r = e, i = t.openElements.getCommonAncestor(e);
  for (let s = 0, a = i; a !== n; s++, a = i) {
    i = t.openElements.getCommonAncestor(a);
    const c = t.activeFormattingElements.getElementEntry(a), l = c && s >= im;
    !c || l ? (l && t.activeFormattingElements.removeEntry(c), t.openElements.remove(a)) : (a = hm(t, c), r === e && (t.activeFormattingElements.bookmark = c), t.treeAdapter.detachNode(r), t.treeAdapter.appendChild(a, r), r = a);
  }
  return r;
}
function hm(t, e) {
  const n = t.treeAdapter.getNamespaceURI(e.element), r = t.treeAdapter.createElement(e.token.tagName, n, e.token.attrs);
  return t.openElements.replace(e.element, r), e.element = r, r;
}
function fm(t, e, n) {
  if (t._isElementCausesFosterParenting(e))
    t._fosterParentElement(n);
  else {
    const r = t.treeAdapter.getTagName(e), i = t.treeAdapter.getNamespaceURI(e);
    r === o.TEMPLATE && i === P.HTML && (e = t.treeAdapter.getTemplateContent(e)), t.treeAdapter.appendChild(e, n);
  }
}
function mm(t, e, n) {
  const r = t.treeAdapter.getNamespaceURI(n.element), i = n.token, s = t.treeAdapter.createElement(i.tagName, r, i.attrs);
  t._adoptNodes(e, s), t.treeAdapter.appendChild(e, s), t.activeFormattingElements.insertElementAfterBookmark(s, n.token), t.activeFormattingElements.removeEntry(n), t.openElements.remove(n.element), t.openElements.insertAfter(e, s);
}
function I1(t, e) {
  let n;
  for (let r = 0; r < rm && (n = cm(t, e), !!n); r++) {
    const i = um(t, n);
    if (!i)
      break;
    t.activeFormattingElements.bookmark = n;
    const s = dm(t, i, n.element), a = t.openElements.getCommonAncestor(n.element);
    t.treeAdapter.detachNode(s), fm(t, a, s), mm(t, i, n);
  }
}
function G() {
}
function gn(t) {
  t._err(Te.misplacedDoctype);
}
function le(t, e) {
  t._appendCommentNode(e, t.openElements.currentTmplContent || t.openElements.current);
}
function Tm(t, e) {
  t._appendCommentNode(e, t.openElements.items[0]);
}
function xs(t, e) {
  t._appendCommentNode(e, t.document);
}
function Oe(t, e) {
  t._insertCharacters(e);
}
function It(t) {
  t.stopped = !0;
}
function pm(t, e) {
  t._setDocumentType(e);
  const n = e.forceQuirks ? z1.DOCUMENT_MODE.QUIRKS : Os.getDocumentMode(e);
  Os.isConforming(e) || t._err(Te.nonConformingDoctype), t.treeAdapter.setDocumentMode(t.document, n), t.insertionMode = Ei;
}
function yt(t, e) {
  t._err(Te.missingDoctype, { beforeToken: !0 }), t.treeAdapter.setDocumentMode(t.document, z1.DOCUMENT_MODE.QUIRKS), t.insertionMode = Ei, t._processToken(e);
}
function Em(t, e) {
  e.tagName === o.HTML ? (t._insertElement(e, P.HTML), t.insertionMode = Kn) : Mt(t, e);
}
function gm(t, e) {
  const n = e.tagName;
  (n === o.HTML || n === o.HEAD || n === o.BODY || n === o.BR) && Mt(t, e);
}
function Mt(t, e) {
  t._insertFakeRootElement(), t.insertionMode = Kn, t._processToken(e);
}
function Am(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.HEAD ? (t._insertElement(e, P.HTML), t.headElement = t.openElements.current, t.insertionMode = mt) : Dt(t, e);
}
function _m(t, e) {
  const n = e.tagName;
  n === o.HEAD || n === o.BODY || n === o.HTML || n === o.BR ? Dt(t, e) : t._err(Te.endTagWithoutMatchingOpenElement);
}
function Dt(t, e) {
  t._insertFakeElement(o.HEAD), t.headElement = t.openElements.current, t.insertionMode = mt, t._processToken(e);
}
function de(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.BASE || n === o.BASEFONT || n === o.BGSOUND || n === o.LINK || n === o.META ? (t._appendElement(e, P.HTML), e.ackSelfClosing = !0) : n === o.TITLE ? t._switchToTextParsing(e, p.MODE.RCDATA) : n === o.NOSCRIPT ? t.options.scriptingEnabled ? t._switchToTextParsing(e, p.MODE.RAWTEXT) : (t._insertElement(e, P.HTML), t.insertionMode = kl) : n === o.NOFRAMES || n === o.STYLE ? t._switchToTextParsing(e, p.MODE.RAWTEXT) : n === o.SCRIPT ? t._switchToTextParsing(e, p.MODE.SCRIPT_DATA) : n === o.TEMPLATE ? (t._insertTemplate(e, P.HTML), t.activeFormattingElements.insertMarker(), t.framesetOk = !1, t.insertionMode = Mn, t._pushTmplInsertionMode(Mn)) : n === o.HEAD ? t._err(Te.misplacedStartTagForHeadElement) : kt(t, e);
}
function Y1(t, e) {
  const n = e.tagName;
  n === o.HEAD ? (t.openElements.pop(), t.insertionMode = zn) : n === o.BODY || n === o.BR || n === o.HTML ? kt(t, e) : n === o.TEMPLATE && t.openElements.tmplCount > 0 ? (t.openElements.generateImpliedEndTagsThoroughly(), t.openElements.currentTagName !== o.TEMPLATE && t._err(Te.closingOfElementWithOpenChildElements), t.openElements.popUntilTagNamePopped(o.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t._popTmplInsertionMode(), t._resetInsertionMode()) : t._err(Te.endTagWithoutMatchingOpenElement);
}
function kt(t, e) {
  t.openElements.pop(), t.insertionMode = zn, t._processToken(e);
}
function Cm(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.BASEFONT || n === o.BGSOUND || n === o.HEAD || n === o.LINK || n === o.META || n === o.NOFRAMES || n === o.STYLE ? de(t, e) : n === o.NOSCRIPT ? t._err(Te.nestedNoscriptInHead) : wt(t, e);
}
function Nm(t, e) {
  const n = e.tagName;
  n === o.NOSCRIPT ? (t.openElements.pop(), t.insertionMode = mt) : n === o.BR ? wt(t, e) : t._err(Te.endTagWithoutMatchingOpenElement);
}
function wt(t, e) {
  const n = e.type === p.EOF_TOKEN ? Te.openElementsLeftAfterEof : Te.disallowedContentInNoscriptInHead;
  t._err(n), t.openElements.pop(), t.insertionMode = mt, t._processToken(e);
}
function Sm(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.BODY ? (t._insertElement(e, P.HTML), t.framesetOk = !1, t.insertionMode = r1) : n === o.FRAMESET ? (t._insertElement(e, P.HTML), t.insertionMode = Vn) : n === o.BASE || n === o.BASEFONT || n === o.BGSOUND || n === o.LINK || n === o.META || n === o.NOFRAMES || n === o.SCRIPT || n === o.STYLE || n === o.TEMPLATE || n === o.TITLE ? (t._err(Te.abandonedHeadElementChild), t.openElements.push(t.headElement), de(t, e), t.openElements.remove(t.headElement)) : n === o.HEAD ? t._err(Te.misplacedStartTagForHeadElement) : Ht(t, e);
}
function Im(t, e) {
  const n = e.tagName;
  n === o.BODY || n === o.HTML || n === o.BR ? Ht(t, e) : n === o.TEMPLATE ? Y1(t, e) : t._err(Te.endTagWithoutMatchingOpenElement);
}
function Ht(t, e) {
  t._insertFakeElement(o.BODY), t.insertionMode = r1, t._processToken(e);
}
function w1(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e);
}
function An(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e), t.framesetOk = !1;
}
function ym(t, e) {
  t.openElements.tmplCount === 0 && t.treeAdapter.adoptAttributes(t.openElements.items[0], e.attrs);
}
function Om(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  n && t.openElements.tmplCount === 0 && (t.framesetOk = !1, t.treeAdapter.adoptAttributes(n, e.attrs));
}
function vm(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  t.framesetOk && n && (t.treeAdapter.detachNode(n), t.openElements.popAllUpToHtmlElement(), t._insertElement(e, P.HTML), t.insertionMode = Vn);
}
function c1(t, e) {
  t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._insertElement(e, P.HTML);
}
function xm(t, e) {
  t.openElements.hasInButtonScope(o.P) && t._closePElement();
  const n = t.openElements.currentTagName;
  (n === o.H1 || n === o.H2 || n === o.H3 || n === o.H4 || n === o.H5 || n === o.H6) && t.openElements.pop(), t._insertElement(e, P.HTML);
}
function Rs(t, e) {
  t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._insertElement(e, P.HTML), t.skipNextNewLine = !0, t.framesetOk = !1;
}
function Rm(t, e) {
  const n = t.openElements.tmplCount > 0;
  (!t.formElement || n) && (t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._insertElement(e, P.HTML), n || (t.formElement = t.openElements.current));
}
function bm(t, e) {
  t.framesetOk = !1;
  const n = e.tagName;
  for (let r = t.openElements.stackTop; r >= 0; r--) {
    const i = t.openElements.items[r], s = t.treeAdapter.getTagName(i);
    let a = null;
    if (n === o.LI && s === o.LI ? a = o.LI : (n === o.DD || n === o.DT) && (s === o.DD || s === o.DT) && (a = s), a) {
      t.openElements.generateImpliedEndTagsWithExclusion(a), t.openElements.popUntilTagNamePopped(a);
      break;
    }
    if (s !== o.ADDRESS && s !== o.DIV && s !== o.P && t._isSpecialElement(i))
      break;
  }
  t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._insertElement(e, P.HTML);
}
function Lm(t, e) {
  t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._insertElement(e, P.HTML), t.tokenizer.state = p.MODE.PLAINTEXT;
}
function Pm(t, e) {
  t.openElements.hasInScope(o.BUTTON) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(o.BUTTON)), t._reconstructActiveFormattingElements(), t._insertElement(e, P.HTML), t.framesetOk = !1;
}
function Mm(t, e) {
  const n = t.activeFormattingElements.getElementEntryInScopeWithTagName(o.A);
  n && (I1(t, e), t.openElements.remove(n.element), t.activeFormattingElements.removeEntry(n)), t._reconstructActiveFormattingElements(), t._insertElement(e, P.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function et(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, P.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function Dm(t, e) {
  t._reconstructActiveFormattingElements(), t.openElements.hasInScope(o.NOBR) && (I1(t, e), t._reconstructActiveFormattingElements()), t._insertElement(e, P.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function bs(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, P.HTML), t.activeFormattingElements.insertMarker(), t.framesetOk = !1;
}
function km(t, e) {
  t.treeAdapter.getDocumentMode(t.document) !== z1.DOCUMENT_MODE.QUIRKS && t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._insertElement(e, P.HTML), t.framesetOk = !1, t.insertionMode = Ee;
}
function rt(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, P.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function wm(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, P.HTML);
  const n = p.getTokenAttr(e, Pl.TYPE);
  (!n || n.toLowerCase() !== Ml) && (t.framesetOk = !1), e.ackSelfClosing = !0;
}
function Ls(t, e) {
  t._appendElement(e, P.HTML), e.ackSelfClosing = !0;
}
function Hm(t, e) {
  t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._appendElement(e, P.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function $m(t, e) {
  e.tagName = o.IMG, rt(t, e);
}
function Fm(t, e) {
  t._insertElement(e, P.HTML), t.skipNextNewLine = !0, t.tokenizer.state = p.MODE.RCDATA, t.originalInsertionMode = t.insertionMode, t.framesetOk = !1, t.insertionMode = Pn;
}
function Bm(t, e) {
  t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._reconstructActiveFormattingElements(), t.framesetOk = !1, t._switchToTextParsing(e, p.MODE.RAWTEXT);
}
function Um(t, e) {
  t.framesetOk = !1, t._switchToTextParsing(e, p.MODE.RAWTEXT);
}
function Ps(t, e) {
  t._switchToTextParsing(e, p.MODE.RAWTEXT);
}
function Gm(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, P.HTML), t.framesetOk = !1, t.insertionMode === Ee || t.insertionMode === Yn || t.insertionMode === we || t.insertionMode === m1 || t.insertionMode === Wn ? t.insertionMode = Ai : t.insertionMode = gi;
}
function Ms(t, e) {
  t.openElements.currentTagName === o.OPTION && t.openElements.pop(), t._reconstructActiveFormattingElements(), t._insertElement(e, P.HTML);
}
function Ds(t, e) {
  t.openElements.hasInScope(o.RUBY) && t.openElements.generateImpliedEndTags(), t._insertElement(e, P.HTML);
}
function Km(t, e) {
  t.openElements.hasInScope(o.RUBY) && t.openElements.generateImpliedEndTagsWithExclusion(o.RTC), t._insertElement(e, P.HTML);
}
function zm(t, e) {
  t.openElements.hasInButtonScope(o.P) && t._closePElement(), t._insertElement(e, P.HTML);
}
function Ym(t, e) {
  t._reconstructActiveFormattingElements(), e1.adjustTokenMathMLAttrs(e), e1.adjustTokenXMLAttrs(e), e.selfClosing ? t._appendElement(e, P.MATHML) : t._insertElement(e, P.MATHML), e.ackSelfClosing = !0;
}
function Wm(t, e) {
  t._reconstructActiveFormattingElements(), e1.adjustTokenSVGAttrs(e), e1.adjustTokenXMLAttrs(e), e.selfClosing ? t._appendElement(e, P.SVG) : t._insertElement(e, P.SVG), e.ackSelfClosing = !0;
}
function Pe(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, P.HTML);
}
function ve(t, e) {
  const n = e.tagName;
  switch (n.length) {
    case 1:
      n === o.I || n === o.S || n === o.B || n === o.U ? et(t, e) : n === o.P ? c1(t, e) : n === o.A ? Mm(t, e) : Pe(t, e);
      break;
    case 2:
      n === o.DL || n === o.OL || n === o.UL ? c1(t, e) : n === o.H1 || n === o.H2 || n === o.H3 || n === o.H4 || n === o.H5 || n === o.H6 ? xm(t, e) : n === o.LI || n === o.DD || n === o.DT ? bm(t, e) : n === o.EM || n === o.TT ? et(t, e) : n === o.BR ? rt(t, e) : n === o.HR ? Hm(t, e) : n === o.RB ? Ds(t, e) : n === o.RT || n === o.RP ? Km(t, e) : n !== o.TH && n !== o.TD && n !== o.TR && Pe(t, e);
      break;
    case 3:
      n === o.DIV || n === o.DIR || n === o.NAV ? c1(t, e) : n === o.PRE ? Rs(t, e) : n === o.BIG ? et(t, e) : n === o.IMG || n === o.WBR ? rt(t, e) : n === o.XMP ? Bm(t, e) : n === o.SVG ? Wm(t, e) : n === o.RTC ? Ds(t, e) : n !== o.COL && Pe(t, e);
      break;
    case 4:
      n === o.HTML ? ym(t, e) : n === o.BASE || n === o.LINK || n === o.META ? de(t, e) : n === o.BODY ? Om(t, e) : n === o.MAIN || n === o.MENU ? c1(t, e) : n === o.FORM ? Rm(t, e) : n === o.CODE || n === o.FONT ? et(t, e) : n === o.NOBR ? Dm(t, e) : n === o.AREA ? rt(t, e) : n === o.MATH ? Ym(t, e) : n === o.MENU ? zm(t, e) : n !== o.HEAD && Pe(t, e);
      break;
    case 5:
      n === o.STYLE || n === o.TITLE ? de(t, e) : n === o.ASIDE ? c1(t, e) : n === o.SMALL ? et(t, e) : n === o.TABLE ? km(t, e) : n === o.EMBED ? rt(t, e) : n === o.INPUT ? wm(t, e) : n === o.PARAM || n === o.TRACK ? Ls(t, e) : n === o.IMAGE ? $m(t, e) : n !== o.FRAME && n !== o.TBODY && n !== o.TFOOT && n !== o.THEAD && Pe(t, e);
      break;
    case 6:
      n === o.SCRIPT ? de(t, e) : n === o.CENTER || n === o.FIGURE || n === o.FOOTER || n === o.HEADER || n === o.HGROUP || n === o.DIALOG ? c1(t, e) : n === o.BUTTON ? Pm(t, e) : n === o.STRIKE || n === o.STRONG ? et(t, e) : n === o.APPLET || n === o.OBJECT ? bs(t, e) : n === o.KEYGEN ? rt(t, e) : n === o.SOURCE ? Ls(t, e) : n === o.IFRAME ? Um(t, e) : n === o.SELECT ? Gm(t, e) : n === o.OPTION ? Ms(t, e) : Pe(t, e);
      break;
    case 7:
      n === o.BGSOUND ? de(t, e) : n === o.DETAILS || n === o.ADDRESS || n === o.ARTICLE || n === o.SECTION || n === o.SUMMARY ? c1(t, e) : n === o.LISTING ? Rs(t, e) : n === o.MARQUEE ? bs(t, e) : n === o.NOEMBED ? Ps(t, e) : n !== o.CAPTION && Pe(t, e);
      break;
    case 8:
      n === o.BASEFONT ? de(t, e) : n === o.FRAMESET ? vm(t, e) : n === o.FIELDSET ? c1(t, e) : n === o.TEXTAREA ? Fm(t, e) : n === o.TEMPLATE ? de(t, e) : n === o.NOSCRIPT ? t.options.scriptingEnabled ? Ps(t, e) : Pe(t, e) : n === o.OPTGROUP ? Ms(t, e) : n !== o.COLGROUP && Pe(t, e);
      break;
    case 9:
      n === o.PLAINTEXT ? Lm(t, e) : Pe(t, e);
      break;
    case 10:
      n === o.BLOCKQUOTE || n === o.FIGCAPTION ? c1(t, e) : Pe(t, e);
      break;
    default:
      Pe(t, e);
  }
}
function Vm(t) {
  t.openElements.hasInScope(o.BODY) && (t.insertionMode = _i);
}
function jm(t, e) {
  t.openElements.hasInScope(o.BODY) && (t.insertionMode = _i, t._processToken(e));
}
function C1(t, e) {
  const n = e.tagName;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n));
}
function Xm(t) {
  const e = t.openElements.tmplCount > 0, n = t.formElement;
  e || (t.formElement = null), (n || e) && t.openElements.hasInScope(o.FORM) && (t.openElements.generateImpliedEndTags(), e ? t.openElements.popUntilTagNamePopped(o.FORM) : t.openElements.remove(n));
}
function Qm(t) {
  t.openElements.hasInButtonScope(o.P) || t._insertFakeElement(o.P), t._closePElement();
}
function qm(t) {
  t.openElements.hasInListItemScope(o.LI) && (t.openElements.generateImpliedEndTagsWithExclusion(o.LI), t.openElements.popUntilTagNamePopped(o.LI));
}
function Zm(t, e) {
  const n = e.tagName;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTagsWithExclusion(n), t.openElements.popUntilTagNamePopped(n));
}
function Jm(t) {
  t.openElements.hasNumberedHeaderInScope() && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilNumberedHeaderPopped());
}
function ks(t, e) {
  const n = e.tagName;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker());
}
function e8(t) {
  t._reconstructActiveFormattingElements(), t._insertFakeElement(o.BR), t.openElements.pop(), t.framesetOk = !1;
}
function Ke(t, e) {
  const n = e.tagName;
  for (let r = t.openElements.stackTop; r > 0; r--) {
    const i = t.openElements.items[r];
    if (t.treeAdapter.getTagName(i) === n) {
      t.openElements.generateImpliedEndTagsWithExclusion(n), t.openElements.popUntilElementPopped(i);
      break;
    }
    if (t._isSpecialElement(i))
      break;
  }
}
function Ci(t, e) {
  const n = e.tagName;
  switch (n.length) {
    case 1:
      n === o.A || n === o.B || n === o.I || n === o.S || n === o.U ? I1(t, e) : n === o.P ? Qm(t) : Ke(t, e);
      break;
    case 2:
      n === o.DL || n === o.UL || n === o.OL ? C1(t, e) : n === o.LI ? qm(t) : n === o.DD || n === o.DT ? Zm(t, e) : n === o.H1 || n === o.H2 || n === o.H3 || n === o.H4 || n === o.H5 || n === o.H6 ? Jm(t) : n === o.BR ? e8(t) : n === o.EM || n === o.TT ? I1(t, e) : Ke(t, e);
      break;
    case 3:
      n === o.BIG ? I1(t, e) : n === o.DIR || n === o.DIV || n === o.NAV || n === o.PRE ? C1(t, e) : Ke(t, e);
      break;
    case 4:
      n === o.BODY ? Vm(t) : n === o.HTML ? jm(t, e) : n === o.FORM ? Xm(t) : n === o.CODE || n === o.FONT || n === o.NOBR ? I1(t, e) : n === o.MAIN || n === o.MENU ? C1(t, e) : Ke(t, e);
      break;
    case 5:
      n === o.ASIDE ? C1(t, e) : n === o.SMALL ? I1(t, e) : Ke(t, e);
      break;
    case 6:
      n === o.CENTER || n === o.FIGURE || n === o.FOOTER || n === o.HEADER || n === o.HGROUP || n === o.DIALOG ? C1(t, e) : n === o.APPLET || n === o.OBJECT ? ks(t, e) : n === o.STRIKE || n === o.STRONG ? I1(t, e) : Ke(t, e);
      break;
    case 7:
      n === o.ADDRESS || n === o.ARTICLE || n === o.DETAILS || n === o.SECTION || n === o.SUMMARY || n === o.LISTING ? C1(t, e) : n === o.MARQUEE ? ks(t, e) : Ke(t, e);
      break;
    case 8:
      n === o.FIELDSET ? C1(t, e) : n === o.TEMPLATE ? Y1(t, e) : Ke(t, e);
      break;
    case 10:
      n === o.BLOCKQUOTE || n === o.FIGCAPTION ? C1(t, e) : Ke(t, e);
      break;
    default:
      Ke(t, e);
  }
}
function u1(t, e) {
  t.tmplInsertionModeStackTop > -1 ? Gl(t, e) : t.stopped = !0;
}
function t8(t, e) {
  e.tagName === o.SCRIPT && (t.pendingScript = t.openElements.current), t.openElements.pop(), t.insertionMode = t.originalInsertionMode;
}
function n8(t, e) {
  t._err(Te.eofInElementThatCanContainOnlyText), t.openElements.pop(), t.insertionMode = t.originalInsertionMode, t._processToken(e);
}
function d1(t, e) {
  const n = t.openElements.currentTagName;
  n === o.TABLE || n === o.TBODY || n === o.TFOOT || n === o.THEAD || n === o.TR ? (t.pendingCharacterTokens = [], t.hasNonWhitespacePendingCharacterToken = !1, t.originalInsertionMode = t.insertionMode, t.insertionMode = wl, t._processToken(e)) : ke(t, e);
}
function r8(t, e) {
  t.openElements.clearBackToTableContext(), t.activeFormattingElements.insertMarker(), t._insertElement(e, P.HTML), t.insertionMode = Yn;
}
function i8(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, P.HTML), t.insertionMode = Qt;
}
function o8(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(o.COLGROUP), t.insertionMode = Qt, t._processToken(e);
}
function s8(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, P.HTML), t.insertionMode = we;
}
function a8(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(o.TBODY), t.insertionMode = we, t._processToken(e);
}
function l8(t, e) {
  t.openElements.hasInTableScope(o.TABLE) && (t.openElements.popUntilTagNamePopped(o.TABLE), t._resetInsertionMode(), t._processToken(e));
}
function c8(t, e) {
  const n = p.getTokenAttr(e, Pl.TYPE);
  n && n.toLowerCase() === Ml ? t._appendElement(e, P.HTML) : ke(t, e), e.ackSelfClosing = !0;
}
function u8(t, e) {
  !t.formElement && t.openElements.tmplCount === 0 && (t._insertElement(e, P.HTML), t.formElement = t.openElements.current, t.openElements.pop());
}
function Ni(t, e) {
  const n = e.tagName;
  switch (n.length) {
    case 2:
      n === o.TD || n === o.TH || n === o.TR ? a8(t, e) : ke(t, e);
      break;
    case 3:
      n === o.COL ? o8(t, e) : ke(t, e);
      break;
    case 4:
      n === o.FORM ? u8(t, e) : ke(t, e);
      break;
    case 5:
      n === o.TABLE ? l8(t, e) : n === o.STYLE ? de(t, e) : n === o.TBODY || n === o.TFOOT || n === o.THEAD ? s8(t, e) : n === o.INPUT ? c8(t, e) : ke(t, e);
      break;
    case 6:
      n === o.SCRIPT ? de(t, e) : ke(t, e);
      break;
    case 7:
      n === o.CAPTION ? r8(t, e) : ke(t, e);
      break;
    case 8:
      n === o.COLGROUP ? i8(t, e) : n === o.TEMPLATE ? de(t, e) : ke(t, e);
      break;
    default:
      ke(t, e);
  }
}
function Si(t, e) {
  const n = e.tagName;
  n === o.TABLE ? t.openElements.hasInTableScope(o.TABLE) && (t.openElements.popUntilTagNamePopped(o.TABLE), t._resetInsertionMode()) : n === o.TEMPLATE ? Y1(t, e) : n !== o.BODY && n !== o.CAPTION && n !== o.COL && n !== o.COLGROUP && n !== o.HTML && n !== o.TBODY && n !== o.TD && n !== o.TFOOT && n !== o.TH && n !== o.THEAD && n !== o.TR && ke(t, e);
}
function ke(t, e) {
  const n = t.fosterParentingEnabled;
  t.fosterParentingEnabled = !0, t._processTokenInBodyMode(e), t.fosterParentingEnabled = n;
}
function d8(t, e) {
  t.pendingCharacterTokens.push(e);
}
function h8(t, e) {
  t.pendingCharacterTokens.push(e), t.hasNonWhitespacePendingCharacterToken = !0;
}
function Ot(t, e) {
  let n = 0;
  if (t.hasNonWhitespacePendingCharacterToken)
    for (; n < t.pendingCharacterTokens.length; n++)
      ke(t, t.pendingCharacterTokens[n]);
  else
    for (; n < t.pendingCharacterTokens.length; n++)
      t._insertCharacters(t.pendingCharacterTokens[n]);
  t.insertionMode = t.originalInsertionMode, t._processToken(e);
}
function f8(t, e) {
  const n = e.tagName;
  n === o.CAPTION || n === o.COL || n === o.COLGROUP || n === o.TBODY || n === o.TD || n === o.TFOOT || n === o.TH || n === o.THEAD || n === o.TR ? t.openElements.hasInTableScope(o.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(o.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = Ee, t._processToken(e)) : ve(t, e);
}
function m8(t, e) {
  const n = e.tagName;
  n === o.CAPTION || n === o.TABLE ? t.openElements.hasInTableScope(o.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(o.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = Ee, n === o.TABLE && t._processToken(e)) : n !== o.BODY && n !== o.COL && n !== o.COLGROUP && n !== o.HTML && n !== o.TBODY && n !== o.TD && n !== o.TFOOT && n !== o.TH && n !== o.THEAD && n !== o.TR && Ci(t, e);
}
function T8(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.COL ? (t._appendElement(e, P.HTML), e.ackSelfClosing = !0) : n === o.TEMPLATE ? de(t, e) : Dn(t, e);
}
function p8(t, e) {
  const n = e.tagName;
  n === o.COLGROUP ? t.openElements.currentTagName === o.COLGROUP && (t.openElements.pop(), t.insertionMode = Ee) : n === o.TEMPLATE ? Y1(t, e) : n !== o.COL && Dn(t, e);
}
function Dn(t, e) {
  t.openElements.currentTagName === o.COLGROUP && (t.openElements.pop(), t.insertionMode = Ee, t._processToken(e));
}
function E8(t, e) {
  const n = e.tagName;
  n === o.TR ? (t.openElements.clearBackToTableBodyContext(), t._insertElement(e, P.HTML), t.insertionMode = m1) : n === o.TH || n === o.TD ? (t.openElements.clearBackToTableBodyContext(), t._insertFakeElement(o.TR), t.insertionMode = m1, t._processToken(e)) : n === o.CAPTION || n === o.COL || n === o.COLGROUP || n === o.TBODY || n === o.TFOOT || n === o.THEAD ? t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Ee, t._processToken(e)) : Ni(t, e);
}
function g8(t, e) {
  const n = e.tagName;
  n === o.TBODY || n === o.TFOOT || n === o.THEAD ? t.openElements.hasInTableScope(n) && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Ee) : n === o.TABLE ? t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Ee, t._processToken(e)) : (n !== o.BODY && n !== o.CAPTION && n !== o.COL && n !== o.COLGROUP || n !== o.HTML && n !== o.TD && n !== o.TH && n !== o.TR) && Si(t, e);
}
function A8(t, e) {
  const n = e.tagName;
  n === o.TH || n === o.TD ? (t.openElements.clearBackToTableRowContext(), t._insertElement(e, P.HTML), t.insertionMode = Wn, t.activeFormattingElements.insertMarker()) : n === o.CAPTION || n === o.COL || n === o.COLGROUP || n === o.TBODY || n === o.TFOOT || n === o.THEAD || n === o.TR ? t.openElements.hasInTableScope(o.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = we, t._processToken(e)) : Ni(t, e);
}
function _8(t, e) {
  const n = e.tagName;
  n === o.TR ? t.openElements.hasInTableScope(o.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = we) : n === o.TABLE ? t.openElements.hasInTableScope(o.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = we, t._processToken(e)) : n === o.TBODY || n === o.TFOOT || n === o.THEAD ? (t.openElements.hasInTableScope(n) || t.openElements.hasInTableScope(o.TR)) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = we, t._processToken(e)) : (n !== o.BODY && n !== o.CAPTION && n !== o.COL && n !== o.COLGROUP || n !== o.HTML && n !== o.TD && n !== o.TH) && Si(t, e);
}
function C8(t, e) {
  const n = e.tagName;
  n === o.CAPTION || n === o.COL || n === o.COLGROUP || n === o.TBODY || n === o.TD || n === o.TFOOT || n === o.TH || n === o.THEAD || n === o.TR ? (t.openElements.hasInTableScope(o.TD) || t.openElements.hasInTableScope(o.TH)) && (t._closeTableCell(), t._processToken(e)) : ve(t, e);
}
function N8(t, e) {
  const n = e.tagName;
  n === o.TD || n === o.TH ? t.openElements.hasInTableScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = m1) : n === o.TABLE || n === o.TBODY || n === o.TFOOT || n === o.THEAD || n === o.TR ? t.openElements.hasInTableScope(n) && (t._closeTableCell(), t._processToken(e)) : n !== o.BODY && n !== o.CAPTION && n !== o.COL && n !== o.COLGROUP && n !== o.HTML && Ci(t, e);
}
function Bl(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.OPTION ? (t.openElements.currentTagName === o.OPTION && t.openElements.pop(), t._insertElement(e, P.HTML)) : n === o.OPTGROUP ? (t.openElements.currentTagName === o.OPTION && t.openElements.pop(), t.openElements.currentTagName === o.OPTGROUP && t.openElements.pop(), t._insertElement(e, P.HTML)) : n === o.INPUT || n === o.KEYGEN || n === o.TEXTAREA || n === o.SELECT ? t.openElements.hasInSelectScope(o.SELECT) && (t.openElements.popUntilTagNamePopped(o.SELECT), t._resetInsertionMode(), n !== o.SELECT && t._processToken(e)) : (n === o.SCRIPT || n === o.TEMPLATE) && de(t, e);
}
function Ul(t, e) {
  const n = e.tagName;
  if (n === o.OPTGROUP) {
    const r = t.openElements.items[t.openElements.stackTop - 1], i = r && t.treeAdapter.getTagName(r);
    t.openElements.currentTagName === o.OPTION && i === o.OPTGROUP && t.openElements.pop(), t.openElements.currentTagName === o.OPTGROUP && t.openElements.pop();
  } else
    n === o.OPTION ? t.openElements.currentTagName === o.OPTION && t.openElements.pop() : n === o.SELECT && t.openElements.hasInSelectScope(o.SELECT) ? (t.openElements.popUntilTagNamePopped(o.SELECT), t._resetInsertionMode()) : n === o.TEMPLATE && Y1(t, e);
}
function S8(t, e) {
  const n = e.tagName;
  n === o.CAPTION || n === o.TABLE || n === o.TBODY || n === o.TFOOT || n === o.THEAD || n === o.TR || n === o.TD || n === o.TH ? (t.openElements.popUntilTagNamePopped(o.SELECT), t._resetInsertionMode(), t._processToken(e)) : Bl(t, e);
}
function I8(t, e) {
  const n = e.tagName;
  n === o.CAPTION || n === o.TABLE || n === o.TBODY || n === o.TFOOT || n === o.THEAD || n === o.TR || n === o.TD || n === o.TH ? t.openElements.hasInTableScope(n) && (t.openElements.popUntilTagNamePopped(o.SELECT), t._resetInsertionMode(), t._processToken(e)) : Ul(t, e);
}
function y8(t, e) {
  const n = e.tagName;
  if (n === o.BASE || n === o.BASEFONT || n === o.BGSOUND || n === o.LINK || n === o.META || n === o.NOFRAMES || n === o.SCRIPT || n === o.STYLE || n === o.TEMPLATE || n === o.TITLE)
    de(t, e);
  else {
    const r = sm[n] || r1;
    t._popTmplInsertionMode(), t._pushTmplInsertionMode(r), t.insertionMode = r, t._processToken(e);
  }
}
function O8(t, e) {
  e.tagName === o.TEMPLATE && Y1(t, e);
}
function Gl(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.popUntilTagNamePopped(o.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t._popTmplInsertionMode(), t._resetInsertionMode(), t._processToken(e)) : t.stopped = !0;
}
function v8(t, e) {
  e.tagName === o.HTML ? ve(t, e) : kn(t, e);
}
function x8(t, e) {
  e.tagName === o.HTML ? t.fragmentContext || (t.insertionMode = $l) : kn(t, e);
}
function kn(t, e) {
  t.insertionMode = r1, t._processToken(e);
}
function R8(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.FRAMESET ? t._insertElement(e, P.HTML) : n === o.FRAME ? (t._appendElement(e, P.HTML), e.ackSelfClosing = !0) : n === o.NOFRAMES && de(t, e);
}
function b8(t, e) {
  e.tagName === o.FRAMESET && !t.openElements.isRootHtmlElementCurrent() && (t.openElements.pop(), !t.fragmentContext && t.openElements.currentTagName !== o.FRAMESET && (t.insertionMode = Hl));
}
function L8(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.NOFRAMES && de(t, e);
}
function P8(t, e) {
  e.tagName === o.HTML && (t.insertionMode = Fl);
}
function M8(t, e) {
  e.tagName === o.HTML ? ve(t, e) : On(t, e);
}
function On(t, e) {
  t.insertionMode = r1, t._processToken(e);
}
function D8(t, e) {
  const n = e.tagName;
  n === o.HTML ? ve(t, e) : n === o.NOFRAMES && de(t, e);
}
function k8(t, e) {
  e.chars = tm.REPLACEMENT_CHARACTER, t._insertCharacters(e);
}
function w8(t, e) {
  t._insertCharacters(e), t.framesetOk = !1;
}
function H8(t, e) {
  if (e1.causesExit(e) && !t.fragmentContext) {
    for (; t.treeAdapter.getNamespaceURI(t.openElements.current) !== P.HTML && !t._isIntegrationPoint(t.openElements.current); )
      t.openElements.pop();
    t._processToken(e);
  } else {
    const n = t._getAdjustedCurrentElement(), r = t.treeAdapter.getNamespaceURI(n);
    r === P.MATHML ? e1.adjustTokenMathMLAttrs(e) : r === P.SVG && (e1.adjustTokenSVGTagName(e), e1.adjustTokenSVGAttrs(e)), e1.adjustTokenXMLAttrs(e), e.selfClosing ? t._appendElement(e, r) : t._insertElement(e, r), e.ackSelfClosing = !0;
  }
}
function $8(t, e) {
  for (let n = t.openElements.stackTop; n > 0; n--) {
    const r = t.openElements.items[n];
    if (t.treeAdapter.getNamespaceURI(r) === P.HTML) {
      t._processToken(e);
      break;
    }
    if (t.treeAdapter.getTagName(r).toLowerCase() === e.tagName) {
      t.openElements.popUntilElementPopped(r);
      break;
    }
  }
}
var Kl = Yl("start"), zl = Yl("end"), F8 = Ii;
Ii.start = Kl;
Ii.end = zl;
function Ii(t) {
  return { start: Kl(t), end: zl(t) };
}
function Yl(t) {
  return e.displayName = t, e;
  function e(n) {
    var r = n && n.position && n.position[t] || {};
    return {
      line: r.line || null,
      column: r.column || null,
      offset: isNaN(r.offset) ? null : r.offset
    };
  }
}
var Wl = Vl;
function Vl(t) {
  if (t == null)
    return K8;
  if (typeof t == "string")
    return G8(t);
  if (typeof t == "object")
    return "length" in t ? U8(t) : B8(t);
  if (typeof t == "function")
    return t;
  throw new Error("Expected function, string, or object as test");
}
function B8(t) {
  return e;
  function e(n) {
    var r;
    for (r in t)
      if (n[r] !== t[r])
        return !1;
    return !0;
  }
}
function U8(t) {
  for (var e = [], n = -1; ++n < t.length; )
    e[n] = Vl(t[n]);
  return r;
  function r() {
    for (var i = -1; ++i < e.length; )
      if (e[i].apply(this, arguments))
        return !0;
    return !1;
  }
}
function G8(t) {
  return e;
  function e(n) {
    return !!(n && n.type === t);
  }
}
function K8() {
  return !0;
}
var z8 = Y8;
function Y8(t) {
  return t;
}
var W8 = jn, V8 = Wl, j8 = z8, jl = !0, Xl = "skip", Gr = !1;
jn.CONTINUE = jl;
jn.SKIP = Xl;
jn.EXIT = Gr;
function jn(t, e, n, r) {
  var i, s;
  typeof e == "function" && typeof n != "function" && (r = n, n = e, e = null), s = V8(e), i = r ? -1 : 1, a(t, null, [])();
  function a(c, l, u) {
    var g = typeof c == "object" && c !== null ? c : {}, A;
    return typeof g.type == "string" && (A = typeof g.tagName == "string" ? g.tagName : typeof g.name == "string" ? g.name : void 0, S.displayName = "node (" + j8(g.type + (A ? "<" + A + ">" : "")) + ")"), S;
    function S() {
      var C = u.concat(c), y = [], N, v;
      if ((!e || s(c, l, u[u.length - 1] || null)) && (y = X8(n(c, u)), y[0] === Gr))
        return y;
      if (c.children && y[0] !== Xl)
        for (v = (r ? c.children.length : -1) + i; v > -1 && v < c.children.length; ) {
          if (N = a(c.children[v], v, C)(), N[0] === Gr)
            return N;
          v = typeof N[1] == "number" ? N[1] : v + i;
        }
      return y;
    }
  }
}
function X8(t) {
  return t !== null && typeof t == "object" && "length" in t ? t : typeof t == "number" ? [jl, t] : [t];
}
var Q8 = Qn, Xn = W8, q8 = Xn.CONTINUE, Z8 = Xn.SKIP, J8 = Xn.EXIT;
Qn.CONTINUE = q8;
Qn.SKIP = Z8;
Qn.EXIT = J8;
function Qn(t, e, n, r) {
  typeof e == "function" && typeof n != "function" && (r = n, n = e, e = null), Xn(t, e, i, r);
  function i(s, a) {
    var c = a[a.length - 1], l = c ? c.children.indexOf(s) : null;
    return n(s, l, c);
  }
}
var yi = tT, eT = Object.prototype.hasOwnProperty;
function tT() {
  for (var t = {}, e = 0; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      eT.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
var Ql = ql, Oi = ql.prototype;
Oi.space = null;
Oi.normal = {};
Oi.property = {};
function ql(t, e, n) {
  this.property = t, this.normal = e, n && (this.space = n);
}
var ws = yi, nT = Ql, Zl = rT;
function rT(t) {
  for (var e = t.length, n = [], r = [], i = -1, s, a; ++i < e; )
    s = t[i], n.push(s.property), r.push(s.normal), a = s.space;
  return new nT(
    ws.apply(null, n),
    ws.apply(null, r),
    a
  );
}
var vi = iT;
function iT(t) {
  return t.toLowerCase();
}
var Jl = ec, Fe = ec.prototype;
Fe.space = null;
Fe.attribute = null;
Fe.property = null;
Fe.boolean = !1;
Fe.booleanish = !1;
Fe.overloadedBoolean = !1;
Fe.number = !1;
Fe.commaSeparated = !1;
Fe.spaceSeparated = !1;
Fe.commaOrSpaceSeparated = !1;
Fe.mustUseProperty = !1;
Fe.defined = !1;
function ec(t, e) {
  this.property = t, this.attribute = e;
}
var Xe = {}, oT = 0;
Xe.boolean = W1();
Xe.booleanish = W1();
Xe.overloadedBoolean = W1();
Xe.number = W1();
Xe.spaceSeparated = W1();
Xe.commaSeparated = W1();
Xe.commaOrSpaceSeparated = W1();
function W1() {
  return Math.pow(2, ++oT);
}
var tc = Jl, Hs = Xe, nc = xi;
xi.prototype = new tc();
xi.prototype.defined = !0;
var rc = [
  "boolean",
  "booleanish",
  "overloadedBoolean",
  "number",
  "commaSeparated",
  "spaceSeparated",
  "commaOrSpaceSeparated"
], sT = rc.length;
function xi(t, e, n, r) {
  var i = -1, s;
  for ($s(this, "space", r), tc.call(this, t, e); ++i < sT; )
    s = rc[i], $s(this, s, (n & Hs[s]) === Hs[s]);
}
function $s(t, e, n) {
  n && (t[e] = n);
}
var Fs = vi, aT = Ql, lT = nc, Tt = cT;
function cT(t) {
  var e = t.space, n = t.mustUseProperty || [], r = t.attributes || {}, i = t.properties, s = t.transform, a = {}, c = {}, l, u;
  for (l in i)
    u = new lT(
      l,
      s(r, l),
      i[l],
      e
    ), n.indexOf(l) !== -1 && (u.mustUseProperty = !0), a[l] = u, c[Fs(l)] = l, c[Fs(u.attribute)] = l;
  return new aT(a, c, e);
}
var uT = Tt, ic = uT({
  space: "xlink",
  transform: dT,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
function dT(t, e) {
  return "xlink:" + e.slice(5).toLowerCase();
}
var hT = Tt, oc = hT({
  space: "xml",
  transform: fT,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});
function fT(t, e) {
  return "xml:" + e.slice(3).toLowerCase();
}
var sc = mT;
function mT(t, e) {
  return e in t ? t[e] : e;
}
var TT = sc, ac = pT;
function pT(t, e) {
  return TT(t, e.toLowerCase());
}
var ET = Tt, gT = ac, lc = ET({
  space: "xmlns",
  attributes: {
    xmlnsxlink: "xmlns:xlink"
  },
  transform: gT,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
}), Ri = Xe, AT = Tt, Ie = Ri.booleanish, Me = Ri.number, H1 = Ri.spaceSeparated, cc = AT({
  transform: _T,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ie,
    ariaAutoComplete: null,
    ariaBusy: Ie,
    ariaChecked: Ie,
    ariaColCount: Me,
    ariaColIndex: Me,
    ariaColSpan: Me,
    ariaControls: H1,
    ariaCurrent: null,
    ariaDescribedBy: H1,
    ariaDetails: null,
    ariaDisabled: Ie,
    ariaDropEffect: H1,
    ariaErrorMessage: null,
    ariaExpanded: Ie,
    ariaFlowTo: H1,
    ariaGrabbed: Ie,
    ariaHasPopup: null,
    ariaHidden: Ie,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: H1,
    ariaLevel: Me,
    ariaLive: null,
    ariaModal: Ie,
    ariaMultiLine: Ie,
    ariaMultiSelectable: Ie,
    ariaOrientation: null,
    ariaOwns: H1,
    ariaPlaceholder: null,
    ariaPosInSet: Me,
    ariaPressed: Ie,
    ariaReadOnly: Ie,
    ariaRelevant: null,
    ariaRequired: Ie,
    ariaRoleDescription: H1,
    ariaRowCount: Me,
    ariaRowIndex: Me,
    ariaRowSpan: Me,
    ariaSelected: Ie,
    ariaSetSize: Me,
    ariaSort: null,
    ariaValueMax: Me,
    ariaValueMin: Me,
    ariaValueNow: Me,
    ariaValueText: null,
    role: null
  }
});
function _T(t, e) {
  return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
}
var qt = Xe, CT = Tt, NT = sc, ST = qt.boolean, w = qt.number, Bs = qt.spaceSeparated, br = qt.commaSeparated, De = qt.commaOrSpaceSeparated, IT = CT({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: NT,
  properties: {
    about: De,
    accentHeight: w,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: w,
    amplitude: w,
    arabicForm: null,
    ascent: w,
    attributeName: null,
    attributeType: null,
    azimuth: w,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: w,
    by: null,
    calcMode: null,
    capHeight: w,
    className: Bs,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: w,
    diffuseConstant: w,
    direction: null,
    display: null,
    dur: null,
    divisor: w,
    dominantBaseline: null,
    download: ST,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: w,
    enableBackground: null,
    end: null,
    event: null,
    exponent: w,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: w,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: br,
    g2: br,
    glyphName: br,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: w,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: w,
    horizOriginX: w,
    horizOriginY: w,
    id: null,
    ideographic: w,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: w,
    k: w,
    k1: w,
    k2: w,
    k3: w,
    k4: w,
    kernelMatrix: De,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: w,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: w,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: w,
    overlineThickness: w,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: w,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Bs,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: w,
    pointsAtY: w,
    pointsAtZ: w,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: De,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: De,
    rev: De,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: De,
    requiredFeatures: De,
    requiredFonts: De,
    requiredFormats: De,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: w,
    specularExponent: w,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: w,
    strikethroughThickness: w,
    string: null,
    stroke: null,
    strokeDashArray: De,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: w,
    strokeOpacity: w,
    strokeWidth: null,
    style: null,
    surfaceScale: w,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: De,
    tabIndex: w,
    tableValues: null,
    target: null,
    targetX: w,
    targetY: w,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: De,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: w,
    underlineThickness: w,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: w,
    values: null,
    vAlphabetic: w,
    vMathematical: w,
    vectorEffect: null,
    vHanging: w,
    vIdeographic: w,
    version: null,
    vertAdvY: w,
    vertOriginX: w,
    vertOriginY: w,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: w,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), yT = Zl, OT = ic, vT = oc, xT = lc, RT = cc, bT = IT, qn = yT([vT, OT, xT, RT, bT]);
const LT = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
];
var PT = vi, MT = nc, DT = Jl, bi = "data", Zn = HT, kT = /^data[-\w.:]+$/i, uc = /-[a-z]/g, wT = /[A-Z]/g;
function HT(t, e) {
  var n = PT(e), r = e, i = DT;
  return n in t.normal ? t.property[t.normal[n]] : (n.length > 4 && n.slice(0, 4) === bi && kT.test(e) && (e.charAt(4) === "-" ? r = $T(e) : e = FT(e), i = MT), new i(r, e));
}
function $T(t) {
  var e = t.slice(5).replace(uc, UT);
  return bi + e.charAt(0).toUpperCase() + e.slice(1);
}
function FT(t) {
  var e = t.slice(4);
  return uc.test(e) ? t : (e = e.replace(wT, BT), e.charAt(0) !== "-" && (e = "-" + e), bi + e);
}
function BT(t) {
  return "-" + t.toLowerCase();
}
function UT(t) {
  return t.charAt(1).toUpperCase();
}
var GT = KT, Us = /[#.]/g;
function KT(t, e) {
  for (var n = t || "", r = e || "div", i = {}, s = 0, a, c, l; s < n.length; )
    Us.lastIndex = s, l = Us.exec(n), a = n.slice(s, l ? l.index : n.length), a && (c ? c === "#" ? i.id = a : i.className ? i.className.push(a) : i.className = [a] : r = a, s += a.length), l && (c = l[0], s++);
  return { type: "element", tagName: r, properties: i, children: [] };
}
var Jn = {};
Jn.parse = WT;
Jn.stringify = VT;
var Gs = "", zT = " ", YT = /[ \t\n\r\f]+/g;
function WT(t) {
  var e = String(t || Gs).trim();
  return e === Gs ? [] : e.split(YT);
}
function VT(t) {
  return t.join(zT).trim();
}
var er = {};
er.parse = jT;
er.stringify = XT;
var Kr = ",", Ks = " ", bt = "";
function jT(t) {
  for (var e = [], n = String(t || bt), r = n.indexOf(Kr), i = 0, s = !1, a; !s; )
    r === -1 && (r = n.length, s = !0), a = n.slice(i, r).trim(), (a || !s) && e.push(a), i = r + 1, r = n.indexOf(Kr, i);
  return e;
}
function XT(t, e) {
  var n = e || {}, r = n.padLeft === !1 ? bt : Ks, i = n.padRight ? Ks : bt;
  return t[t.length - 1] === bt && (t = t.concat(bt)), t.join(i + Kr + r).trim();
}
var QT = Zn, zs = vi, qT = GT, Ys = Jn.parse, Ws = er.parse, dc = JT, ZT = {}.hasOwnProperty;
function JT(t, e, n) {
  var r = n ? ip(n) : null;
  return i;
  function i(a, c) {
    var l = qT(a, e), u = Array.prototype.slice.call(arguments, 2), g = l.tagName.toLowerCase(), A;
    if (l.tagName = r && ZT.call(r, g) ? r[g] : g, c && ep(c, l) && (u.unshift(c), c = null), c)
      for (A in c)
        s(l.properties, A, c[A]);
    return hc(l.children, u), l.tagName === "template" && (l.content = { type: "root", children: l.children }, l.children = []), l;
  }
  function s(a, c, l) {
    var u, g, A;
    l == null || l !== l || (u = QT(t, c), g = u.property, A = l, typeof A == "string" && (u.spaceSeparated ? A = Ys(A) : u.commaSeparated ? A = Ws(A) : u.commaOrSpaceSeparated && (A = Ys(Ws(A).join(" ")))), g === "style" && typeof l != "string" && (A = rp(A)), g === "className" && a.className && (A = a.className.concat(A)), a[g] = np(u, g, A));
  }
}
function ep(t, e) {
  return typeof t == "string" || "length" in t || tp(e.tagName, t);
}
function tp(t, e) {
  var n = e.type;
  return t === "input" || !n || typeof n != "string" ? !1 : typeof e.children == "object" && "length" in e.children ? !0 : (n = n.toLowerCase(), t === "button" ? n !== "menu" && n !== "submit" && n !== "reset" && n !== "button" : "value" in e);
}
function hc(t, e) {
  var n, r;
  if (typeof e == "string" || typeof e == "number") {
    t.push({ type: "text", value: String(e) });
    return;
  }
  if (typeof e == "object" && "length" in e) {
    for (n = -1, r = e.length; ++n < r; )
      hc(t, e[n]);
    return;
  }
  if (typeof e != "object" || !("type" in e))
    throw new Error("Expected node, nodes, or string, got `" + e + "`");
  t.push(e);
}
function np(t, e, n) {
  var r, i, s;
  if (typeof n != "object" || !("length" in n))
    return Vs(t, e, n);
  for (i = n.length, r = -1, s = []; ++r < i; )
    s[r] = Vs(t, e, n[r]);
  return s;
}
function Vs(t, e, n) {
  var r = n;
  return t.number || t.positiveNumber ? !isNaN(r) && r !== "" && (r = Number(r)) : (t.boolean || t.overloadedBoolean) && typeof r == "string" && (r === "" || zs(n) === zs(e)) && (r = !0), r;
}
function rp(t) {
  var e = [], n;
  for (n in t)
    e.push([n, t[n]].join(": "));
  return e.join("; ");
}
function ip(t) {
  for (var e = t.length, n = -1, r = {}, i; ++n < e; )
    i = t[n], r[i.toLowerCase()] = i;
  return r;
}
var op = qn, sp = LT, ap = dc, fc = ap(op, "g", sp);
fc.displayName = "svg";
var lp = fc, pt = Xe, cp = Tt, up = ac, B = pt.boolean, dp = pt.overloadedBoolean, vt = pt.booleanish, re = pt.number, Ce = pt.spaceSeparated, _n = pt.commaSeparated, hp = cp({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: up,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: _n,
    acceptCharset: Ce,
    accessKey: Ce,
    action: null,
    allow: null,
    allowFullScreen: B,
    allowPaymentRequest: B,
    allowUserMedia: B,
    alt: null,
    as: null,
    async: B,
    autoCapitalize: null,
    autoComplete: Ce,
    autoFocus: B,
    autoPlay: B,
    capture: B,
    charSet: null,
    checked: B,
    cite: null,
    className: Ce,
    cols: re,
    colSpan: null,
    content: null,
    contentEditable: vt,
    controls: B,
    controlsList: Ce,
    coords: re | _n,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: B,
    defer: B,
    dir: null,
    dirName: null,
    disabled: B,
    download: dp,
    draggable: vt,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: B,
    formTarget: null,
    headers: Ce,
    height: re,
    hidden: B,
    high: re,
    href: null,
    hrefLang: null,
    htmlFor: Ce,
    httpEquiv: Ce,
    id: null,
    imageSizes: null,
    imageSrcSet: _n,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: B,
    itemId: null,
    itemProp: Ce,
    itemRef: Ce,
    itemScope: B,
    itemType: Ce,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: B,
    low: re,
    manifest: null,
    max: null,
    maxLength: re,
    media: null,
    method: null,
    min: null,
    minLength: re,
    multiple: B,
    muted: B,
    name: null,
    nonce: null,
    noModule: B,
    noValidate: B,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: B,
    optimum: re,
    pattern: null,
    ping: Ce,
    placeholder: null,
    playsInline: B,
    poster: null,
    preload: null,
    readOnly: B,
    referrerPolicy: null,
    rel: Ce,
    required: B,
    reversed: B,
    rows: re,
    rowSpan: re,
    sandbox: Ce,
    scope: null,
    scoped: B,
    seamless: B,
    selected: B,
    shape: null,
    size: re,
    sizes: null,
    slot: null,
    span: re,
    spellCheck: vt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: _n,
    start: re,
    step: null,
    style: null,
    tabIndex: re,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: B,
    useMap: null,
    value: vt,
    width: re,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Ce,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: re,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: re,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: B,
    // Lists. Use CSS to reduce space between items instead
    declare: B,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: re,
    // `<img>` and `<object>`
    leftMargin: re,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: re,
    // `<body>`
    marginWidth: re,
    // `<body>`
    noResize: B,
    // `<frame>`
    noHref: B,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: B,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: B,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: re,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: vt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: re,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: re,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: B,
    disableRemotePlayback: B,
    prefix: null,
    property: null,
    results: re,
    security: null,
    unselectable: null
  }
}), fp = Zl, mp = ic, Tp = oc, pp = lc, Ep = cc, gp = hp, tr = fp([Tp, mp, pp, Ep, gp]), Ap = tr, _p = dc, mc = _p(Ap, "div");
mc.displayName = "html";
var Cp = mc, Np = Cp, Sp = Ip;
function Ip(t) {
  for (var e = String(t), n = [], r = /\r?\n|\r/g; r.exec(e); )
    n.push(r.lastIndex);
  return n.push(e.length + 1), {
    toPoint: i,
    toPosition: i,
    toOffset: s
  };
  function i(a) {
    var c = -1;
    if (a > -1 && a < n[n.length - 1]) {
      for (; ++c < n.length; )
        if (n[c] > a)
          return {
            line: c + 1,
            column: a - (n[c - 1] || 0) + 1,
            offset: a
          };
    }
    return {};
  }
  function s(a) {
    var c = a && a.line, l = a && a.column, u;
    return !isNaN(c) && !isNaN(l) && c - 1 in n && (u = (n[c - 2] || 0) + l - 1 || 0), u > -1 && u < n[n.length - 1] ? u : -1;
  }
}
const yp = "http://www.w3.org/1999/xhtml", Op = "http://www.w3.org/1998/Math/MathML", vp = "http://www.w3.org/2000/svg", xp = "http://www.w3.org/1999/xlink", Rp = "http://www.w3.org/XML/1998/namespace", bp = "http://www.w3.org/2000/xmlns/", nr = {
  html: yp,
  mathml: Op,
  svg: vp,
  xlink: xp,
  xml: Rp,
  xmlns: bp
};
var Lp = lp, Pp = Np, Mp = Zn, Tc = tr, pc = qn, Dp = Sp, kp = nr, wp = $p, Hp = {}.hasOwnProperty, js = {
  "#document": Xs,
  "#document-fragment": Xs,
  "#text": Up,
  "#comment": Gp,
  "#documentType": Bp
};
function $p(t, e) {
  var n = e || {}, r;
  return n.messages ? (r = n, n = {}) : r = n.file, Li(t, {
    schema: n.space === "svg" ? pc : Tc,
    file: r,
    verbose: n.verbose
  });
}
function Li(t, e) {
  var n = e.schema, r = Hp.call(js, t.nodeName) ? js[t.nodeName] : Qs, i, s, a;
  return r === Qs && (e.schema = t.namespaceURI === kp.svg ? pc : Tc), t.childNodes && (i = Fp(t.childNodes, e)), s = r(t, i, e), t.sourceCodeLocation && e.file && (a = Kp(s, t.sourceCodeLocation, e), a && (e.location = !0, s.position = a)), e.schema = n, s;
}
function Fp(t, e) {
  for (var n = -1, r = []; ++n < t.length; )
    r[n] = Li(t[n], e);
  return r;
}
function Xs(t, e, n) {
  var r = {
    type: "root",
    children: e,
    data: { quirksMode: t.mode === "quirks" || t.mode === "limited-quirks" }
  }, i, s;
  return n.file && n.location && (i = String(n.file), s = Dp(i), r.position = {
    start: s.toPoint(0),
    end: s.toPoint(i.length)
  }), r;
}
function Bp(t) {
  return {
    type: "doctype",
    name: t.name || "",
    public: t.publicId || null,
    system: t.systemId || null
  };
}
function Up(t) {
  return { type: "text", value: t.value };
}
function Gp(t) {
  return { type: "comment", value: t.data };
}
function Qs(t, e, n) {
  for (var r = n.schema.space === "svg" ? Lp : Pp, i = {}, s = -1, a, c, l, u, g; ++s < t.attrs.length; )
    c = t.attrs[s], i[(c.prefix ? c.prefix + ":" : "") + c.name] = c.value;
  return a = r(t.tagName, i, e), a.tagName === "template" && "content" in t && (l = t.sourceCodeLocation, u = l && l.startTag && it(l.startTag).end, g = l && l.endTag && it(l.endTag).start, a.content = Li(t.content, n), (u || g) && n.file && (a.content.position = { start: u, end: g })), a;
}
function Kp(t, e, n) {
  var r = it(e), i, s, a;
  if (t.type === "element" && (i = t.children[t.children.length - 1], !e.endTag && i && i.position && i.position.end && (r.end = Object.assign({}, i.position.end)), n.verbose)) {
    a = {};
    for (s in e.attrs)
      a[Mp(n.schema, s).property] = it(e.attrs[s]);
    t.data = {
      position: {
        opening: it(e.startTag),
        closing: e.endTag ? it(e.endTag) : null,
        properties: a
      }
    };
  }
  return r;
}
function it(t) {
  var e = qs({
    line: t.startLine,
    column: t.startCol,
    offset: t.startOffset
  }), n = qs({
    line: t.endLine,
    column: t.endCol,
    offset: t.endOffset
  });
  return e || n ? { start: e, end: n } : null;
}
function qs(t) {
  return t.line && t.column ? t : null;
}
const zp = "classID", Yp = "datatype", Wp = "itemID", Vp = "strokeDasharray", jp = "strokeDashoffset", Xp = "strokeLinecap", Qp = "strokeLinejoin", qp = "strokeMiterlimit", Zp = "typeof", Jp = "xlinkActuate", e2 = "xlinkArcrole", t2 = "xlinkHref", n2 = "xlinkRole", r2 = "xlinkShow", i2 = "xlinkTitle", o2 = "xlinkType", s2 = "xmlnsXlink", a2 = {
  classId: zp,
  dataType: Yp,
  itemId: Wp,
  strokeDashArray: Vp,
  strokeDashOffset: jp,
  strokeLineCap: Xp,
  strokeLineJoin: Qp,
  strokeMiterLimit: qp,
  typeOf: Zp,
  xLinkActuate: Jp,
  xLinkArcRole: e2,
  xLinkHref: t2,
  xLinkRole: n2,
  xLinkShow: r2,
  xLinkTitle: i2,
  xLinkType: o2,
  xmlnsXLink: s2
};
var Zs = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, l2 = /\n/g, c2 = /^\s*/, u2 = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, d2 = /^:\s*/, h2 = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, f2 = /^[;\s]*/, m2 = /^\s+|\s+$/g, T2 = `
`, Js = "/", ea = "*", F1 = "", p2 = "comment", E2 = "declaration", g2 = function(t, e) {
  if (typeof t != "string")
    throw new TypeError("First argument must be a string");
  if (!t)
    return [];
  e = e || {};
  var n = 1, r = 1;
  function i(y) {
    var N = y.match(l2);
    N && (n += N.length);
    var v = y.lastIndexOf(T2);
    r = ~v ? y.length - v : r + y.length;
  }
  function s() {
    var y = { line: n, column: r };
    return function(N) {
      return N.position = new a(y), u(), N;
    };
  }
  function a(y) {
    this.start = y, this.end = { line: n, column: r }, this.source = e.source;
  }
  a.prototype.content = t;
  function c(y) {
    var N = new Error(
      e.source + ":" + n + ":" + r + ": " + y
    );
    if (N.reason = y, N.filename = e.source, N.line = n, N.column = r, N.source = t, !e.silent)
      throw N;
  }
  function l(y) {
    var N = y.exec(t);
    if (N) {
      var v = N[0];
      return i(v), t = t.slice(v.length), N;
    }
  }
  function u() {
    l(c2);
  }
  function g(y) {
    var N;
    for (y = y || []; N = A(); )
      N !== !1 && y.push(N);
    return y;
  }
  function A() {
    var y = s();
    if (!(Js != t.charAt(0) || ea != t.charAt(1))) {
      for (var N = 2; F1 != t.charAt(N) && (ea != t.charAt(N) || Js != t.charAt(N + 1)); )
        ++N;
      if (N += 2, F1 === t.charAt(N - 1))
        return c("End of comment missing");
      var v = t.slice(2, N - 2);
      return r += 2, i(v), t = t.slice(N), r += 2, y({
        type: p2,
        comment: v
      });
    }
  }
  function S() {
    var y = s(), N = l(u2);
    if (N) {
      if (A(), !l(d2))
        return c("property missing ':'");
      var v = l(h2), X = y({
        type: E2,
        property: ta(N[0].replace(Zs, F1)),
        value: v ? ta(v[0].replace(Zs, F1)) : F1
      });
      return l(f2), X;
    }
  }
  function C() {
    var y = [];
    g(y);
    for (var N; N = S(); )
      N !== !1 && (y.push(N), g(y));
    return y;
  }
  return u(), C();
};
function ta(t) {
  return t ? t.replace(m2, F1) : F1;
}
var A2 = g2;
function _2(t, e) {
  var n = null;
  if (!t || typeof t != "string")
    return n;
  for (var r, i = A2(t), s = typeof e == "function", a, c, l = 0, u = i.length; l < u; l++)
    r = i[l], a = r.property, c = r.value, s ? e(a, c, r) : c && (n || (n = {}), n[a] = c);
  return n;
}
var C2 = _2, N2 = tr, Ec = qn, S2 = Zn, I2 = a2, y2 = Jn, O2 = er, v2 = C2, x2 = nr, Pi = Wl, R2 = Pi("root"), zr = Pi("element"), b2 = Pi("text"), L2 = P2;
function P2(t, e, n) {
  var r = n || {}, i = D2(t), s = H2(t), a = w2(t), c;
  if (typeof t != "function")
    throw new Error("h is not a function");
  if (typeof r == "string" || typeof r == "boolean" ? (c = r, r = {}) : c = r.prefix, R2(e))
    e = e.children.length === 1 && zr(e.children[0]) ? e.children[0] : {
      type: "element",
      tagName: "div",
      properties: {},
      children: e.children
    };
  else if (!zr(e))
    throw new Error(
      "Expected root or element, not `" + (e && e.type || e) + "`"
    );
  return gc(t, e, {
    schema: r.space === "svg" ? Ec : N2,
    prefix: c ?? (i || s || a ? "h-" : null),
    key: 0,
    react: i,
    vue: s,
    vdom: a,
    hyperscript: k2(t)
  });
}
function gc(t, e, n) {
  var r = n.schema, i = r, s = e.tagName, a = {}, c = [], l = -1, u, g;
  r.space === "html" && s.toLowerCase() === "svg" && (i = Ec, n.schema = i);
  for (u in e.properties)
    M2(a, u, e.properties[u], n, s);
  if (n.vdom && (i.space === "html" ? s = s.toUpperCase() : a.namespace = x2[i.space]), n.prefix && (n.key++, a.key = n.prefix + n.key), e.children)
    for (; ++l < e.children.length; )
      g = e.children[l], zr(g) ? c.push(gc(t, g, n)) : b2(g) && c.push(g.value);
  return n.schema = r, c.length ? t.call(e, s, a, c) : t.call(e, s, a);
}
function M2(t, e, n, r, i) {
  var s = S2(r.schema, e), a;
  n == null || n !== n || n === !1 && (r.vue || r.vdom || r.hyperscript) || !n && s.boolean && (r.vue || r.vdom || r.hyperscript) || (n && typeof n == "object" && "length" in n && (n = (s.commaSeparated ? O2 : y2).stringify(n)), s.boolean && r.hyperscript && (n = ""), s.property === "style" && typeof n == "string" && (r.react || r.vue || r.vdom) && (n = $2(n, i)), r.vue ? s.property !== "style" && (a = "attrs") : s.mustUseProperty || (r.vdom ? s.property !== "style" && (a = "attributes") : r.hyperscript && (a = "attrs")), a ? (t[a] || (t[a] = {}), t[a][s.attribute] = n) : s.space && r.react ? t[I2[s.property] || s.property] = n : t[s.attribute] = n);
}
function D2(t) {
  var e = t && t("div");
  return !!(e && ("_owner" in e || "_store" in e) && e.key == null);
}
function k2(t) {
  return !!(t && t.context && t.cleanup);
}
function w2(t) {
  return t && t("div").type === "VirtualNode";
}
function H2(t) {
  var e = t && t("div");
  return !!(e && e.context && e.context._isVue);
}
function $2(t, e) {
  var n = {};
  try {
    v2(t, r);
  } catch (i) {
    throw i.message = e + "[style]" + i.message.slice(9), i;
  }
  return n;
  function r(i, s) {
    i.slice(0, 4) === "-ms-" && (i = "ms-" + i.slice(4)), n[i.replace(/-([a-z])/g, F2)] = s;
  }
}
function F2(t, e) {
  return e.toUpperCase();
}
var Ac = U2, B2 = Function.prototype, na = {}.hasOwnProperty;
function U2(t, e) {
  var n = e || {};
  function r(i) {
    var s = r.invalid, a = r.handlers;
    return i && na.call(i, t) && (s = na.call(a, i[t]) ? a[i[t]] : r.unknown), (s || B2).apply(this, arguments);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
var G2 = yi, K2 = tr, _c = qn, z2 = Zn, Y2 = L2, Cc = nr, W2 = Ac, V2 = X2, j2 = ["svg", "html"], V1 = W2("type");
V1.handlers.root = Q2;
V1.handlers.element = tE;
V1.handlers.text = J2;
V1.handlers.comment = eE;
V1.handlers.doctype = Z2;
function X2(t, e) {
  return V1(t, e === "svg" ? _c : K2);
}
function Q2(t, e) {
  var n = t.data || {}, r = n.quirksMode ? "quirks" : "no-quirks";
  return Et(t, { nodeName: "#document", mode: r }, e);
}
function q2(t, e) {
  return Et(t, { nodeName: "#document-fragment" }, e);
}
function Z2(t, e) {
  return Et(
    t,
    {
      nodeName: "#documentType",
      name: t.name,
      publicId: t.public || "",
      systemId: t.system || ""
    },
    e
  );
}
function J2(t, e) {
  return Et(t, { nodeName: "#text", value: t.value }, e);
}
function eE(t, e) {
  return Et(t, { nodeName: "#comment", data: t.value }, e);
}
function tE(t, e) {
  var n = e.space, r = G2(t, { children: [] });
  return Y2(i, r, { space: n });
  function i(s, a) {
    var c = [], l, u, g, A, S, C;
    for (A in a)
      S = z2(e, A), u = a[A], !(u === !1 || S.boolean && !u) && (g = { name: A, value: u === !0 ? "" : String(u) }, S.space && j2.indexOf(S.space) === -1 && (C = A.indexOf(":"), C === -1 ? g.prefix = "" : (g.name = A.slice(C + 1), g.prefix = A.slice(0, C)), g.namespace = Cc[S.space]), c.push(g));
    return l = Et(t, { nodeName: s, tagName: s, attrs: c }, e), s === "template" && (l.content = q2(r.content, e)), l;
  }
}
function Et(t, e, n) {
  var r = n, i = t.position, s = t.children, a = [], c = s ? s.length : 0, l = -1, u;
  for (t.type === "element" && (r.space === "html" && t.tagName === "svg" && (r = _c), e.namespaceURI = Cc[r.space]); ++l < c; )
    u = V1(s[l], r), u.parentNode = e, a[l] = u;
  return (t.type === "element" || t.type === "root") && (e.childNodes = a), i && i.start && i.end && (e.sourceCodeLocation = {
    startLine: i.start.line,
    startCol: i.start.column,
    startOffset: i.start.offset,
    endLine: i.end.line,
    endCol: i.end.column,
    endOffset: i.end.offset
  }), e;
}
const nE = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
];
var rE = lm, Yr = F8, iE = Q8, oE = wp, Nc = V2, sE = nE, Lr = nr, aE = Ac, Sc = yi, lE = Ic, cE = "IN_TEMPLATE_MODE", uE = "DATA_STATE", dE = "CHARACTER_TOKEN", hE = "START_TAG_TOKEN", fE = "END_TAG_TOKEN", mE = "COMMENT_TOKEN", TE = "DOCTYPE_TOKEN", pE = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function Ic(t, e, n) {
  var r = new rE(pE), i = aE("type", {
    handlers: {
      root: v,
      element: X,
      text: Z,
      comment: $,
      doctype: ae,
      raw: te
    },
    unknown: _E
  }), s, a, c, l, u, g, A;
  if (e && !("contents" in e) && (n = e, e = void 0), n && n.passThrough)
    for (A = -1; ++A < n.passThrough.length; )
      i.handlers[n.passThrough[A]] = Se;
  if (g = oE(CE(t) ? y() : C(), e), s && iE(g, "comment", S), t.type !== "root" && g.children.length === 1)
    return g.children[0];
  return g;
  function S(F, J, he) {
    if (F.value.stitch)
      return he.children[J] = F.value.stitch, J;
  }
  function C() {
    var F = {
      nodeName: "template",
      tagName: "template",
      attrs: [],
      namespaceURI: Lr.html,
      childNodes: []
    }, J = {
      nodeName: "documentmock",
      tagName: "documentmock",
      attrs: [],
      namespaceURI: Lr.html,
      childNodes: []
    }, he = { nodeName: "#document-fragment", childNodes: [] };
    return r._bootstrap(J, F), r._pushTmplInsertionMode(cE), r._initTokenizerForFragmentParsing(), r._insertFakeRootElement(), r._resetInsertionMode(), r._findFormInFragmentContext(), a = r.tokenizer, c = a.preprocessor, u = a.__mixins[0], l = u.posTracker, i(t), r._adoptNodes(J.childNodes[0], he), he;
  }
  function y() {
    var F = r.treeAdapter.createDocument();
    return r._bootstrap(F, null), a = r.tokenizer, c = a.preprocessor, u = a.__mixins[0], l = u.posTracker, i(t), F;
  }
  function N(F) {
    var J = -1;
    if (F)
      for (; ++J < F.length; )
        i(F[J]);
  }
  function v(F) {
    N(F.children);
  }
  function X(F) {
    Ae(), r._processToken(EE(F), Lr.html), N(F.children), sE.indexOf(F.tagName) < 0 && (Ae(), r._processToken(AE(F)));
  }
  function Z(F) {
    Ae(), r._processToken({
      type: dE,
      chars: F.value,
      location: ot(F)
    });
  }
  function ae(F) {
    var J = Nc(F);
    Ae(), r._processToken({
      type: TE,
      name: J.name,
      forceQuirks: !1,
      publicId: J.publicId,
      systemId: J.systemId,
      location: ot(F)
    });
  }
  function $(F) {
    Ae(), r._processToken({
      type: mE,
      data: F.value,
      location: ot(F)
    });
  }
  function te(F) {
    var J = Yr.start(F), he = J.line || 1, p1 = J.column || 1, Re = J.offset || 0, ee;
    c.html = null, c.pos = -1, c.lastGapPos = -1, c.lastCharPos = -1, c.gapStack = [], c.skipNextNewLine = !1, c.lastChunkWritten = !1, c.endOfChunkHit = !1, l.isEol = !1, l.lineStartPos = -p1 + 1, l.droppedBufferSize = Re, l.offset = 0, l.col = 1, l.line = he, u.currentAttrLocation = null, u.ctLoc = ot(F), a.write(F.value), r._runParsingLoop(null), ee = a.currentCharacterToken, ee && (ee.location.endLine = l.line, ee.location.endCol = l.col + 1, ee.location.endOffset = l.offset + 1, r._processToken(ee));
  }
  function Se(F) {
    var J = Object.assign({}, F);
    s = !0, F.children && (J.children = Ic(
      { type: "root", children: F.children },
      e,
      n
    ).children), $({ value: { stitch: J } });
  }
  function Ae() {
    a.tokenQueue = [], a.state = uE, a.returnState = "", a.charRefCode = -1, a.tempBuff = [], a.lastStartTagName = "", a.consumedAfterSnapshot = -1, a.active = !1, a.currentCharacterToken = null, a.currentToken = null, a.currentAttr = null;
  }
}
function EE(t) {
  var e = ot(t);
  return e.startTag = Sc(e), {
    type: hE,
    tagName: t.tagName,
    selfClosing: !1,
    attrs: gE(t),
    location: e
  };
}
function gE(t) {
  return Nc({
    tagName: t.tagName,
    type: "element",
    properties: t.properties
  }).attrs;
}
function AE(t) {
  var e = ot(t);
  return e.endTag = Sc(e), {
    type: fE,
    tagName: t.tagName,
    attrs: [],
    location: e
  };
}
function _E(t) {
  throw new Error("Cannot compile `" + t.type + "` node");
}
function CE(t) {
  var e = t.type === "root" ? t.children[0] : t;
  return e && (e.type === "doctype" || e.tagName === "html");
}
function ot(t) {
  var e = Yr.start(t), n = Yr.end(t);
  return {
    startLine: e.line,
    startCol: e.column,
    startOffset: e.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
var NE = lE, SE = IE;
function IE(t) {
  return e;
  function e(n, r) {
    return NE(n, r, t);
  }
}
const yE = /* @__PURE__ */ rl(SE), OE = m.div`
  ${({ width: t }) => t ? `max-width: ${t};` : ""}
  line-height: 20px;
`, vE = new n9(), t3 = ({ children: t, skipHtml: e, width: n }) => {
  const r = e ? t : vE.convertToHtml(t);
  return /* @__PURE__ */ h(OE, { width: n, children: /* @__PURE__ */ h(
    Ea,
    {
      skipHtml: e,
      rehypePlugins: [yE],
      components: {
        img: ({ ...s }) => /* @__PURE__ */ h("img", { style: { width: "100%", borderRadius: j }, ...s }),
        // eslint-disable-next-line id-length
        a: ({ ...s }) => {
          const a = s.href;
          return a != null && a.startsWith("/") ? /* @__PURE__ */ h(ha, { to: a, children: s.children }) : /* @__PURE__ */ h("a", { ...s, target: "_blank", rel: "noopener noreferrer" });
        }
      },
      children: r
    }
  ) });
}, n3 = ({ children: t }) => /* @__PURE__ */ h(Ea, { disallowedElements: ["paragraph"], unwrapDisallowed: !0, children: t }), xE = m.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${Ia};
  z-index: 100;
  @media (orientation: portrait) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
`, RE = m.div`
  margin-left: auto;
  margin-right: auto;
  min-height: 150px;
  background-color: ${d.backgroundPrimary};
  padding: 24px;
  border-radius: 8px;

  margin-top: 20vh;
  width: 415px;
  @media (orientation: portrait) {
    margin-top: 0;
    width: 100vw;
    border-radius: 0;
  }

  @media only screen and (max-width: ${$n.sm}) {
    padding: 24px 16px;
  }
`, bE = m.p`
  font-size: 21px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 16px;
  color: ${d.contentPrimary};
`, LE = m.p`
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  margin-bottom: 24px;
  color: ${d.contentSecondary};
`, PE = m.div`
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: ${$n.sm}) {
    justify-content: flex-start;
  }
`, ME = m.div`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap-reverse;

  @media only screen and (max-width: ${$n.sm}) {
    flex-direction: column-reverse;
  }
`, DE = m(Bn)`
  margin-left: 8px;

  @media only screen and (max-width: ${$n.sm}) {
    margin-left: 0;
    margin-top: 8px;
  }
`, r3 = ({ buttons: t, title: e, message: n }) => /* @__PURE__ */ h(xE, { children: /* @__PURE__ */ O(RE, { children: [
  /* @__PURE__ */ h(bE, { children: e }),
  /* @__PURE__ */ h(LE, { children: n }),
  /* @__PURE__ */ h(PE, { children: /* @__PURE__ */ h(ME, { children: (() => t.map((i, s) => {
    const a = s === 0;
    return /* @__PURE__ */ h(DE, { onClick: i.onPress, buttonTheme: a ? ja : ze, children: i.text }, s);
  }))() }) })
] }) }), yc = (t) => t === "xl" ? "1275px" : t === "large" ? "1180px" : t === "medium" ? "720px" : "520px", kE = m(Vr)`
  background-color: ${d.backgroundSecondary};
  ${({ width: t }) => `width: ${t};`};
  margin: 0px 24px;
  border-radius: 10px;
  &:focus {
    outline: none;
  }
`, Mi = m(c9)`
  background: ${Ia};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  justify-content: center;
  align-items: start;
  overflow-y: auto;
  z-index: ${({ zIndexOverride: t }) => t ?? R9};
  padding-top: 30px;
  padding-bottom: 30px;
`, wE = m(D9)`
  display: flex;
  flex-direction: row;
  font-size: 15px;
  font-weight: 400;
  border-bottom: 1px solid ${d.borderPrimary};
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  background-color: ${d.backgroundPrimary};
  position: relative;
`, HE = m(u9)`
  margin: 0;
  flex: 1;
  color: ${d.contentPrimary};
  font-size: 22px;
  padding-top: 26px;
  padding-bottom: 28px;
  padding-left: 20px;
  padding-right: 20px;
`, $E = m(d9)`
  display: flex;
  padding: 20px;
  flex: 0;
  align-items: center;
  cursor: pointer;
  color: ${d.interactivePrimary};
  background-color: ${d.backgroundPrimary};
  border: none;
  border-radius: 10px;
  // to over-write radix outline
  &:focus {
    outline: none;
  }
  ${jt}
  &:focus-visible {
    outline-offset: -5px;
  }
`, FE = m.div`
  margin-left: 5px;
  font-size: 15px;
  line-height: 15px;
`, BE = m.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`, UE = m(BE)`
  position: relative;
  flex-wrap: wrap;
  margin: -18px 0px -18px 0px;
  padding: 0px 16px 0px 16px;
  display: flex;
  gap: 8px;
  z-index: 1052;
`, i3 = m.div`
  color: ${d.contentPrimary};
  font-size: 15px;
  background-color: ${d.backgroundSecondary};
`, o3 = m.div`
  border-top: 1px solid ${d.borderPrimary};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: ${d.backgroundPrimary};
  display: flex;
`, s3 = ({
  isOpen: t,
  toggle: e,
  title: n,
  actions: r,
  children: i,
  size: s = "default",
  zIndexOverride: a
}) => /* @__PURE__ */ h(jr, { open: t, children: /* @__PURE__ */ h(ga, { children: /* @__PURE__ */ h(Mi, { zIndexOverride: a, children: /* @__PURE__ */ O(
  kE,
  {
    onEscapeKeyDown: e,
    onPointerDownOutside: (c) => {
      const l = c.currentTarget;
      c.detail.originalEvent.offsetX <= l.clientWidth && e();
    },
    "aria-describedby": void 0,
    width: yc(s),
    children: [
      /* @__PURE__ */ O(wE, { children: [
        /* @__PURE__ */ h(HE, { children: n }),
        /* @__PURE__ */ O($E, { onClick: e, children: [
          /* @__PURE__ */ h(ge, { icon: "times" }),
          /* @__PURE__ */ h(FE, { children: H.modal.close() })
        ] })
      ] }),
      r && /* @__PURE__ */ h(UE, { children: r }),
      i
    ]
  }
) }) }) }), GE = m(Vr)`
  background-color: ${d.backgroundPrimary};
  ${({ width: t }) => `width: ${t};`};
  margin: 0px 24px;
  border-radius: 10px;
  &:focus {
    outline: none;
  }
`, KE = m(Aa)`
  padding: 24px 16px;
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: ${d.contentPrimary};
  line-height: 28px;
`, zE = m.p`
  font-size: 15px;
  font-weight: 400;
  color: ${d.contentPrimary};
  line-height: 20px;
  padding: 0 16px;
  margin-bottom: 24px;
`, YE = m.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
  padding: 16px;
  border-top: 1px solid ${d.borderPrimary};
`, ra = H.modal, a3 = ({
  isOpen: t,
  toggle: e,
  title: n,
  description: r,
  size: i = "default",
  onConfirm: s,
  confirmButtonText: a = ra.confirm(),
  cancelButtonText: c = ra.cancel()
}) => /* @__PURE__ */ h(jr, { open: t, children: /* @__PURE__ */ h(ga, { children: /* @__PURE__ */ h(Mi, { children: /* @__PURE__ */ O(
  GE,
  {
    onEscapeKeyDown: e,
    onPointerDownOutside: (l) => {
      const u = l.currentTarget;
      l.detail.originalEvent.offsetX <= u.clientWidth && e();
    },
    "aria-describedby": void 0,
    width: yc(i),
    children: [
      /* @__PURE__ */ h(KE, { children: n }),
      /* @__PURE__ */ h(zE, { children: r }),
      /* @__PURE__ */ O(YE, { children: [
        /* @__PURE__ */ h(Rn, { onClick: e, children: c }),
        /* @__PURE__ */ h(Rn, { onClick: s, buttonTheme: ja, children: a })
      ] })
    ]
  }
) }) }) }), Di = pe`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
  font-size: 15px;
  line-height: 20px;
  margin-top: 12px;
  transition: all 0.3s ease;
  &:hover {
    text-decoration: none;
  }
  &.selected {
    text-decoration: none;
  }
  width: fit-content;
  max-width: 100%;
  &:focus {
    text-decoration: none;
  }
`, l3 = m(fa)`
  ${Di}
  color: ${d.contentPrimary} !important;
  cursor: 'pointer';
  &:hover {
    color: ${d.interactivePrimary} !important;
  }
  &.selected {
    color: ${d.interactivePrimary} !important;
  }
`, c3 = m.a`
  ${Di}
  color: ${d.contentTertiary} !important;
  cursor: 'auto';
  pointer-events: 'none';
  &:hover {
    color: ${d.contentTertiary} !important;
  }
  &.selected {
    color: ${d.contentTertiary} !important;
  }
`, WE = m.nav`
  display: flex;
  gap: 8px;
  align-items: center;
`, VE = m(fa)`
  ${Di}
  margin-top: 0;
  color: ${d.contentSecondary} !important;
  cursor: 'pointer';
  &:hover {
    color: ${d.interactivePrimary} !important;
  }
  &.selected {
    color: ${d.interactivePrimary} !important;
  }
`, jE = m.div`
  height: 20px;
  width: 20px;
`, XE = () => /* @__PURE__ */ h(ge, { color: d.borderSecondary, icon: "chevron-right", size: "sm" }), u3 = ({ items: t, containerStyles: e, onBreadcrumbClick: n }) => /* @__PURE__ */ h(WE, { "aria-label": "Breadcrumb", style: e, children: t.length === 0 ? /* @__PURE__ */ h(jE, {}) : t.map((r, i) => /* @__PURE__ */ O(Yt.Fragment, { children: [
  /* @__PURE__ */ h(VE, { to: r.to, onClick: () => n && n(r), children: r.label || "..." }),
  /* @__PURE__ */ h(XE, {})
] }, `${i}-${r.label}`)) }), QE = m(h9)`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  box-shadow: ${We};
  border-radius: ${j};
  background-color: ${d.backgroundSecondary};

  button {
    cursor: pointer;
  }
`, d3 = ({ children: t, value: e, onChange: n }) => /* @__PURE__ */ h(
  QE,
  {
    type: "single",
    value: e,
    onValueChange: (r) => n && n(r),
    rovingFocus: !1,
    children: t
  }
), qE = m.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  height: 100%;
`, ZE = m.div`
  color: ${d.contentPrimary};
  font-size: 15px;
  line-height: 20px;
  text-align: left;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  flex: 1;
  span {
    margin-left: 6px;
    display: inline-flex;
    align-items: center;
  }
`, JE = m.div`
  color: ${(t) => t.color};
  font-size: 24px;
  line-height: 28px;
  height: 28px;
`, e6 = m.span`
  color: ${d.contentPrimary};
  font-size: 15px;
`, t6 = (t) => {
  const e = t.color ?? d.interactivePrimary, n = t.figure === void 0 ? "-" : t.figure, r = t.unit && n1(t.figure) ? t.unit : null;
  return /* @__PURE__ */ O(qE, { children: [
    /* @__PURE__ */ O(ZE, { children: [
      t.title,
      t.description && /* @__PURE__ */ h(ft, { content: t.description })
    ] }),
    /* @__PURE__ */ O(JE, { color: e, children: [
      n,
      /* @__PURE__ */ h(e6, { children: r })
    ] })
  ] });
}, n6 = m(f9)`
  padding: 8px 16px;
  border: none;
  border-right: 1px solid ${d.borderPrimary};
  background-color: ${d.backgroundPrimary};
  flex: 1;
  &:first-child {
    border-top-left-radius: ${j};
    border-bottom-left-radius: ${j};
  }
  &:last-child {
    border-top-right-radius: ${j};
    border-bottom-right-radius: ${j};
    border-right: none;
  }
  &:hover {
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }
  &[data-state='on'] {
    outline: none;
    box-shadow: inset 0px -4px 0px ${d.interactivePrimary};
  }
`, h3 = (t) => /* @__PURE__ */ h(n6, { value: t.value, "aria-label": t.title, children: /* @__PURE__ */ h(t6, { ...t }) }), Oc = m.button`
  all: initial;
  font: inherit;
  background-color: ${d.backgroundPrimary};
  display: inline-block;
  padding: 16px 16px 12px 16px;
  font-size: 15px;
  flex: 1;
  text-align: left;
  box-sizing: border-box;
  color: ${(t) => t.$isDisabled ? d.contentTertiary : t.$isActive ? d.interactivePrimary : d.contentPrimary};
  border-bottom: 4px solid ${(t) => t.$isActive ? d.interactivePrimary : "transparent"};
  opacity: ${(t) => t.$isDisabled ? 0.6 : 1};

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:not(:last-of-type) {
    border-right: 1px solid ${d.borderPrimary};
  }

  // Round corners of the first and last tab
  &:first-of-type {
    border-top-left-radius: ${j};
    border-bottom-left-radius: ${j};
  }
  &:last-of-type {
    border-top-right-radius: ${j};
    border-bottom-right-radius: ${j};
  }

  // Don't show outline on mouse click
  &:focus:not(:focus-visible) {
    outline: none;
  }

  // Do show outline on keyboard navigation
  &:focus-visible {
    position: relative;
    z-index: 1;
    outline: 2px solid ${d.interactivePrimary};
    outline-offset: -2px;
  }
`;
Oc.displayName = "TabBarItem";
const vc = m.span`
  min-width: 15px;
  height: 20px;
  background: ${d.backgroundPrimary};
  border: 1px solid ${d.interactivePrimary};
  box-sizing: border-box;
  border-radius: 4px;
  margin: 0 0 0 8px;
  padding: 0 4px;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  color: ${d.contentPrimary};
`;
vc.displayName = "NumberPill";
const xc = Wt(
  ({ StyledTabItem: t = Oc, children: e, $isActive: n, $isDisabled: r, $count: i, ...s }, a) => /* @__PURE__ */ O(t, { ref: a, $isActive: n, $isDisabled: r, ...s, children: [
    e,
    i !== void 0 && /* @__PURE__ */ h(vc, { children: i })
  ] })
);
xc.displayName = "TabBarItem";
const r6 = m.div`
  box-shadow: ${We};
  border-radius: ${j};
  background-color: ${(t) => t.backgroundColor || "white"};
  display: flex;
  flex-direction: row;
`;
function Rc({
  tabs: t,
  activeTab: e,
  focusedTabIndex: n,
  onClick: r,
  onKeyboardNavigation: i,
  tabIndex: s,
  backgroundColor: a,
  refs: c,
  StyledTabItem: l,
  StyledContainer: u = r6
}) {
  const g = (A) => {
    var S, C, y, N;
    switch (A.key) {
      case "ArrowLeft": {
        A.persist();
        let v = Math.max(n - 1, 0);
        for (; v >= 0 && ((S = t[v]) != null && S.disabled); )
          v--;
        v >= 0 && i(A, v);
        break;
      }
      case "ArrowRight": {
        A.persist();
        let v = Math.min(n + 1, t.length - 1);
        for (; v < t.length && ((C = t[v]) != null && C.disabled); )
          v++;
        v < t.length && i(A, v);
        break;
      }
      case "Home": {
        A.persist();
        let v = 0;
        for (; v < t.length && ((y = t[v]) != null && y.disabled); )
          v++;
        v < t.length && i(A, v);
        break;
      }
      case "End": {
        A.persist();
        let v = t.length - 1;
        for (; v >= 0 && ((N = t[v]) != null && N.disabled); )
          v--;
        v >= 0 && i(A, v);
        break;
      }
    }
  };
  return (
    // TODO: the role='tablist' should also be accompanied by an aria-label or aria-labelledby
    // https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
    /* @__PURE__ */ h(u, { backgroundColor: a, role: "tablist", children: t.map((A, S) => /* @__PURE__ */ h(
      xc,
      {
        id: A.key,
        ref: (C) => {
          C && (c.current[S] = C);
        },
        $isActive: A.key === e,
        $isDisabled: A.disabled,
        onClick: (C) => r(C, A),
        onKeyDown: g,
        tabIndex: s(A.key),
        role: "tab",
        "aria-selected": A.key === e,
        "aria-disabled": A.disabled,
        disabled: A.disabled,
        StyledTabItem: l,
        $count: A.count,
        children: A.label
      },
      A.key
    )) })
  );
}
function i6({
  tabs: t,
  activeTab: e,
  onTabChange: n,
  backgroundColor: r,
  StyledTabItem: i,
  StyledContainer: s
}) {
  const [a, c] = Yt.useState(0), l = at([]), u = y1(() => t.map((A) => A.key), [t]);
  return /* @__PURE__ */ h(
    Rc,
    {
      tabs: t,
      activeTab: e,
      onClick: (A, S) => {
        S.disabled || (A.preventDefault(), c(u.indexOf(S.key)), n(S.key));
      },
      tabIndex: (A) => u.indexOf(A) === a ? 0 : -1,
      focusedTabIndex: a,
      onKeyboardNavigation: (A, S) => {
        S !== a && (A.preventDefault(), l.current[S].focus(), c(S));
      },
      backgroundColor: r,
      refs: l,
      StyledTabItem: i,
      StyledContainer: s
    }
  );
}
function f3({
  tabs: t,
  activeTab: e,
  onTabChange: n,
  backgroundColor: r,
  StyledTabItem: i,
  StyledContainer: s
}) {
  const [a, c] = Yt.useState(0), l = at([]), u = y1(() => t.map((A) => A.key), [t]);
  return /* @__PURE__ */ h(
    Rc,
    {
      tabs: t,
      activeTab: e,
      onClick: (A, S) => {
        S.disabled || (A.preventDefault(), c(u.indexOf(S.key)), n(S.key));
      },
      tabIndex: (A) => A === e ? 0 : -1,
      focusedTabIndex: a,
      onKeyboardNavigation: (A, S) => {
        const C = t[S];
        C && !C.disabled && (A.preventDefault(), l.current[S].focus(), c(S), n(C.key));
      },
      backgroundColor: r,
      refs: l,
      StyledTabItem: i,
      StyledContainer: s
    }
  );
}
const m3 = i6, Cn = (t, e) => t.map((n) => `--${n}: ${e[n]};`).join(`
`), T3 = p0`
  &:root {
    ${Cn(Vi, h0)}
    ${Cn(ji, f0)}
  }

  html[data-theme='dark'] {
    ${Cn(Vi, m0)}
    ${Cn(ji, T0)}

    // we only want to change the scrollbar color in dark mode, keep the light mode scrollbar default
    *::-webkit-scrollbar {
      background-color: ${d.backgroundTertiary};
    }

    *::-webkit-scrollbar-track {
      background-color: ${d.backgroundTertiary};
    }

    *::-webkit-scrollbar-thumb {
      background-color: ${d.accentGrayPrimary};
      border-radius: 10px;
      border: 4px solid ${d.backgroundTertiary};
      
      :hover {
        background-color: ${d.accentGrayPrimaryHover};
      }
    }
  }

  body {
    margin: 0;
    padding: 0;
    color: ${d.contentPrimary};
    background-color: ${d.backgroundSecondary};
    // We intentionally do NOT put font-feature-settings here in case Inter fails to load
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  }

  html.font-loaded body,
  html.font-loaded button,
  html.font-loaded input,
  html.font-loaded optgroup,
  html.font-loaded select,
  html.font-loaded textarea,
  html.font-loaded .form-control { 
    // Now we apply the full OpenType feature set, because we know "Inter" is loaded and ready
    // ss01/ss02 (font-specific stylistic sets) and standard typographic features (ligatures, contextual alternates)
    font-feature-settings: 'ss01' on, 'ss02' on, 'liga' 1, 'calt' 1;
  }

  // Bootstrap overrides
  button, 
  input, 
  optgroup, 
  select, 
  textarea, 
  .form-control {
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
    font-feature-settings: "ss01" on, "ss02" on, "liga" 1, "calt" 1;
  }

  .form-control {
    border-color: ${d.borderPrimary};
    background-color: ${d.backgroundPrimary};
    color: ${d.contentPrimary};

    &:focus {
      background-color: ${d.backgroundPrimary};
      color: ${d.contentPrimary};
    }
    
    &:disabled, 
    &[readonly] {
      background-color: ${d.backgroundTertiary};
      color: ${d.contentTertiary};
    }
  }
`, $t = 300, o6 = 500, bc = 76, st = 68, s6 = m(Mi)`
  inset: 0;
  transition: opacity ${$t}ms;
  opacity: 0;
  &[data-state='open'] {
    opacity: 1;
  }
`, a6 = zt`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0%);
  }
`, l6 = zt`
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(100%);
  }
`, c6 = m(Vr)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: ${(t) => t.$customWidth ? t.$customWidth : `${o6}px`};
  background-color: ${d.backgroundSecondary};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition:
    transform ${$t}ms,
    box-shadow ${$t}ms;
  transform: translateX(${(t) => t.$active ? "0%" : "100%"});
  box-shadow: ${(t) => t.$active ? y9 : "none"};
  z-index: ${L9};
  animation: ${(t) => t.$active ? a6 : l6} ${$t}ms
    forwards;
`, u6 = m.div`
  flex: 1;
  width: 100%;
  height: calc(100% - ${bc}px);
  position: relative;
  transition: padding ${$t * 2}ms;

  /* Hide breadcrumbs */
  & > div > * > nav,
  & > div > nav {
    display: none;
    opacity: 0;
  }
`, d6 = m.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 24px 16px;
  background-color: ${d.backgroundPrimary};
  border-bottom: 1px solid ${d.borderPrimary};
  box-shadow: ${We};
  align-items: center;
  z-index: 1;
  height: 76px;
`, h6 = m.div`
  color: ${d.contentPrimary};
  font-size: 22px;
  font-weight: 600;
`, p3 = m(G0)`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  overflow-y: auto;
  height: calc(100% - ${st}px);
  padding-bottom: ${st}px;
`, E3 = m(K0)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: ${st}px;
  padding: 16px;
  justify-content: flex-end;
  gap: 8px;
`, g3 = {
  formStyle: {
    boxShadow: "none",
    height: "100%"
  },
  contentStyle: {
    height: `calc(100vh - ${bc}px - ${st}px)`,
    overflowY: "auto",
    paddingBottom: `${st}px`
  },
  footerStyle: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: `${st}px`
  }
}, f6 = ({
  drawerActive: t,
  setDrawerActive: e,
  isDataChanged: n,
  setIsDataChanged: r,
  refreshIndex: i,
  setRefreshIndex: s,
  title: a,
  validationMessage: c,
  children: l,
  customWidth: u
}) => {
  const g = at(null), A = () => {
    (n && confirm(c) || !n) && (e(!1), r(!1), n1(i) && s && n && s(i + 1));
  }, S = (C) => {
    C ? e(!0) : A();
  };
  return Ne(() => {
    var N;
    if (!t)
      return;
    const C = (N = document.getElementById("main-content")) == null ? void 0 : N.parentElement;
    if (!C)
      return;
    const y = (v) => {
      const X = v.target, Z = g.current;
      !X || !Z || Z.getAttribute("data-active") !== "true" || document.contains(X) && A();
    };
    return C.addEventListener("click", y), () => C.removeEventListener("click", y);
  }, [n, t]), m9(
    /* @__PURE__ */ O(jr, { open: t, onOpenChange: S, children: [
      /* @__PURE__ */ h(s6, {}),
      /* @__PURE__ */ O(
        c6,
        {
          ref: g,
          $active: t,
          "data-maximized": !1,
          "data-drawer": !0,
          $customWidth: u,
          children: [
            /* @__PURE__ */ h(P0.Root, { children: /* @__PURE__ */ h(Aa, { children: a }) }),
            /* @__PURE__ */ O(d6, { children: [
              /* @__PURE__ */ h(
                Rn,
                {
                  onClick: A,
                  buttonTheme: ze,
                  style: { width: "36px", height: "36px" },
                  children: /* @__PURE__ */ h(U1, { icon: "times" })
                }
              ),
              /* @__PURE__ */ h(h6, { children: a })
            ] }),
            /* @__PURE__ */ h(u6, { children: l })
          ]
        }
      )
    ] }),
    document.body
  );
};
f6.displayName = "DrawerView";
const m6 = m(_a.Root)`
  background-color: ${({ loading: t }) => t ? d.backgroundTertiary : d.interactivePrimaryDisabled};

  width: 30px;
  height: 20px;
  padding: 0;
  border-radius: 999px;

  box-shadow: none;
  border: none;

  transition: background-color 300ms;

  &[data-state='checked'] {
    background-color: ${({ loading: t }) => t ? d.backgroundTertiary : d.interactivePrimary};
  }
`, T6 = m(_a.Thumb)`
  display: ${({ loading: t }) => t ? "none" : "block"};
  background-color: ${d.backgroundPrimary};

  width: 14px;
  height: 14px;
  border-radius: 999px;
  transition: transform 100ms;
  transform: translateX(3px);
  will-change: transform;

  box-shadow: none;

  &[data-state='checked'] {
    transform: translateX(13px);
  }
`, p6 = m.div`
  position: relative;
  line-height: 0;
`, E6 = m(K1)`
  position: absolute;
  height: 14px;
  width: 14px;

  margin-left: 8px;
  margin-top: 3px;

  z-index: 7;
`, A3 = ({ id: t, checked: e, onChange: n, className: r, loading: i }) => /* @__PURE__ */ O(p6, { id: t, children: [
  i && /* @__PURE__ */ h(E6, {}),
  /* @__PURE__ */ h(m6, { className: r, checked: e, onCheckedChange: n, loading: i ?? !1, children: /* @__PURE__ */ h(T6, { loading: i ?? !1 }) })
] }), g6 = m(T9)`
  background-color: ${({ color: t }) => t};

  &[data-orientation='horizontal'] {
    width: 100%;
    height: ${({ size: t }) => t}px;
  }

  &[data-orientation='vertical'] {
    height: 100%;
    width: ${({ size: t }) => t}px;
  }
`, _3 = ({ size: t = 1, color: e = d.borderPrimary, ...n }) => /* @__PURE__ */ h(g6, { size: t, color: e, ...n });
export {
  $t as ANIMATION_DURATION,
  Tl as AUTOSAVE_DEFAULT_EXPIRY,
  pl as AUTOSAVE_KEY_PREFIX,
  Xt as AbstractButton,
  m7 as AccordionContent,
  g9 as AccordionHeader,
  p7 as AccordionHeaderWithTitleAndIcon,
  C9 as AccordionIcon,
  T7 as AccordionItem,
  f7 as AccordionRoot,
  Ca as AccordionTitle,
  E7 as AccordionTitleWithButtons,
  A9 as AccordionTrigger,
  Nu as AddressInput,
  $7 as AddressV2Input,
  r3 as AlertDialog,
  ei as AsyncAbstractButton,
  b7 as AsyncFlatButton,
  W7 as AsyncPopoverItem,
  Rn as AsyncRoundedButton,
  Gf as AutoSaveManager,
  f3 as AutomaticTabBar,
  Ah as Badge,
  Ch as Banner,
  y7 as BrandButtonTheme,
  u3 as Breadcrumb,
  jt as ButtonFocusTheme,
  U1 as ButtonIcon,
  I9 as ButtonSpinner,
  Su as CANADIAN_PROVINCES,
  x9 as CONTENT_WIDTH_PX,
  M9 as Card,
  _7 as CardList,
  tl as CharacterCount,
  Fu as CheckboxInput,
  C7 as Collapsible,
  S7 as CompactField,
  v5 as CompactFieldContainer,
  R5 as CompactFieldHint,
  x5 as CompactFieldLabel,
  b5 as CompactValidationError,
  a3 as ConfirmationModal,
  L9 as DRAWER_Z_INDEX,
  v7 as DangerButtonTheme,
  Bu as DateInput,
  F7 as DateRangeInput,
  B7 as DateTimeInput,
  ze as DefaultButtonTheme,
  fh as DefaultPopoverItem,
  kg as Difference,
  Ff as DifferenceCalculator,
  Bf as DifferenceContainer,
  wg as DifferenceFormatter,
  x7 as DisabledButtonTheme,
  u6 as DrawerContent,
  g3 as DrawerFormSharedStyles,
  d6 as DrawerHeader,
  h6 as DrawerTitle,
  f6 as DrawerView,
  U7 as DrawingInput,
  I7 as DrawingView,
  Mr as EmptyValue,
  xn as FOCUS_WIDTH,
  ou as FieldContainer,
  bg as FieldGap,
  Qr as FieldHint,
  I5 as FieldLabel,
  Ya as FieldValue,
  za as FieldValueContainer,
  k7 as Fields,
  G7 as FileInput,
  K5 as FileUploadError,
  Va as FileUploadingView,
  Ja as FileView,
  R7 as FlatButton,
  g7 as Flier,
  Lg as FormFieldset,
  Pg as FormFieldsetHorizontalBar,
  fg as GroupedMultipleChoiceInput,
  oi as HOUR,
  Mg as HintContainer,
  Sa as INPUT_BREAKPOINT_WIDTH_PX,
  dt as INPUT_HEIGHT,
  ce as INPUT_MAX_WIDTH,
  Na as INPUT_MAX_WIDTH_PX,
  v9 as INPUT_MIN_WIDTH,
  O9 as INPUT_MIN_WIDTH_PX,
  ft as InfoTooltip,
  Hn as InputFocusTheme,
  el as InputLabel,
  w7 as InputWithLabel,
  cu as InputWithLabelComponent,
  v1 as LABEL_COLUMN_WIDTH_PX,
  ht as LABEL_MARGIN_RIGHT_PX,
  f1 as LineDifferenceType,
  X5 as LinkButton,
  P7 as LinkText,
  K1 as LoaderSpinner,
  Y5 as LoadingButtonTheme,
  ku as LocationAutocompleteInput,
  ii as MINUTE,
  R9 as MODAL_Z_INDEX,
  i6 as ManualTabBar,
  Gg as MapBoxContainer,
  t3 as Markdown,
  V7 as MarkdownInput,
  n3 as MarkdownSpan,
  Jd as MarkdownVariablePickerBuilder,
  s3 as Modal,
  i3 as ModalBody,
  o3 as ModalFooter,
  mg as MultipleChoiceInput,
  K7 as MultipleFileInput,
  M7 as MultipleFileViewContainer,
  Di as NavLinkStyles,
  Tg as NumberInput,
  pg as NumberInputV2,
  Eg as NumberInputWithStaticUnit,
  gg as NumberInputWithUnits,
  vc as NumberPill,
  Mi as Overlay,
  b9 as POPOVER_Z_INDEX,
  Ag as PhoneNumberInput,
  _g as PhotoInput,
  z7 as Popover,
  th as PopoverContent,
  al as PopoverContentCSS,
  Y7 as PopoverItem,
  nh as PopoverRoot,
  ch as PopoverTrigger,
  Cg as PriceInput,
  D7 as ProgressBar,
  Ng as RadioContainer,
  Ig as RadioInput,
  Sg as RadioLabel,
  sf as RadioTitle,
  hg as RootAdminBanner,
  Bn as RoundedButton,
  L7 as RoundedButtonDivider,
  O7 as SelectedButtonTheme,
  _3 as Separator,
  D9 as ShadowContainer,
  Rf as ShowLessButton,
  Dg as ShowMoreCard,
  bf as ShowMoreContainer,
  Og as SingleChoiceColorInput,
  vg as SingleChoiceFancyInput,
  yg as SingleChoiceIconInput,
  bn as SingleChoiceInput,
  l3 as StyledActiveNavLink,
  qu as StyledDateRangePicker,
  c3 as StyledDisabledNavLink,
  p3 as StyledDrawerBody,
  c6 as StyledDrawerContent,
  E3 as StyledDrawerFooter,
  ol as StyledDropzone,
  He as StyledInput,
  s6 as StyledOverlay,
  Xu as StyledSingleDatePicker,
  Qu as StyledSingleDatePickerWithDayNavigation,
  Oc as StyledTabBarItem,
  ja as SubmitButtonTheme,
  d3 as SummaryBar,
  h3 as SummaryBarItem,
  A3 as Switch,
  A7 as TOAST_Z_INDEX,
  m3 as TabBar,
  xc as TabBarItem,
  mf as TextAreaInput,
  gu as TextInput,
  T3 as ThemeProvider,
  ld as TimeInput,
  ad as TimeInputMode,
  xg as TimeRangeInput,
  t6 as TitledFigure,
  ll as ToggleBase,
  rh as ToggleButton,
  Rg as ToggleInput,
  ih as ToggleText,
  Ga as Tooltip,
  Fn as ValidationError,
  N7 as ViewField,
  S5 as ViewFieldContainer,
  Xa as abstractButtonStyles,
  dg as aiBannerTheme,
  rg as aiFeatureBadgeTheme,
  gh as baseBadgeStyles,
  Z7 as blackBadgeTheme,
  ng as blueAltBadgeTheme,
  X7 as blueBadgeTheme,
  j as borderRadius,
  We as boxShadow,
  ct as boxShadowStrong,
  y9 as boxShadowStronger,
  $n as breakpoints,
  P9 as cardStyle,
  sg as dangerBannerTheme,
  vu as detectCountryFromAddress,
  H7 as extractAddressValue,
  Qa as flatButtonStyle,
  wr as fromHHMMtoTs,
  kr as fromTsToHHMM,
  Xr as getChoiceDataAttributeProp,
  Zu as getScreenReaderInputMessage,
  eg as grayBadgeTheme,
  j7 as greenBadgeTheme,
  Ou as hasCanadianPostalCode,
  ig as infoBannerTheme,
  $g as isDifferenceObject,
  Hg as isDifferenceValue,
  so as mapCountryNameToCode,
  oo as mapStateNameToCode,
  lg as neutralBannerTheme,
  cg as noConnectionBannerTheme,
  Ia as overlay,
  tg as purpleBadgeTheme,
  ug as purpleBannerTheme,
  Q7 as redBadgeTheme,
  ti as roundedButtonStyle,
  hu as styledInputStyle,
  og as successBannerTheme,
  ho as timeFromTs,
  J7 as transparentBadgeTheme,
  Bg as useAutoSaveCleanUp,
  Fg as useAutoSaveState,
  Ug as useCountdown,
  Yf as useStopwatch,
  no as useTryAsync,
  ag as warningBannerTheme,
  q7 as yellowBadgeTheme
};
